const t = {
  ABN_COLUMN: "ABN",
  ABN_PLACEHOLDER: "Australian business number (ABN)",
  ACCEPT_BUTTON: "Accept",
  ACCOUNT_NUMBER_CONFIRM_DOES_NOT_MATCH:
    "The bank accounts entered do not match.",
  ACCOUNT_NUMBER_LABEL: "Account Number",
  ACCOUNT_NUMBER_PLACEHOLDER: "Beneficiary's Bank Account Number",
  ACTION_CANCEL: "Cancel Request",
  ACTION_CANCEL_HERO: "Do you want to cancel this payment request?",
  ACTION_CANCEL_INSTRUCTIONS:
    "Your customer will be notified that your payment request has been cancelled.",
  ACTION_CANCEL_NO: "No",
  ACTION_CANCEL_YES: "Yes, Cancel",
  ACTION_COLUMN: "Action",
  ACTION_COPY_LINK: "Copy Link",
  ACTION_COPY_LINK_CONFIRMED: "Copied",
  ACTION_MARK_PAID: "Mark as Paid",
  ACTION_RESEND_EMAIL_SUCCESS:
    "Your payment request has been resent to the updated email address.",
  ACTION_RESEND_MOBILE_SUCCESS:
    "Your payment request has been resent to the updated mobile.",
  ACTION_RESEND_REMIND: "Remind Customer",
  ACTION_RESEND_REQUEST: "Resend Request",
  ACTION_RESEND_SENT: "Sent",
  ACTION_RESEND_SUCCESS:
    "Your payment request has been resent to your customer.",
  ACTIVITY_COMPLETED_PAYMENTS: "Completed Payments",
  ACTIVITY_PAYMENTS_COLLECTED: "Payments Collected",
  ACTIVITY_PAYMENTS_DEPOSITED: "Payments Deposited",
  ACTIVITY_PAYMENTS_IN_PROGRESS: "Payments In Progress",
  ACTIVITY_PAYMENTS_REQUEST: "Payments Requested",
  ACTIVITY_SCHEDULED_PAYMENTS: "Scheduled Payments",
  ACTIVITY_TITLE: "\u003cb\u003eACTIVITY\u003c/b\u003e, IN THE LAST 30 DAYS",
  ADDITIONAL_INFORMATION_SECTION: "Additional Information",
  ADDRESS_LABEL: "Address",
  ADDRESS_PLACEHOLDER: "Address",
  ADD_BUTTON: "Add",
  ADD_CARD_BUTTON: "Add card for this payment",
  ADD_COMPANY_BUTTON: "Add New Company",
  ADD_COMPANY_WELCOME:
    "Welcome to ipaymy! Confirm your company details to get started",
  ADD_CUSTOMER_BUTTON: "Add Customer",
  ADD_EMPLOYEE: "ADD YOUR EMPLOYEE",
  ADD_EMPLOYEE_BUTTON: "Add Employee",
  ADD_EMPLOYEE_LABEL: "Add New Employee",
  ADD_LANDLORD_HERO: "ADD YOUR LANDLORD",
  ADD_MULTIPLE_EMPLOYEES: "Add Multiple Employees",
  ADD_MULTIPLE_SUPPLIERS_BUTTON: "Add Multiple Suppliers",
  ADD_NEW_CUSTOMER_BUTTON: "Add New Customer",
  ADD_NEW_CUSTOMER_HERO: "Add New Customer",
  ADD_NEW_SUPPLIER_BUTTON: "Add New Supplier",
  ADD_NEW_SUPPLIER_HERO: "Add New Supplier",
  ADD_PROPERTY_BUTTON: "Add Property",
  ADD_PROPERTY_LABEL: "Add New Property",
  ADD_SUPPLIER: "ADD YOUR SUPPLIER",
  ADMIN_BULK_UPLOAD_PAYMENT_FILE_SUCCESS: "Upload successfully!",
  ADMIN_EDIT_PAYEE_ERROR:
    "\u003cp\u003eThere was a problem with editing. Please try again.\u003c/p\u003e",
  ADMIN_EDIT_PAYEE_SUCCESS: "Edits saved.",
  ADMIN_MENU_ITEM: "Admin",
  ALERTS_MENU_ITEM: "My Alerts",
  ALREADY_PROCESSED_OR_DELETED_PAYMENT_ERROR:
    "Payment has been completed or deleted already",
  ALREADY_REFUNDED_OR_DELETED_PAYMENT_ERROR:
    "Payment has refunded or deleted already",
  AMEX_COMMON_FEE_LABEL: "Amex",
  AMEX_LABEL: "Amex",
  AMOUNT_DOES_NOT_MATCH_ITEMS_SUBTOTALS:
    "This amount doesn’t match your item subtotals, please check the item details or remove all selected items.",
  AMOUNT_EXCEED_ERROR: "This payment amount exceeds our maximum.",
  AMOUNT_LABEL: "Amount",
  APPLY_ALL_BUTTON: "Apply to All",
  APPLY_ALL_INSTRUCTIONS:
    "Enter note here if you want to apply the same note to all your suppliers.",
  APPROVAL_REQUEST: "Approval Request",
  AT_LEAST_ONE_PAYMENT_TYPE: "Please select at least one payment type.",
  AU_POSTAL_CODE_MAX_LENGTH_ERROR: "Please enter fewer than 4 characters.",
  AU_T1_DEADLINE:
    "If you make your payment before 5:00 PM AEST today, you will be able to settle your payment by the next business day.",
  BACK_BUTTON: "Back",
  BANK_ACCOUNT_HOLDER_COLUMN: "Bank Account Holder Name",
  BANK_ACCOUNT_HOLDER_LABEL: "Bank Account Holder Name",
  BANK_ACCOUNT_HOLDER_PLACEHOLDER: "Bank Account Holder Name",
  BANK_DETAILS_INSTRUCTIONS:
    "Please provide the bank account details you would like the funds to be deposited in. This must be a bank account in ",
  BANK_DETAILS_INSTRUCTIONS_AU: "Australia that accepts AUD.",
  BANK_DETAILS_INSTRUCTIONS_HK: "Hong Kong that accepts HKD.",
  BANK_DETAILS_INSTRUCTIONS_MY: "Malaysia that accepts RM.",
  BANK_DETAILS_INSTRUCTIONS_SG: "Singapore that accepts SGD.",
  BANK_DETAILS_SECTION: "Bank Details",
  BANK_LABEL: "Bank",
  BANK_NAME_LABEL: "Bank Name",
  BANK_PAYOUT_FEE_LABEL: "Fund Safeguarding",
  BANK_PAYOUT_FEE_TOOLTIP:
    "In compliance with the Payment Services Act 2019, this ensures your funds are protected and held in a segregated safeguarded account. The fund safeguarding applies to each payout instruction.",
  BANK_PLACEHOLDER: "Select Bank",
  BANK_RECIPIENT_GENERAL_ERROR:
    "Uh oh - something doesn't look right. Please check your recipient's bank details.",
  BANK_STATEMENT_ACCOUNT: "Account Number",
  BANK_STATEMENT_DATE: "Date of Statement",
  BANK_STATEMENT_HEADER: "Bank Statement",
  BANK_STATEMENT_INSTRUCTIONS:
    "Upload a recent copy of your bank statement (dated within the past 3 months). This bank account must belong to the company you are creating your Be Paid account for. The bank statement must include",
  BANK_STATEMENT_INSTRUCTIONS_EXTRA:
    "Please ensure your document includes the above information to avoid any delay in payouts",
  BANK_STATEMENT_MESSAGE:
    "Please upload a copy of your recent bank statement (within 30 days) to confirm the availability and source of funds. Your statement should include:",
  BANK_STATEMENT_MESSAGE_INT:
    "Please upload a copy of your recent bank statement (within the past 3 months) for your overseas receiving account. Your statement should include:",
  BANK_STATEMENT_NAME: "Your Name",
  BANK_STATEMENT_PURPOSE_LABEL:
    "Enter Payment Details and Upload Bank Statement",
  BETA_BADGE: "BETA",
  BE_PAID_CALENDAR_SUBTITLE: "Total Amount Received This Month",
  BE_PAID_CALENDAR_TITLE: "Payments Received",
  BE_PAID_LABEL: "Be Paid",
  BLOCKED_ADMIN_LOGIN_ERROR:
    "You cannot access this website, please contact us for support.",
  BLOCKED_ERROR:
    "There is a problem with successfully processing your card. Please contact your issuer for more information.",
  BLOCKED_USER_MYINFO_ERROR: "This account has been suspended.",
  BT_INTERNAL_TECHNICAL_ISSUE:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  BUSINESS_DESCRIPTION_LABEL: "Business Description",
  BUSINESS_DESCRIPTION_PLACEHOLDER: "Select Business Industry",
  BUSINESS_INDUSTRY_1: "Accounting/audit/consulting",
  BUSINESS_INDUSTRY_10: "Forestry \u0026 Logging ",
  BUSINESS_INDUSTRY_101: "Telecom service",
  BUSINESS_INDUSTRY_102: "A/C and heating contractor",
  BUSINESS_INDUSTRY_103: "Other building service",
  BUSINESS_INDUSTRY_104: "Metal service centre",
  BUSINESS_INDUSTRY_105: "Sanitation and speciality cleaning",
  BUSINESS_INDUSTRY_106: "Construction materials",
  BUSINESS_INDUSTRY_107: "Commercial equipment",
  BUSINESS_INDUSTRY_108: "Florist and flower supplies",
  BUSINESS_INDUSTRY_109: "Food and beverage",
  BUSINESS_INDUSTRY_11: "Government Bodies",
  BUSINESS_INDUSTRY_110: "Textiles",
  BUSINESS_INDUSTRY_111: "Hardware equipment and supplies",
  BUSINESS_INDUSTRY_112: "Industrial suppliers",
  BUSINESS_INDUSTRY_113: "Office and commercial furniture",
  BUSINESS_INDUSTRY_114: "Office supplies and stationary",
  BUSINESS_INDUSTRY_115: "Photography equipment",
  BUSINESS_INDUSTRY_116: "Plumbing and heating equipment",
  BUSINESS_INDUSTRY_117: "Medical devices and laboratory equipment",
  BUSINESS_INDUSTRY_12: "Hotel \u0026 Lodging",
  BUSINESS_INDUSTRY_13: "Information Technology",
  BUSINESS_INDUSTRY_14: "Legal \u0026 Judiciary",
  BUSINESS_INDUSTRY_15: "Logistics",
  BUSINESS_INDUSTRY_16: "Manufacturing",
  BUSINESS_INDUSTRY_17: "Media \u0026 Communications",
  BUSINESS_INDUSTRY_18: "Medical \u0026 Healthcare",
  BUSINESS_INDUSTRY_19: "Mining \u0026 Quarrying",
  BUSINESS_INDUSTRY_2: "Agriculture",
  BUSINESS_INDUSTRY_20: "Money Lending",
  BUSINESS_INDUSTRY_21: "Non-profit Organisation",
  BUSINESS_INDUSTRY_22: "Oil \u0026 Gas",
  BUSINESS_INDUSTRY_23: "Pawnshop",
  BUSINESS_INDUSTRY_24: "Professional Services Firm",
  BUSINESS_INDUSTRY_25: "Real Estate",
  BUSINESS_INDUSTRY_26: "Trading/retail/wholesale",
  BUSINESS_INDUSTRY_27: "Transportation",
  BUSINESS_INDUSTRY_28: "Utilities",
  BUSINESS_INDUSTRY_29: "Travel/tourism",
  BUSINESS_INDUSTRY_3: "Antiques \u0026 Artpiece",
  BUSINESS_INDUSTRY_30: "Unknown ",
  BUSINESS_INDUSTRY_31: "Others",
  BUSINESS_INDUSTRY_32: "Not Applicable",
  BUSINESS_INDUSTRY_33: "Telemarketing",
  BUSINESS_INDUSTRY_34: "Mortgage consulting service",
  BUSINESS_INDUSTRY_35: "Warranty service",
  BUSINESS_INDUSTRY_36: "Other marketing services",
  BUSINESS_INDUSTRY_37: "Other business services",
  BUSINESS_INDUSTRY_38: "Civic, fraternal or social associations",
  BUSINESS_INDUSTRY_39: "Charities or social services organizations",
  BUSINESS_INDUSTRY_4: "Banking/financial/insurance",
  BUSINESS_INDUSTRY_40: "Religious organizations",
  BUSINESS_INDUSTRY_41: "Country clubs",
  BUSINESS_INDUSTRY_42: "Political organizations",
  BUSINESS_INDUSTRY_43: "Other membership organizations",
  BUSINESS_INDUSTRY_44: "Personal services",
  BUSINESS_INDUSTRY_45: "Photography studio",
  BUSINESS_INDUSTRY_46: "Health and beauty spa",
  BUSINESS_INDUSTRY_47: "Salon or barber",
  BUSINESS_INDUSTRY_48: "Landscaping service",
  BUSINESS_INDUSTRY_49: "Massage parlor",
  BUSINESS_INDUSTRY_5: "Construction \u0026 Development",
  BUSINESS_INDUSTRY_50: "Counseling service",
  BUSINESS_INDUSTRY_51: "Health and wellness coaching",
  BUSINESS_INDUSTRY_52: "Laundry or cleaning service",
  BUSINESS_INDUSTRY_53: "Dating service",
  BUSINESS_INDUSTRY_54: "Other personal service",
  BUSINESS_INDUSTRY_55: "Ridesharing",
  BUSINESS_INDUSTRY_56: "Taxis and limos",
  BUSINESS_INDUSTRY_57: "Courier service",
  BUSINESS_INDUSTRY_58: "Parking lot",
  BUSINESS_INDUSTRY_59: "Freight forwarder",
  BUSINESS_INDUSTRY_6: "Education",
  BUSINESS_INDUSTRY_60: "Shipping or forwarding",
  BUSINESS_INDUSTRY_61: "Commuter transportation",
  BUSINESS_INDUSTRY_62: "Cruise line",
  BUSINESS_INDUSTRY_63: "Airline and air carrier",
  BUSINESS_INDUSTRY_64: "Other transportation service",
  BUSINESS_INDUSTRY_65: "Property rental",
  BUSINESS_INDUSTRY_66: "Hotel, inn or motel",
  BUSINESS_INDUSTRY_67: "Timeshare",
  BUSINESS_INDUSTRY_68: "Other travel and lodging",
  BUSINESS_INDUSTRY_7: "Engineering",
  BUSINESS_INDUSTRY_71: "Doctor and physicians",
  BUSINESS_INDUSTRY_72: "Optician and eyeglasses",
  BUSINESS_INDUSTRY_73: "Dentist and orthodontist",
  BUSINESS_INDUSTRY_74: "Chiropractor",
  BUSINESS_INDUSTRY_75: "Nursing or personal care facility",
  BUSINESS_INDUSTRY_76: "Hospital",
  BUSINESS_INDUSTRY_77: "Mental health service",
  BUSINESS_INDUSTRY_78: "Assisted living",
  BUSINESS_INDUSTRY_79: "Veterinary service",
  BUSINESS_INDUSTRY_8: "Entertainment \u0026 Recreation",
  BUSINESS_INDUSTRY_80: "Medical organization",
  BUSINESS_INDUSTRY_81: "Telemedicine and telehealth",
  BUSINESS_INDUSTRY_82: "Other medical services",
  BUSINESS_INDUSTRY_83: "Childcare service",
  BUSINESS_INDUSTRY_84: "College or university",
  BUSINESS_INDUSTRY_85: "Vocation or trade school",
  BUSINESS_INDUSTRY_86: "Elementary or secondary school",
  BUSINESS_INDUSTRY_87: "Other educational service",
  BUSINESS_INDUSTRY_89: "Event ticketing",
  BUSINESS_INDUSTRY_9: "Food \u0026 Beverage ",
  BUSINESS_INDUSTRY_90: "Tourist attraction",
  BUSINESS_INDUSTRY_91: "Recreational camp",
  BUSINESS_INDUSTRY_92: "Musician, band, orchestra",
  BUSINESS_INDUSTRY_93: "Amusement park, carnival or circus",
  BUSINESS_INDUSTRY_94: "Movie theatre",
  BUSINESS_INDUSTRY_95: "Other entertainment and recreation",
  BUSINESS_INDUSTRY_97: "General contractor",
  BUSINESS_INDUSTRY_98: "Electrical contractor",
  BUSINESS_INDUSTRY_99: "Carpentry contractor",
  BUSINESS_INDUSTRY_GROUP_1: "Retail",
  BUSINESS_INDUSTRY_GROUP_10: "Medical Services",
  BUSINESS_INDUSTRY_GROUP_11: "Entertainment and Recreation",
  BUSINESS_INDUSTRY_GROUP_12: "Building Services",
  BUSINESS_INDUSTRY_GROUP_2: "Professional Services",
  BUSINESS_INDUSTRY_GROUP_3: "Membership Organizations",
  BUSINESS_INDUSTRY_GROUP_4: "Transportation",
  BUSINESS_INDUSTRY_GROUP_5: "Travel and Lodging",
  BUSINESS_INDUSTRY_GROUP_6: "Education",
  BUSINESS_INDUSTRY_GROUP_7: "Digital Products",
  BUSINESS_INDUSTRY_GROUP_8: "Food and Drinks",
  BUSINESS_INDUSTRY_PLACEHOLDER: "Please Select Your Industry",
  BUSINESS_OCCUPATION_1: "Chiropractor",
  BUSINESS_OCCUPATION_10: "Therapist",
  BUSINESS_OCCUPATION_11: "Veterinarian",
  BUSINESS_OCCUPATION_12: "Health Technologist or Technician",
  BUSINESS_OCCUPATION_13:
    "Other Healthcare Practitioners and Technical Occupation",
  BUSINESS_OCCUPATION_14: "Nursing, Psychiatric, or Home Health Aide",
  BUSINESS_OCCUPATION_15:
    "Occupational and Physical Therapist Assistant or Aide",
  BUSINESS_OCCUPATION_16: "Other Healthcare Support Occupation",
  BUSINESS_OCCUPATION_17: "Chief Executive",
  BUSINESS_OCCUPATION_18: "General and Operations Manager",
  BUSINESS_OCCUPATION_19:
    "Advertising, Marketing, Promotions, Public Relations, and Sales Manager",
  BUSINESS_OCCUPATION_2: "Dentist",
  BUSINESS_OCCUPATION_20:
    "Operations Specialties Manager (e.g., IT or HR Manager)",
  BUSINESS_OCCUPATION_21: "Construction Manager",
  BUSINESS_OCCUPATION_22: "Engineering Manager",
  BUSINESS_OCCUPATION_23: "Accountant, Auditor",
  BUSINESS_OCCUPATION_24: "Business Operations or Financial Specialist",
  BUSINESS_OCCUPATION_25: "Business Owner",
  BUSINESS_OCCUPATION_26:
    "Other Business, Executive, Management, Financial Occupation",
  BUSINESS_OCCUPATION_27: "Architect, Surveyor, or Cartographer",
  BUSINESS_OCCUPATION_28: "Engineer",
  BUSINESS_OCCUPATION_29: "Other Architecture and Engineering Occupation",
  BUSINESS_OCCUPATION_3: "Dietitian or Nutritionist",
  BUSINESS_OCCUPATION_30: "Postsecondary Teacher (e.g., College Professor)",
  BUSINESS_OCCUPATION_31:
    "Primary, Secondary, or Special Education School Teacher",
  BUSINESS_OCCUPATION_32: "Other Teacher or Instructor",
  BUSINESS_OCCUPATION_33: "Other Education, Training, and Library Occupation",
  BUSINESS_OCCUPATION_34:
    "Arts, Design, Entertainment, Sports, and Media Occupations",
  BUSINESS_OCCUPATION_35: "Computer Specialist, Mathematical Science",
  BUSINESS_OCCUPATION_36:
    "Counselor, Social Worker, or Other Community and Social Service Specialist",
  BUSINESS_OCCUPATION_37: "Lawyer, Judge",
  BUSINESS_OCCUPATION_38:
    "Life Scientist (e.g., Animal, Food, Soil, or Biological Scientist, Zoologist)",
  BUSINESS_OCCUPATION_39:
    "Physical Scientist (e.g., Astronomer, Physicist, Chemist, Hydrologist)",
  BUSINESS_OCCUPATION_4: "Optometrist",
  BUSINESS_OCCUPATION_40:
    "Religious Worker (e.g., Clergy, Director of Religious Activities or Education)",
  BUSINESS_OCCUPATION_41: "Social Scientist and Related Worker",
  BUSINESS_OCCUPATION_42: "Other Professional Occupation",
  BUSINESS_OCCUPATION_43: "Supervisor of Administrative Support Workers",
  BUSINESS_OCCUPATION_44: "Financial Clerk",
  BUSINESS_OCCUPATION_45: "Secretary or Administrative Assistant",
  BUSINESS_OCCUPATION_46:
    "Material Recording, Scheduling, and Dispatching Worker",
  BUSINESS_OCCUPATION_47: "Other Office and Administrative Support Occupation",
  BUSINESS_OCCUPATION_48:
    "Protective Service (e.g., Fire Fighting, Police Officer, Correctional Officer)",
  BUSINESS_OCCUPATION_49: "Chef or Head Cook",
  BUSINESS_OCCUPATION_5: "Pharmacist",
  BUSINESS_OCCUPATION_50: "Cook or Food Preparation Worker",
  BUSINESS_OCCUPATION_51:
    "Food and Beverage Serving Worker (e.g., Bartender, Waiter, Waitress)",
  BUSINESS_OCCUPATION_52: "Building and Grounds Cleaning and Maintenance",
  BUSINESS_OCCUPATION_53:
    "Personal Care and Service (e.g., Hairdresser, Flight Attendant, Concierge)",
  BUSINESS_OCCUPATION_54: "Sales Supervisor, Retail Sales",
  BUSINESS_OCCUPATION_55: "Retail Sales Worker",
  BUSINESS_OCCUPATION_56: "Insurance Sales Agent",
  BUSINESS_OCCUPATION_57: "Sales Representative",
  BUSINESS_OCCUPATION_58: "Real Estate Sales Agent",
  BUSINESS_OCCUPATION_59: "Other Services Occupation",
  BUSINESS_OCCUPATION_6: "Physician",
  BUSINESS_OCCUPATION_60:
    "Construction and Extraction (e.g., Construction Laborer, Electrician)",
  BUSINESS_OCCUPATION_61: "Farming, Fishing, and Forestry",
  BUSINESS_OCCUPATION_62: "Installation, Maintenance, and Repair",
  BUSINESS_OCCUPATION_63: "Production Occupations",
  BUSINESS_OCCUPATION_64:
    "Other Agriculture, Maintenance, Repair, and Skilled Crafts Occupation",
  BUSINESS_OCCUPATION_65: "Aircraft Pilot or Flight Engineer",
  BUSINESS_OCCUPATION_66:
    "Motor Vehicle Operator (e.g., Ambulance, Bus, Taxi, or Truck Driver)",
  BUSINESS_OCCUPATION_67: "Other Transportation Occupation",
  BUSINESS_OCCUPATION_68: "Military",
  BUSINESS_OCCUPATION_69: "Homemaker",
  BUSINESS_OCCUPATION_7: "Physician Assistant",
  BUSINESS_OCCUPATION_70: "Other Occupation",
  BUSINESS_OCCUPATION_71: "Don't Know",
  BUSINESS_OCCUPATION_72: "Not Applicable",
  BUSINESS_OCCUPATION_8: "Podiatrist",
  BUSINESS_OCCUPATION_9: "Registered Nurse",
  BUSINESS_TYPE_1: "Association",
  BUSINESS_TYPE_10: "General Partnership",
  BUSINESS_TYPE_11: "Government Bodies",
  BUSINESS_TYPE_12: "Incorporated",
  BUSINESS_TYPE_13: "Limited",
  BUSINESS_TYPE_14: "Limited Liability Company",
  BUSINESS_TYPE_15: "Limited Liability Partnership",
  BUSINESS_TYPE_16: "Limited Partnership",
  BUSINESS_TYPE_17: "Local Company",
  BUSINESS_TYPE_18: "Local Entity Not Registered With Local Registrar",
  BUSINESS_TYPE_19: "Local Private Company",
  BUSINESS_TYPE_2: "Banks",
  BUSINESS_TYPE_20: "Local Public Company",
  BUSINESS_TYPE_21: "Management Corporations",
  BUSINESS_TYPE_22: "Financial Institution",
  BUSINESS_TYPE_23: "Non-for-profit Organisation",
  BUSINESS_TYPE_24: "Organ Of State",
  BUSINESS_TYPE_25: "Partnership",
  BUSINESS_TYPE_26: "Private Company Limited By Shares",
  BUSINESS_TYPE_27: "Proprietary Limited",
  BUSINESS_TYPE_28: "Public Company Limited By Guarantee",
  BUSINESS_TYPE_29: "Public Company Limited By Shares",
  BUSINESS_TYPE_3: "Charity",
  BUSINESS_TYPE_30: "Public Limited Company",
  BUSINESS_TYPE_31: "Sole-proprietorship",
  BUSINESS_TYPE_32: "Trust",
  BUSINESS_TYPE_33: "Variable Capital Company",
  BUSINESS_TYPE_34: "Others",
  BUSINESS_TYPE_35: "Unknown",
  BUSINESS_TYPE_4: "Club",
  BUSINESS_TYPE_5: "Exempt Private Company Limited By Shares",
  BUSINESS_TYPE_6: "Foreign Branch",
  BUSINESS_TYPE_7: "Foreign Company",
  BUSINESS_TYPE_8: "Foreign Entity Not Registered With Acra",
  BUSINESS_TYPE_9: "Funds",
  BUSINESS_TYPE_LABEL: "Type of Business",
  CALCULATE_PAYMENT_AMOUNT: "Calculate payment amount",
  CALCULATING_PAYMENT_AMOUNT: "Calculating payment amount",
  CALENDAR_CHARGE_DATE_LEGEND:
    "Charge Date: Your card will be charged on this day",
  CALENDAR_CURRENT_PAYOUT_DATE_LEGEND: "Current Payout Date",
  CALENDAR_DUE_DATE_LEGEND:
    "Due Date: the day your customer needs to make a payment by",
  CALENDAR_HOLIDAY_LEGEND: "Public Holiday",
  CALENDAR_PAYOUT_DATE_LEGEND:
    "Payout Date: Your recipient will receive the payment on this day",
  CALENDAR_SELECT_DATE_ERROR: "Please select a date",
  CANCELLED: "Cancelled",
  CANCELLED_DUE_TO_DELETED_CARD:
    "This payment has been cancelled because the card associated with it has been deleted.",
  CANCELLED_DUE_TO_DELETED_PROPERTY:
    "This payment has been cancelled because the associated property has been deleted",
  CANCELLED_DUE_TO_DELETED_SCHEDULE:
    "This payment has been cancelled by user request",
  CANCEL_BUTTON: "Cancel",
  CANNOT_ACCESS_CRYPTO_PAYMENT:
    "Pay by crypto is not available for now, please try again later!",
  CANNOT_ADD_LATE_PAYMENT_REMEDIATION_AND_INSTALLMENT_PLAN_IN_A_PAYMENT_REQUEST:
    "Select either an installment plan or the late payment fee.",
  CANNOT_APPLY_COUPON_ERROR: "Invalid coupon code.",
  CARD_ADD_LABEL: "Add a card to pay",
  CARD_BRAND_AMEX_LABEL: "Amex",
  CARD_BRAND_CHINA_UNIONPAY_LABEL: "China UnionPay",
  CARD_BRAND_MASTERCARD_LABEL: "Mastercard",
  CARD_BRAND_VISA_AND_MASTER_LABEL: "Visa and Mastercard",
  CARD_BRAND_VISA_LABEL: "Visa",
  CARD_CONFIRMATION_CHECKBOX:
    "I agree to the \u003ca\u003eterms of service\u003c/a\u003e and confirm that the payment amount and all payment details are correct.",
  CARD_CONFIRMATION_CHECKBOX_WALLEX:
    "I agree to the \u003ca\u003eterms of service\u003c/a\u003e and confirm that the payment amount and all payment details are correct, and I understand my payment will arrive by",
  CARD_CVC_LABEL: "CVC/CVV",
  CARD_CVC_PLACEHOLDER: "CVC/CVV",
  CARD_DETAILS_HEADING: "Card Details",
  CARD_ENCRYPTED_MESSAGE: "The card details you are entering are encrypted.",
  CARD_EXPIRED: "Please use a card with a valid expiry date",
  CARD_EXPIRED_ERROR: "Please use a card with a valid expiry date",
  CARD_EXPIRY_LABEL: "Expiry date",
  CARD_EXPIRY_PLACEHOLDER: "MM/YY",
  CARD_IMAGE_EXPIRY: "exp date",
  CARD_IMAGE_HOLDER: "CARDHOLDER NAME",
  CARD_IMAGE_NUMBER: "card number",
  CARD_IMAGE_YOUR_NAME: "YOUR NAME",
  CARD_INFORMATION_DESCRIPTION:
    "Please enter your card details below. All transactions are secure and encrypted.",
  CARD_INFORMATION_HEADING: "Card Information",
  CARD_LICENSE_FEE_NOTE: "License fee amount depends on credit card used.",
  CARD_NAME_PLACEHOLDER: "Cardholder name",
  CARD_NUMBER_LABEL: "Card number",
  CARD_NUMBER_PLACEHOLDER: "1234 1234 1234 1234",
  CARD_PAY_BUTTON: "Pay",
  CARD_REAUTHORIZED_MESSAGE:
    "Don’t see your card? Your card needs to be reauthorized to send a payment to a recipient in this country.",
  CARD_RECORDS_NOTE:
    'This is the description that will appear on your credit card statement. This will also by the note displayed in the "Description" field in the dashboard and payment details.',
  CARD_RECORDS_PLACEHOLDER: "Max 22 characters",
  CARD_RECORDS_TOOLTIP:
    'This is an internal note for your records about the purpose of this payment. This will display as the "Description" of your payment in the dashboard and payment details.',
  CARD_SAVE_CHECKBOX: "Save my information for future payments",
  CARD_SELECTED_LABEL: "Card Selected",
  CARD_SELECTED_PLACEHOLDER: "Select Card",
  CARD_SELECTED_SECTION: "Card Selected",
  CARD_SELECT_LABEL: "Select a card to pay",
  CARD_SLIDER_ADD_INSTRUCTIONS: "CLICK HERE TO ADD A NEW CARD",
  CARD_SLIDER_AUTHORIZED_TOOLTIP:
    "This card has been authorized to make payments to recipients in this country.",
  CARD_SLIDER_BUTTON: "Edit Details",
  CARD_TOTAL_LABEL: "Total",
  CARD_WAS_DELETED:
    "This card is no longer available. Please select another card.",
  CHANGE_PASSWORD_CONFIRM: "Confirm new password",
  CHANGE_PASSWORD_CONFIRM_PLACEHOLDER: "Please enter your new password again",
  CHANGE_PASSWORD_HERO: "CHANGE PASSWORD",
  CHANGE_PASSWORD_NEW: "New password",
  CHANGE_PASSWORD_NEW_PLACEHOLDER: "Please enter your new password",
  CHANGE_PASSWORD_OLD: "Old password",
  CHANGE_PASSWORD_OLD_PLACEHOLDER: "Please enter your old password",
  CHANGE_PASSWORD_SUCCESS: "Updated",
  CHARACTER_LIMIT_60: "File name should not be more than 60 characters.",
  CHECKBOX_SELECT_ALL_LABEL: "Select All",
  CHECKOUT_GENERAL_ISSUE:
    "There appears to be a technical issue with your payment request. Please try again or contact us at \u003ca\u003esupport@ipaymy.com\u003c/a\u003e.",
  CHECK_SPAM:
    "Not getting your email? Check your spam/junk folder, click “Resend email” or ",
  CITY_LABEL: "City",
  CITY_PLACEHOLDER: "City",
  CKO_ERROR_3DS_MALFUNCTION:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_3DS_NOT_CONFIGURED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_3DS_NOT_ENABLED_FOR_CARD:
    "Payments made on this card are not supported on ipaymy. You may contact us for more information.",
  CKO_ERROR_3DS_NOT_SUPPORTED:
    "Payments made on this card are not supported on ipaymy. You may contact us for more information.",
  CKO_ERROR_3DS_PAYMENT_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_3DS_VERSION_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_3DS_VERSION_NOT_SUPPORTED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_ADDRESS_INVALID:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  CKO_ERROR_AMOUNT_EXCEEDS_BALANCE:
    "Payment failed due to insufficient credit. You may have reached the maximum credit limit on this credit card. Please adjust the payment amount or use another credit card.",
  CKO_ERROR_AMOUNT_INVALID:
    "The transaction cannot be authorized. Please try a different card or contact your issuer for more information.",
  CKO_ERROR_API_CALLS_QUOTA_EXCEEDED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_BILLING_DESCRIPTOR_CITY_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_BILLING_DESCRIPTOR_CITY_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_BILLING_DESCRIPTOR_NAME_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_BILLING_DESCRIPTOR_NAME_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_BUSINESS_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_BUSINESS_SETTINGS_MISSING:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_CAPTURE_VALUE_GREATER_THAN_AUTHORIZED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_CAPTURE_VALUE_GREATER_THAN_REMAINING_AUTHORIZED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_CARD_AUTHORIZATION_FAILED:
    "The transaction cannot be authorized. Please try a different card or contact your issuer for more information.",
  CKO_ERROR_CARD_DISABLED:
    "The transaction cannot be authorized. Please try a different card or contact your issuer for more information.",
  CKO_ERROR_CARD_EXPIRED:
    "The card’s expiration is incorrect. Check the expiration date or use a different card.",
  CKO_ERROR_CARD_EXPIRY_MONTH_INVALID:
    "The card’s expiration is incorrect. Check the expiration date or use a different card.",
  CKO_ERROR_CARD_EXPIRY_MONTH_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_CARD_EXPIRY_YEAR_INVALID:
    "The card’s expiration is incorrect. Check the expiration date or use a different card.",
  CKO_ERROR_CARD_EXPIRY_YEAR_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_CARD_HOLDER_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_CARD_NOT_FOUND:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_CARD_NUMBER_INVALID:
    "The card number is incorrect. Check the card’s number or use a different card.",
  CKO_ERROR_CARD_NUMBER_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_CHANNEL_DETAILS_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_CHANNEL_URL_MISSING:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_CHARGE_DETAILS_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_CITY_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_COUNTRY_ADDRESS_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_COUNTRY_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_COUNTRY_PHONE_CODE_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_COUNTRY_PHONE_CODE_LENGTH_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_CURRENCY_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_CURRENCY_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_CUSTOMER_ALREADY_EXISTS:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_CUSTOMER_EMAIL_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_CUSTOMER_ID_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_CUSTOMER_MISMATCH:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_CUSTOMER_NOT_FOUND:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_CUSTOMER_NUMBER_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_CUSTOMER_PLAN_EDIT_FAILED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_CUSTOMER_PLAN_ID_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_CVV_INVALID:
    "The card’s CVC/CVV is incorrect. Check the card’s security code or use a different card.",
  CKO_ERROR_DO_NOT_HONOR:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  CKO_ERROR_EMAIL_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_EMAIL_IN_USE:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_EMAIL_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_ENDPOINT_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_EXPIRY_DATE_FORMAT_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_FAIL_URL_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_FIRST_NAME_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_IP_ADDRESS_INVALID:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  CKO_ERROR_ISSUER_NETWORK_UNAVAILABLE:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  CKO_ERROR_LAST_NAME_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_METADATA_KEY_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_PARAMETER_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_PASSWORD_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_PAYMENTS_NOT_SUPPORTED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_PAYMENT_EXPIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_PAYMENT_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_PAYMENT_METHOD_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_PAYMENT_METHOD_NOT_SUPPORTED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_PAYMENT_SOURCE_DOES_NOT_EXIST:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_PAYMENT_SOURCE_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_PAYMENT_TYPE_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_PHONE_NUMBER_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_PHONE_NUMBER_LENGTH_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_PREVIOUS_PAYMENT_ID_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_PROCESSING_ERROR:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_PROCESSING_KEY_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_PROCESSING_VALUE_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_RECIPIENT_ACCOUNT_NUMBER_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_RECIPIENT_ACCOUNT_NUMBER_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_RECIPIENT_DOB_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_RECIPIENT_DOB_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_RECIPIENT_LAST_NAME_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_RECIPIENT_ZIP_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_RECIPIENT_ZIP_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_RECURRING_PLAN_EXISTS:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_RECURRING_PLAN_NOT_EXIST:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_RECURRING_PLAN_REMOVAL_FAILED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_REFUNDS_NOT_SUPPORTED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_REQUEST_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_REQUEST_JSON_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_RISK_ENABLED_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_SERVER_API_NOT_ALLOWED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_SERVICE_UNAVAILABLE:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_SOURCE_EMAIL_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_SOURCE_EMAIL_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_SOURCE_ID_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_SOURCE_ID_OR_EMAIL_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_SOURCE_ID_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_SOURCE_ID_UNKNOWN:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_SOURCE_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_SOURCE_OR_DESTINATION_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_SOURCE_TOKEN_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_SOURCE_TOKEN_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_SOURCE_TOKEN_TYPE_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_SOURCE_TOKEN_TYPE_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_SOURCE_TYPE_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_SUCCESS_URL_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_TOKEN_EXPIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_TOKEN_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_TOKEN_IN_USE:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_TOKEN_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_TOKEN_TYPE_REQUIRED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_TOKEN_USED:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_VOID_AMOUNT_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_WALLET_ID_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_ERROR_ZIP_INVALID:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CKO_INTERNAL_TECHNICAL_ISSUE:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  CLOSE_ACCOUNT_REASON_1: "I want to register a new Fetch account.",
  CLOSE_ACCOUNT_REASON_2: "I'm not willing to pay to use the app.",
  CLOSE_ACCOUNT_REASON_3: "It was difficult to get support when I needed help.",
  CLOSE_ACCOUNT_REASON_4: "I'm using another app instead.",
  CLOSE_ACCOUNT_REASON_5: "The app was difficult to use.",
  CLOSE_ACCOUNT_REASON_6: "The app was different from what I'd expected.",
  CLOSE_ACCOUNT_REASON_7: "The app didn't help me much with getting paid.",
  CLOSE_ACCOUNT_REASON_8: "I don't need to issue invoices anymore.",
  CLOSE_ACCOUNT_REASON_9: "Other",
  CLOSE_BUTTON: "Close",
  COMING_SOON: "Coming Soon",
  COMMENT_HELP_COMPANY_REQUEST:
    "You may use ipaymy immediately after you submit the New Company listing request, though please note that while the listing is being approved, any payouts will be held. ipaymy will notify you once the listing is approved, and this will usually be no later than 1 business day.",
  COMPANIES_HERO: "MY COMPANIES",
  COMPANIES_INSTRUCTIONS:
    "Here are your registered companies. Have a new one?{br}Click “Add New Company” to add it.",
  COMPANIES_MENU_ITEM: "Companies",
  COMPANY_ABN_NOT_FOUND:
    "Company or ABN not found or listed? Find it \u003ca\u003ehere\u003c/a\u003e or simply request listing approval \u003cb\u003ehere\u003c/b\u003e",
  COMPANY_ADDRESS_1_PLACEHOLDER: "Company Address Line 1",
  COMPANY_ADDRESS_2_PLACEHOLDER: "Company Address Line 2",
  COMPANY_ADDRESS_LABEL: "Company Address",
  COMPANY_ALREADY_EXISTS_ERROR: "This company already exists.",
  COMPANY_CRN_NOT_FOUND:
    "Company or CRN not found or listed? Find it \u003ca\u003ehere\u003c/a\u003e or simply request listing approval \u003cb\u003ehere\u003c/b\u003e",
  COMPANY_EMAIL_PLACEHOLDER: "Company Email Address",
  COMPANY_EXISTED:
    "This company already exists. Please contact your administrator.",
  COMPANY_LOCATION_LABEL: "Where is your company based in?",
  COMPANY_NAME_COLUMN: "Company Name",
  COMPANY_NAME_CONFIRMATION_LABEL: "Company Name Confirmation",
  COMPANY_NAME_LABEL: "Company Name",
  COMPANY_NAME_PLACEHOLDER: "Company Name",
  COMPANY_REGISTRATION_ERROR: "Please enter your company registration number",
  COMPANY_REGISTRATION_PLACEHOLDER: "Company Registration Number",
  COMPANY_SEARCH_LABEL: "Supplier company",
  COMPANY_SEARCH_NAME_PLACEHOLDER: "Search company name or registration number",
  COMPANY_SEARCH_PLACEHOLDER: "Enter company name or number...",
  COMPANY_SECTION: "Company",
  COMPANY_TELL_MORE_INSTRUCTIONS: "Tell us a bit more about your company",
  COMPANY_UEN_NOT_FOUND:
    "Company or UEN not found or listed? Find it \u003ca\u003ehere\u003c/a\u003e or simply request listing approval \u003cb\u003ehere\u003c/b\u003e",
  COMPANY_WELCOME_BE_LISTED: "Confirm your company details to be listed",
  COMPLETE_PAYMENT_DESCRIPTION:
    "Review the details and complete your payments.",
  COMPLETE_PAYMENT_HERO: "COMPLETE YOUR {render} PAYMENT",
  CONFIRM_ACCOUNT_NUMBER_LABEL: "Confirm Account Number",
  CONFIRM_ACCOUNT_NUMBER_PLACEHOLDER: "Confirm Account Number",
  CONFIRM_BANK_POLICY_LABEL:
    "We recommend confirming the bank details relevant to your policy with your insurance provider.",
  CONFIRM_BUTTON: "Confirm",
  CONFIRM_EMAIL_LABEL: "Confirm Email",
  CONFIRM_EMAIL_PLACEHOLDER: "Confirm Email",
  CONFIRM_PASSWORD_ERROR: "Confirm Password does not match password",
  CONFIRM_PASSWORD_PLACEHOLDER: "Confirm Password",
  CONFIRM_SEND_BUTTON: "Confirm and Send",
  CONFIRM_SEND_HERO: "CONFIRM AND SEND",
  CONTACT_SUPPORT: "Contact Support",
  COUNTRY_1: "Singapore",
  COUNTRY_10: "Vietnam",
  COUNTRY_100: "Iraq",
  COUNTRY_101: "Ireland",
  COUNTRY_102: "Isle of Man",
  COUNTRY_103: "Israel",
  COUNTRY_104: "Italy",
  COUNTRY_105: "Ivory Coast",
  COUNTRY_106: "Jamaica",
  COUNTRY_107: "Japan",
  COUNTRY_108: "Jersey",
  COUNTRY_109: "Jordan",
  COUNTRY_11: "Antarctica",
  COUNTRY_110: "Kazakhstan",
  COUNTRY_111: "Kenya",
  COUNTRY_112: "Kiribati",
  COUNTRY_113: "Kosovo",
  COUNTRY_114: "Kuwait",
  COUNTRY_115: "Kyrgyzstan",
  COUNTRY_116: "Laos",
  COUNTRY_117: "Latvia",
  COUNTRY_118: "Lebanon",
  COUNTRY_119: "Lesotho",
  COUNTRY_12: "Antigua and Barbuda",
  COUNTRY_120: "Liberia",
  COUNTRY_121: "Libya",
  COUNTRY_122: "Liechtenstein",
  COUNTRY_123: "Lithuania",
  COUNTRY_124: "Luxembourg",
  COUNTRY_125: "Macau",
  COUNTRY_126: "Macedonia",
  COUNTRY_127: "Madagascar",
  COUNTRY_128: "Malawi",
  COUNTRY_129: "Maldives",
  COUNTRY_13: "Argentina",
  COUNTRY_130: "Mali",
  COUNTRY_131: "Malta",
  COUNTRY_132: "Marshall Islands",
  COUNTRY_133: "Mauritania",
  COUNTRY_134: "Mauritius",
  COUNTRY_135: "Mayotte",
  COUNTRY_136: "Mexico",
  COUNTRY_137: "Micronesia",
  COUNTRY_138: "Moldova",
  COUNTRY_139: "Monaco",
  COUNTRY_14: "Armenia",
  COUNTRY_140: "Mongolia",
  COUNTRY_141: "Montenegro",
  COUNTRY_142: "Montserrat",
  COUNTRY_143: "Morocco",
  COUNTRY_144: "Mozambique",
  COUNTRY_145: "Myanmar",
  COUNTRY_146: "Namibia",
  COUNTRY_147: "Nauru",
  COUNTRY_148: "Nepal",
  COUNTRY_149: "Netherlands",
  COUNTRY_15: "Aruba",
  COUNTRY_150: "Netherlands Antilles",
  COUNTRY_151: "New Caledonia",
  COUNTRY_152: "New Zealand",
  COUNTRY_153: "Nicaragua",
  COUNTRY_154: "Niger",
  COUNTRY_155: "Nigeria",
  COUNTRY_156: "Niue",
  COUNTRY_157: "North Korea",
  COUNTRY_158: "Northern Mariana Islands",
  COUNTRY_159: "Norway",
  COUNTRY_16: "Australia",
  COUNTRY_160: "Oman",
  COUNTRY_161: "Pakistan",
  COUNTRY_162: "Palau",
  COUNTRY_163: "Palestine",
  COUNTRY_164: "Panama",
  COUNTRY_165: "Papua New Guinea",
  COUNTRY_166: "Paraguay",
  COUNTRY_167: "Peru",
  COUNTRY_168: "Philippines",
  COUNTRY_169: "Pitcairn",
  COUNTRY_17: "Austria",
  COUNTRY_170: "Poland",
  COUNTRY_171: "Portugal",
  COUNTRY_172: "Puerto Rico",
  COUNTRY_173: "Qatar",
  COUNTRY_174: "Republic of the Congo",
  COUNTRY_175: "Reunion",
  COUNTRY_176: "Romania",
  COUNTRY_177: "Russia",
  COUNTRY_178: "Rwanda",
  COUNTRY_179: "Saint Barthelemy",
  COUNTRY_18: "Azerbaijan",
  COUNTRY_180: "Saint Helena",
  COUNTRY_181: "Saint Kitts and Nevis",
  COUNTRY_182: "Saint Lucia",
  COUNTRY_183: "Saint Martin",
  COUNTRY_184: "Saint Pierre and Miquelon",
  COUNTRY_185: "Saint Vincent and the Grenadines",
  COUNTRY_186: "Samoa",
  COUNTRY_187: "San Marino",
  COUNTRY_188: "Sao Tome and Principe",
  COUNTRY_189: "Saudi Arabia",
  COUNTRY_19: "Bahamas",
  COUNTRY_190: "Senegal",
  COUNTRY_191: "Serbia",
  COUNTRY_192: "Seychelles",
  COUNTRY_193: "Sierra Leone",
  COUNTRY_194: "Sint Maarten",
  COUNTRY_195: "Slovakia",
  COUNTRY_196: "Slovenia",
  COUNTRY_197: "Solomon Islands",
  COUNTRY_198: "Somalia",
  COUNTRY_199: "South Africa",
  COUNTRY_2: "Malaysia",
  COUNTRY_20: "Bahrain",
  COUNTRY_200: "South Korea",
  COUNTRY_201: "South Sudan",
  COUNTRY_202: "Spain",
  COUNTRY_203: "Sri Lanka",
  COUNTRY_204: "Sudan",
  COUNTRY_205: "Suriname",
  COUNTRY_206: "Svalbard and Jan Mayen",
  COUNTRY_207: "Swaziland",
  COUNTRY_208: "Sweden",
  COUNTRY_209: "Switzerland",
  COUNTRY_21: "Bangladesh",
  COUNTRY_210: "Syria",
  COUNTRY_211: "Taiwan",
  COUNTRY_212: "Tajikistan",
  COUNTRY_213: "Tanzania",
  COUNTRY_214: "Thailand",
  COUNTRY_215: "Togo",
  COUNTRY_216: "Tokelau",
  COUNTRY_217: "Tonga",
  COUNTRY_218: "Trinidad and Tobago",
  COUNTRY_219: "Tunisia",
  COUNTRY_22: "Barbados",
  COUNTRY_220: "Turkey",
  COUNTRY_221: "Turkmenistan",
  COUNTRY_222: "Turks and Caicos Islands",
  COUNTRY_223: "Tuvalu",
  COUNTRY_224: "U.S. Virgin Islands",
  COUNTRY_225: "Uganda",
  COUNTRY_226: "Ukraine",
  COUNTRY_227: "United Arab Emirates",
  COUNTRY_228: "United Kingdom",
  COUNTRY_229: "United States",
  COUNTRY_23: "Belarus",
  COUNTRY_230: "Uruguay",
  COUNTRY_231: "Uzbekistan",
  COUNTRY_232: "Vanuatu",
  COUNTRY_233: "Vatican",
  COUNTRY_234: "Venezuela",
  COUNTRY_235: "Wallis and Futuna",
  COUNTRY_236: "Western Sahara",
  COUNTRY_237: "Yemen",
  COUNTRY_238: "Zambia",
  COUNTRY_239: "Zimbabwe",
  COUNTRY_24: "Belgium",
  COUNTRY_240: "Afghanistan",
  COUNTRY_25: "Belize",
  COUNTRY_26: "Benin",
  COUNTRY_27: "Bermuda",
  COUNTRY_28: "Bhutan",
  COUNTRY_29: "Bolivia",
  COUNTRY_3: "Hong Kong",
  COUNTRY_30: "Bosnia and Herzegovina",
  COUNTRY_31: "Botswana",
  COUNTRY_32: "Brazil",
  COUNTRY_33: "British Indian Ocean Territory",
  COUNTRY_34: "British Virgin Islands",
  COUNTRY_35: "Brunei",
  COUNTRY_36: "Bulgaria",
  COUNTRY_37: "Burkina Faso",
  COUNTRY_38: "Burundi",
  COUNTRY_39: "Cambodia",
  COUNTRY_4: "Albania",
  COUNTRY_40: "Cameroon",
  COUNTRY_41: "Canada",
  COUNTRY_42: "Cape Verde",
  COUNTRY_43: "Cayman Islands",
  COUNTRY_44: "Central African Republic",
  COUNTRY_45: "Chad",
  COUNTRY_46: "Chile",
  COUNTRY_47: "China",
  COUNTRY_48: "Christmas Island",
  COUNTRY_49: "Cocos Islands",
  COUNTRY_5: "Algeria",
  COUNTRY_50: "Colombia",
  COUNTRY_51: "Comoros",
  COUNTRY_52: "Cook Islands",
  COUNTRY_53: "Costa Rica",
  COUNTRY_54: "Croatia",
  COUNTRY_55: "Cuba",
  COUNTRY_56: "Curacao",
  COUNTRY_57: "Cyprus",
  COUNTRY_58: "Czech Republic",
  COUNTRY_59: "Democratic Republic of the Congo",
  COUNTRY_6: "American Samoa",
  COUNTRY_60: "Denmark",
  COUNTRY_61: "Djibouti",
  COUNTRY_62: "Dominica",
  COUNTRY_63: "Dominican Republic",
  COUNTRY_64: "East Timor",
  COUNTRY_65: "Ecuador",
  COUNTRY_66: "Egypt",
  COUNTRY_67: "El Salvador",
  COUNTRY_68: "Equatorial Guinea",
  COUNTRY_69: "Eritrea",
  COUNTRY_7: "Andorra",
  COUNTRY_70: "Estonia",
  COUNTRY_71: "Ethiopia",
  COUNTRY_72: "Falkland Islands",
  COUNTRY_73: "Faroe Islands",
  COUNTRY_74: "Fiji",
  COUNTRY_75: "Finland",
  COUNTRY_76: "France",
  COUNTRY_77: "French Polynesia",
  COUNTRY_78: "Gabon",
  COUNTRY_79: "Gambia",
  COUNTRY_8: "Angola",
  COUNTRY_80: "Georgia",
  COUNTRY_81: "Germany",
  COUNTRY_82: "Ghana",
  COUNTRY_83: "Gibraltar",
  COUNTRY_84: "Greece",
  COUNTRY_85: "Greenland",
  COUNTRY_86: "Grenada",
  COUNTRY_87: "Guam",
  COUNTRY_88: "Guatemala",
  COUNTRY_89: "Guernsey",
  COUNTRY_9: "Anguilla",
  COUNTRY_90: "Guinea",
  COUNTRY_91: "Guinea-Bissau",
  COUNTRY_92: "Guyana",
  COUNTRY_93: "Haiti",
  COUNTRY_94: "Honduras",
  COUNTRY_95: "Hungary",
  COUNTRY_96: "Iceland",
  COUNTRY_97: "India",
  COUNTRY_98: "Indonesia",
  COUNTRY_99: "Iran",
  COUNTRY_LABEL_AU: "Australia",
  COUNTRY_LABEL_HK: "HK",
  COUNTRY_LABEL_MY: "Malaysian",
  COUNTRY_LABEL_SG: "Singapore",
  COUPON_APPLIED_SUCCESS: "Coupon Code Applied",
  COUPON_APPLY_BUTTON: "Apply",
  COUPON_CODE_CC_VISA_ERROR:
    "Oops! Your credit card is not valid for this promotion. Please use a Singapore issued Visa.",
  COUPON_CODE_CC_VISA_MASTERCARD_ERROR:
    "Oops! Your credit card is not valid for this promotion. Please use a Singapore issued Visa or Singapore issued Mastercard.",
  COUPON_CODE_INVALID_ERROR: "Oops! This promo code is invalid.",
  COUPON_CODE_SCHEDULE_ERROR:
    "Please schedule your payment with a charge date no later than 30 Nov 2019.",
  COUPON_FLY_SUCCESS:
    "Awesome! You are one step closer to flying in style in Business Class!",
  COUPON_LOCK_SUCCESS: "Congratulations! You have locked in your rate!",
  COUPON_NOT_FOUND: "Invalid promo code",
  COUPON_REWARD_SUCCESS:
    "You’ve been rewarded with a {render1} rate by using the coupon code,{br}our usual rate is {render2}",
  COUPON_SAVE_SUCCESS: "Congratulations! You have just saved",
  CREATE_BUTTON: "Create",
  CREATE_COLLECTION_ACCOUNT_HERO: "CREATE PAYMENT COLLECTION ACCOUNT",
  CREATE_INVOICE_BUTTON: "Create Invoice",
  CREATE_INVOICE_HERO: "CREATE INVOICE",
  CREATE_INVOICE_MENU_ITEM: "Create Invoice",
  CREATE_ORDER_INVOICE_BUTTON: "Create Order Invoice",
  CREATE_ORDER_MENU_ITEM: "Create Order Invoice",
  CREDIT_CARD_CONFIRMATION: "Do You Have a Credit Card?",
  CREDIT_CARD_STATEMENT_INSTRUCTIONS:
    "This information may appear on your customer’s credit card statement",
  CREDIT_CARD_STATEMENT_INSTRUCTIONS_EXTRA:
    "We recommend using a descriptor your customer will recognize, such as the name of your business",
  CREDIT_CARD_STATEMENT_SECTION: "Credit Card Statement Details",
  CRN_COLUMN: "BRN/CRN",
  CRN_PLACEHOLDER: "Business registration number (BRN/CRN)",
  CURRENCY_CONFIRMATION:
    "For settlements made in USD, you may be subject to inward remittance fees by your bank.{br}This amount varies per bank.",
  CURRENCY_CUSTOM: "{currency}{amount, number, money}",
  CURRENCY_HKD_BUTTON: "Change to HKD",
  CURRENCY_LABEL: "Currency",
  CURRENCY_PLACEHOLDER: "Select the Currency of this Account",
  CUSTOMERS_HERO: "CUSTOMERS",
  CUSTOMERS_MENU_ITEM: "Customers",
  CUSTOMERS_MOBILE_HEADER: "Mobile Number",
  CUSTOMER_ADDRESS_1_LABEL: "Address Line 1",
  CUSTOMER_ADDRESS_1_PLACEHOLDER: "Address Line 1",
  CUSTOMER_ADDRESS_2_LABEL: "Address Line 2",
  CUSTOMER_ADDRESS_2_PLACEHOLDER: "Address Line 2",
  CUSTOMER_ADD_OPTION: "Add New Customer",
  CUSTOMER_BUSINESS_REGISTRATION_NUMBER_LABEL:
    "Business registration number (BRN/CRN)",
  CUSTOMER_BUSINESS_REGISTRATION_NUMBER_PLACEHOLDER:
    "Business registration number (BRN/CRN)",
  CUSTOMER_EMAIL_LABEL: "Customer Email",
  CUSTOMER_EMAIL_PLACEHOLDER: "Customer Email",
  CUSTOMER_LABEL: "Customer",
  CUSTOMER_MOBILE_NUMBER_LABEL: "Customer's Mobile Number",
  CUSTOMER_MOBILE_NUMBER_PLACEHOLDER: "Customer's Mobile Number",
  CUSTOMER_NAME_LABEL: "Customer Name",
  CUSTOMER_NAME_PLACEHOLDER: "Customer Name",
  CUSTOMER_PAYS_LABEL: "Customer Pays",
  CUSTOMER_PHONE_LABEL: "Customer Phone Number",
  CUSTOMER_PHONE_PLACEHOLDER: "Customer Phone Number",
  CUSTOMER_PLACEHOLDER: "Select Customer or Add New Customer",
  CUSTOMER_TYPE_LABEL: "Individual or a Business",
  DASHBOARD_MENU_ITEM: "Dashboard",
  DBS_BANK_AMPERSAND_ERROR: 'Please remove the "\u0026" symbol and try again.',
  DEBIT_CARD_NOT_SUPPORTED:
    "We no longer accept debit cards as of 26 August 2021. Please use a Visa, Mastercard, or UnionPay credit card instead.",
  DELETE_BUTTON: "Delete",
  DELETE_CARD_DESCRIBE:
    "Deleting this card will also delete any associated scheduled payments.",
  DELETE_CARD_HERO: "Do you want to delete this card?",
  DELETE_COMPANY_CONFIRMATION: "Do you want to delete this company?",
  DELETE_COMPANY_DESCRIPTION:
    "This company will be removed from your companies",
  DELETE_CUSTOMER_HERO: "Are you sure you want to delete this customer?",
  DELETE_CUSTOMER_INSTRUCTIONS:
    "You will need to add this customer again if you want to send any payment requests to this customer later.",
  DELETE_PAYEE: "Are you sure you want to delete this {render}?",
  DETAILS_COMPLETED_PAYMENTS: "\u003cb\u003eCOMPLETED\u003c/b\u003e PAYMENTS",
  DETAILS_CONFIRMED:
    "All details have been entered and confirmed, you can now proceed to the next step!",
  DETAILS_MAKE_PAYMENT_NOW: "Make a new payment now.",
  DETAILS_NOTIFICATION: "Notification",
  DETAILS_NO_COMPLETED_PAYMENTS: "No completed payments yet.",
  DETAILS_NO_SCHEDULED_PAYMENTS: "No scheduled payments yet.",
  DETAILS_PAYMENTS_COLLECTED: "PAYMENTS \u003cb\u003eCOLLECTED\u003c/b\u003e",
  DETAILS_PAYMENTS_DEPOSITED: "PAYMENTS \u003cb\u003eDEPOSITED\u003c/b\u003e",
  DETAILS_PAYMENTS_IN_PROGRESS:
    "PAYMENTS \u003cb\u003eIN PROGRESS\u003c/b\u003e",
  DETAILS_PAYMENTS_ON_HOLD: "Payments \u003cb\u003eOn Hold\u003c/b\u003e",
  DETAILS_PAYMENTS_REQUESTED: "PAYMENTS \u003cb\u003eREQUESTED\u003c/b\u003e",
  DETAILS_PLEASE_CHECK: "Please check and update your customer’s {render}",
  DETAILS_PLEASE_CHECK_EMAIL: "email address",
  DETAILS_PLEASE_CHECK_MOBILE: "mobile number",
  DETAILS_REQUEST_FAILED:
    "Payment request (Invoice Number \u003cspan\u003erender\u003c/span\u003e) failed.",
  DETAILS_REQUEST_PAYMENT_NOW: "Request a payment now.",
  DETAILS_SCHEDULED_PAYMENTS: "\u003cb\u003eSCHEDULED\u003c/b\u003e PAYMENTS",
  DETAILS_SCHEDULE_PAYMENT_NOW: "Schedule a payment now.",
  DONE_BUTTON: "Done",
  DOWNLOAD_CSV_BUTTON: "Download CSV Template",
  DROPDOWN_AUSTRALIA: "Australia",
  DROPDOWN_HONG_KONG: "Hong Kong",
  DROPDOWN_MALAYSIA: "Malaysia",
  DROPDOWN_SELECT_COUNTRY: "Select country",
  DROPDOWN_SINGAPORE: "Singapore",
  DUE_DATE_LABEL: "Due Date",
  DYNAMIC_CVV_CARD_NOT_ALLOWED_FOR_RECURRING_PAYMENT_ERROR:
    "This card type is not valid for recurring payments or a payment with a future charge date. Please use another card.",
  DYNAMIC_CVV_CARD_TYPE_NOT_SUPPORT_ERROR:
    "This card type is not valid for your payment. Please use another card.",
  EDIT: "Edit",
  EDIT_ALL_BUTTON: "Edit All",
  EDIT_BUTTON: "Edit",
  EDIT_CUSTOMER_HERO: "Edit Customer",
  EDIT_EMPLOYEE_LABEL: "Edit Employee",
  EDIT_SCHEDULED_PAYMENTS_DESCRIPTION:
    "You need to cancel the associated payment before you edit the {render} details.",
  EDIT_SCHEDULED_PAYMENTS_WARNING:
    "This {render} is associated with a scheduled payment.",
  EDIT_SUPPLIER_HERO: "Edit Supplier",
  EMAIL_ACCOUNT_APPROVED_BODY: "Looks like we have everything we need now!",
  EMAIL_ACCOUNT_APPROVED_BODY_01: "Hi {{.FirstName}}",
  EMAIL_ACCOUNT_APPROVED_BODY_02: "Looks like we have everything we need now!",
  EMAIL_ACCOUNT_APPROVED_BODY_03: "Your",
  EMAIL_ACCOUNT_APPROVED_BODY_04:
    "account has been verified, your payouts are now active. You can easily track the status of when your next settlements are due on your dashboard.",
  EMAIL_ACCOUNT_APPROVED_INSTRUCTIONS:
    "Your Fetch account has been verified, and your payouts are now active. You can easily track the status of when your next settlements are due on your dashboard.",
  EMAIL_ACCOUNT_APPROVED_SUBJECT: "ipaymy Fetch account verified",
  EMAIL_ADDRESS_PLACEHOLDER: "Email Address",
  EMAIL_ALREADY_EXISTS: "This email is already registered.",
  EMAIL_ALREADY_VERIFIED: "This email has been verified already",
  EMAIL_ALREADY_VERIFIED_ERROR:
    "Your email has already been verified. You may sign in now.",
  EMAIL_BEST_SIGNATURE: "Best, ipaymy Compliance Team",
  EMAIL_BE_PAID: "Be Paid",
  EMAIL_BUSINESS_RECEIPT_BODY:
    "Thank you for your payment of {{.Currency}}{{.InvoiceAmount}} to {{.CompanyName}} via ipaymy! Please view your receipt details below.",
  EMAIL_BUSINESS_RECEIPT_BODY_01:
    "Hi, {{.CustomerName}}! Thank you for your payment of",
  EMAIL_BUSINESS_RECEIPT_BODY_02: "to",
  EMAIL_BUSINESS_RECEIPT_BODY_03:
    "via ipaymy! Please view your receipt details below.",
  EMAIL_BUSINESS_RECEIPT_DATE_PAID: "Date Paid",
  EMAIL_BUSINESS_RECEIPT_DETAILS: "Receipt Details",
  EMAIL_BUSINESS_RECEIPT_HERO: "Receipt from {{.CompanyName}}",
  EMAIL_BUSINESS_RECEIPT_LABEL: "Receipt",
  EMAIL_BUSINESS_RECEIPT_ORDER_NUMBER: "Order Number",
  EMAIL_BUSINESS_RECEIPT_POWERED_BY: "Payments powered by",
  EMAIL_BUSINESS_RECEIPT_SUPPORT_EMAIL: "For support, please email us at",
  EMAIL_CANCEL_PAYMENT_COLLECTION_BODY:
    "Hi {{.CustomerName}}! Looks like the payment request of {{.PaymentAmount}} for Invoice #{{.DefaultComments}} has been cancelled by {{.CompanyName}}. No further action required here.",
  EMAIL_CANCEL_PAYMENT_COLLECTION_HERO: "Payment Request Cancelled",
  EMAIL_CANCEL_PAYMENT_COLLECTION_TRY:
    "Get started today and use your credit card to pay rent, salaries, invoices, and more.",
  EMAIL_CDD_ACCOUNT_APPROVED_BODY_02:
    "Your company information has been verified, and your payouts are now active. You can easily track the status of when your next settlements are due on your dashboard.",
  EMAIL_CDD_ACCOUNT_APPROVED_SUBJECT: "ipaymy account verified",
  EMAIL_CDD_ACCOUNT_DECLINED_BODY_02:
    "Your company verification has been declined. We are sorry to inform you that your company has not been approved to make or receive payments on ipaymy.",
  EMAIL_CDD_ACCOUNT_DECLINE_SUBJECT:
    "ipaymy is unable to verify your account details",
  EMAIL_CDD_ACCOUNT_DOCUMENT_REQUEST_BODY_02:
    "We are getting in touch as we noticed you have created an account with ipaymy. We are excited to have you on board, and we just need to collect a bit more information in order to verify your company. Unfortunately, we were not able to verify this based on the information provided.",
  EMAIL_CDD_ACCOUNT_DOCUMENT_REQUEST_BODY_04:
    "Please could you provide a copy of your government registration (dated within the past 3 months).",
  EMAIL_CDD_ACCOUNT_DOCUMENT_REQUEST_MEANTIME_01:
    "In the meantime, you can begin to issue invoices to your customers. However, we will need this information in order to get your account fully up and running.",
  EMAIL_CDD_ACCOUNT_DOCUMENT_REQUEST_SUBJECT:
    "Additional information required for your ipaymy account",
  EMAIL_CDD_DECLINED_VERIFY_QUESTIONS:
    "Should you have any queries about this verification please contact us at ",
  EMAIL_CDD_FETCH_DECLINED_BODY_02:
    "Your Fetch verification has been declined. We are sorry to inform you that your company has not been approved to collect payments through Fetch.",
  EMAIL_CDD_FETCH_DECLINE_SUBJECT:
    "ipaymy is unable to verify your Fetch details",
  EMAIL_COLLECTED_REFUND_AMOUNT: "Refund Amount",
  EMAIL_COLLECTED_REFUND_CARD: "to your",
  EMAIL_COLLECTED_REFUND_COMPANY: "has issued a refund to your",
  EMAIL_COLLECTED_REFUND_COMPANY_OF: "has issued a refund of",
  EMAIL_COLLECTED_REFUND_DETAILS: "Refund Details",
  EMAIL_COLLECTED_REFUND_FEE: "Fee Adjustment",
  EMAIL_COLLECTED_REFUND_RECEIPT: "for Receipt",
  EMAIL_COLLECTED_REFUND_TEN:
    "Please allow up to 10 business days for this to be reflected on your statement.",
  EMAIL_COLLECTED_REFUND_TOTAL: "Total Refund",
  EMAIL_COMMISSION: "Commission",
  EMAIL_COMPLETED_HERO: "Yay! Payment Received",
  EMAIL_COMPLETED_INSTRUCTIONS:
    "Hello {{.FirstName}}! Your payment with the following details has been received by your recipient.",
  EMAIL_CONFIRM_DOES_NOT_MATCH: "The emails entered do not match.",
  EMAIL_COPYRIGHT: "All rights reserved.",
  EMAIL_CREDIT_ENDED_BODY:
    "Time sure flies by! We wanted to give you a heads up that you have reached the end of our Be Paid waived transaction fees period. Going forward the standard transaction fees will apply to any payments made with a credit or debit card to {{.CompanyName}}.",
  EMAIL_CREDIT_ENDED_BODY_01:
    "Time sure flies by! We wanted to give you a heads up that you have reached the end of our Be Paid waived transaction fees period. Going forward the standard transaction fees will apply to any payments made with a credit or debit card to {{.CompanyName}}.",
  EMAIL_CREDIT_ENDED_BODY_02:
    "The great news is you can continue using our service with no additional subscription or hidden fee. Hop on over to ipaymy and create your next invoice today.",
  EMAIL_CREDIT_ENDED_INSTRUCTIONS:
    "The great news is you can continue using our service with no additional subscription or hidden fee. Hop on over to ipaymy and create your next invoice today.",
  EMAIL_CREDIT_ENDED_MONTH_BODY:
    "Looks like you have been busy! You have reached your monthly free payments of {{.CreditCurrency}}{{.CreditAmount}}. Going forward, our standard transaction fees starting from 2.8% will apply.",
  EMAIL_CREDIT_ENDED_MONTH_BODY_01:
    "Looks like you have been busy! You have reached your monthly free payments of",
  EMAIL_CREDIT_ENDED_MONTH_BODY_02:
    "Going forward, our standard transaction fees starting from 2.8% will apply.",
  EMAIL_CREDIT_ENDED_MONTH_BODY_03: "Good news is starting on",
  EMAIL_CREDIT_ENDED_MONTH_BODY_04: "you can process another",
  EMAIL_CREDIT_ENDED_MONTH_BODY_05: "worth of transactions for free!",
  EMAIL_CREDIT_ENDED_MONTH_DASHBOARD: "View in ipaymy Dashboard",
  EMAIL_CREDIT_ENDED_MONTH_INSTRUCTIONS:
    "Good news is starting on {{.NextDate}} you can process another {{.CreditCurrency}}{{.CreditAmount}} worth of transactions for free!",
  EMAIL_CREDIT_ENDED_MONTH_SUBJECT: "Sweet! You maximized your savings!",
  EMAIL_CREDIT_ENDED_SUBJECT: "All good things don’t need to end",
  EMAIL_CREDIT_ENTERED_BODY:
    "Awesome, you have just claimed your free payments!",
  EMAIL_CREDIT_ENTERED_BODY_01:
    "Awesome, you have just claimed your free payments!",
  EMAIL_CREDIT_ENTERED_BODY_02:
    "ipaymy will waive the transaction fees on the first",
  EMAIL_CREDIT_ENTERED_BODY_03:
    "of credit or debit card payments made to your business each month for the next 3 months.",
  EMAIL_CREDIT_ENTERED_BODY_04: "That is a total",
  EMAIL_CREDIT_ENTERED_BODY_05:
    "worth of invoice payments at 0% transaction fees!",
  EMAIL_CREDIT_ENTERED_BODY_06: "Some helpful tips to get you started",
  EMAIL_CREDIT_ENTERED_HELP:
    "Need help getting started? Schedule an onboarding session with us today!",
  EMAIL_CREDIT_ENTERED_INSTRUCTIONS:
    "ipaymy will waive the transaction fees on the first {{.CreditCurrency}}{{.CreditAmount}} of credit or debit card payments made to your business each month for the next 3 months. That is a total {{.CreditCurrency}}{{.TotalCreditAmount}} worth of invoice payments at 0% transaction fees!",
  EMAIL_CREDIT_ENTERED_NEW_BODY:
    "Guess what? You’ve locked-in another month of waived transaction fees on the first {{.CreditCurrency}}{{.CreditAmount}} of credit or debit card payments made to {{.CompanyName}}.",
  EMAIL_CREDIT_ENTERED_NEW_BODY_01:
    "Guess what? You’ve locked-in another month of waived transaction fees on the first",
  EMAIL_CREDIT_ENTERED_NEW_BODY_02:
    "of credit or debit card payments made to {{.CompanyName}}.",
  EMAIL_CREDIT_ENTERED_NEW_BODY_03:
    "Make sure to make the most of this special offer before",
  EMAIL_CREDIT_ENTERED_NEW_BODY_04:
    "Hop on over to ipaymy and create your next invoice today.",
  EMAIL_CREDIT_ENTERED_NEW_CREATE_BUTTON: "Create Invoice",
  EMAIL_CREDIT_ENTERED_NEW_INSTRUCTIONS:
    "Make sure to make the most of this special offer before {{.ThisMonthEndDate}}. Hop on over to ipaymy and create your next invoice today.",
  EMAIL_CREDIT_ENTERED_NEW_SUBJECT: "You have more free payments!",
  EMAIL_CREDIT_ENTERED_SCHEDULE_BUTTON: "Schedule Session",
  EMAIL_CREDIT_ENTERED_SUBJECT: "You just unlocked an amazing promotion",
  EMAIL_CREDIT_ENTERED_TIPS: "Some helpful tips to get you started",
  EMAIL_CREDIT_ENTERED_TIP_1:
    "Each month, your business can accept {{.CreditCurrency}}{{.CreditAmount}} worth of card payments absolutely free",
  EMAIL_CREDIT_ENTERED_TIP_1_01: "Each month, your business can accept",
  EMAIL_CREDIT_ENTERED_TIP_1_02: "worth of card payments absolutely free",
  EMAIL_CREDIT_ENTERED_TIP_2:
    "The program goes into effect when your first customer pays you by card",
  EMAIL_CREDIT_ENTERED_TIP_3:
    "You will be notified through email when you have reached your monthly free limit, after that ipaymy’s standard transaction fees apply",
  EMAIL_CUSTOMER_PAID_BODY:
    "Good news! {{.CustomerName}} has paid you {{.Currency}}{{.Amount}}. The funds will be deposited to your {{.BankName}} account ending in {{.BankAccountNumberLast4}} on {{.PayoutDate}}.",
  EMAIL_CUSTOMER_PAID_BODY_01: "Good news!",
  EMAIL_CUSTOMER_PAID_BODY_02: "has paid you",
  EMAIL_CUSTOMER_PAID_BODY_03: "The funds will be deposited to your",
  EMAIL_CUSTOMER_PAID_BODY_04: "account ending in",
  EMAIL_CUSTOMER_PAID_BODY_05: "on",
  EMAIL_CUSTOMER_PAID_DASHBOARD: "View in ipaymy Dashboard",
  EMAIL_CUSTOMER_PAID_DETAILS: "Payment Details",
  EMAIL_CUSTOMER_PAID_HERO: "{{.CustomerName}} has paid you!",
  EMAIL_CUSTOMER_PAID_SUBJECT: "%s paid",
  EMAIL_DEPOSITED_BODY:
    "Your payment has been deposited to your {{.BankName}} account ending in {{.BankAccountNumberLast4}}.",
  EMAIL_DEPOSITED_BODY_01: "Hi",
  EMAIL_DEPOSITED_BODY_02: "Your payment has been deposited to your",
  EMAIL_DEPOSITED_BODY_03: "account ending in",
  EMAIL_DEPOSITED_HERO: "Congrats! Your payment has been deposited.",
  EMAIL_DEPOSITED_TOTAL: "Total Amount Deposited",
  EMAIL_DOCUMENT_REQUEST_ACCOUNT:
    "Complete bank account number for verification",
  EMAIL_DOCUMENT_REQUEST_BODY:
    "We are getting in touch as we noticed you have created a Fetch account with ipaymy. We are excited to have you on board, and just need to collect a bit more information in order to verify your account details. Unfortunately, we were not able to verify this based on the information provided.",
  EMAIL_DOCUMENT_REQUEST_BODY_01: "Hi there {{.FirstName}}",
  EMAIL_DOCUMENT_REQUEST_BODY_02:
    "We are getting in touch as we noticed you have created a",
  EMAIL_DOCUMENT_REQUEST_BODY_03:
    "account with ipaymy. We are excited to have you on board, and just need to collect a bit more information in order to verify your account details. Unfortunately, we were not able to verify this based on the information provided.",
  EMAIL_DOCUMENT_REQUEST_BODY_04:
    "Please could you provide a copy of your bank statement (dated within the past 3 months). This bank account must belong to the company you are creating your Fetch account for. The bank statement must include:",
  EMAIL_DOCUMENT_REQUEST_COMPANY: "Your company’s name",
  EMAIL_DOCUMENT_REQUEST_MEANTIME:
    "In the meantime, you can begin to issue invoices to your customers. However, we will need this information in order to get your Fetch account fully up and running.",
  EMAIL_DOCUMENT_REQUEST_MEANTIME_01:
    "In the meantime, you can begin to issue invoices to your customers. However, we will need this information in order to get your",
  EMAIL_DOCUMENT_REQUEST_MEANTIME_02: "account fully up and running.",
  EMAIL_DOCUMENT_REQUEST_RESPOND:
    "You can provide this information by directly responding to this email.",
  EMAIL_DOCUMENT_REQUEST_SIGNATURE_01: "Best",
  EMAIL_DOCUMENT_REQUEST_SIGNATURE_02: "ipaymy Compliance Team",
  EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_BODY_01: "Hi there",
  EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_BODY_02:
    "We are getting in touch as we noticed you have created a",
  EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_BODY_03: "Be Paid",
  EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_BODY_04:
    "account with ipaymy. We are excited to have you on board, and just need to collect a bit more information in order to verify your account details. Unfortunately, we were not able to verify this based on the information provided.",
  EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_BODY_05:
    "Could you kindly provide us with the following",
  EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_BODY_06:
    "A photo of your ID held up next to you",
  EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_BODY_07: "Copy of the latest ACRA",
  EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_BODY_08:
    "Copy of a Bank Statement including the address and account number (dated in last 90 days)",
  EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_BODY_09:
    "You can provide this information by directly responding to this email.",
  EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_BODY_10:
    "In the meantime, you can begin to issue invoices to your customer. However, we will need this final piece of verification to ensure we can transfer future payments to your bank account. Please do not hesitate to reach out should you have any questions.",
  EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_BODY_11: "Thanks",
  EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_BODY_12: "ipaymy Compliance Team",
  EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_SUBJECT_01:
    "ipaymy - Further Information Required",
  EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_TEMPL02_BODY_01: "Hi there",
  EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_TEMPL02_BODY_02:
    "We are getting in touch as we noticed you have created a ",
  EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_TEMPL02_BODY_03: "Be Paid ",
  EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_TEMPL02_BODY_04:
    "account with ipaymy. We are excited to have you on board, and just need to collect a bit more information in order to verify your account details. Unfortunately, we were not able to verify this based on the information provided.",
  "EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_TEMPL02_BODY_05 ":
    "Could you kindly provide us with the following",
  EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_TEMPL02_BODY_06:
    "A photo of your ID held up next to you",
  EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_TEMPL02_BODY_07:
    "Copy of the Business Registration Certificate",
  EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_TEMPL02_BODY_08:
    "Copy of a Bank Statement including the address and account number (dated in last 90 days)",
  EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_TEMPL02_BODY_09:
    "You can provide this information by directly responding to this email.",
  EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_TEMPL02_BODY_10:
    "In the meantime, you can begin to issue invoices to your customer. However, we will need this final piece of verification to ensure we can transfer future payments to your bank account. Please do not hesitate to reach out should you have any questions.",
  EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_TEMPL02_BODY_11: "Thanks",
  EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_TEMPL02_BODY_12:
    "ipaymy Compliance Team",
  EMAIL_DOCUMENT_REQUEST_SOLE_PROPRIETORS_TEMPL02_SUBJECT_01:
    "ipaymy - Further Information Required",
  EMAIL_DOCUMENT_REQUEST_STATEMENT:
    "Could you kindly provide us with a bank account statement issued within the last 3 months? Your bank statement must include:",
  EMAIL_DOCUMENT_REQUEST_SUBJECT:
    "Additional information required for your ipaymy Fetch account",
  EMAIL_DOCUMENT_REQUEST_THANKS:
    "Thanks for your understanding and please don’t hesitate to reach out should you have any questions.",
  EMAIL_DOES_NOT_EXIST:
    "An account with this email and password combination does not exist.",
  EMAIL_EARLY_PAYMENT_REQUEST_DISCOUNT_SUBJECT:
    "Get a discount if you pay invoice %s now",
  EMAIL_ERROR: "Please enter a valid email address",
  EMAIL_FAQ: "FAQ",
  EMAIL_FETCH: "Fetch",
  EMAIL_FIRST_INSTALLMENT_PLAN_SUBJECT:
    "%s is offering you an installment plan for invoice %s",
  EMAIL_FM_GENERATION_REPORT_WEEKLY: "ipaymy - Payments ready for approval",
  EMAIL_GREETING: "Hi there {{.FirstName}}",
  EMAIL_GREETING_COMPANY: "Hi there {{.CompanyName}}",
  EMAIL_HERE_LINK: "here",
  EMAIL_IMMEDIATE_PAYMENT_DISCOUNT_SUBJECT:
    "Get a discount if you pay invoice %s now",
  EMAIL_INSTALLMENT_PLAN_FAILED_CUSTOMER_SUBJECT:
    "Payment failed, let's try again",
  EMAIL_INSTALLMENT_PLAN_FAILED_SUPPLIER_SUBJECT: "Payment from %s failed",
  EMAIL_INSTRUCTIONS:
    "Please provide the email you would like all information regarding payments made to your account to be sent to",
  EMAIL_LABEL: "Email",
  EMAIL_LAST_INSTALLMENT_PLAN_SUBJECT:
    "Your last installment for %s is due today",
  EMAIL_LATE_PAYMENT_FEE_SUBJECT: "%s is requesting a late payment fee for %s",
  EMAIL_NOT_EXIST: "This email address does not exist in our database.",
  EMAIL_OVERDUE_BODY:
    "Your payment request from {{.CompanyName}} for {{.InvoiceNumber}} is 2 days overdue.",
  EMAIL_OVERDUE_BODY_01: "Hello {{.CustomerName}}! Your payment request from",
  EMAIL_OVERDUE_BODY_02: " for {{.InvoiceNumber}} is",
  EMAIL_OVERDUE_BODY_03: "2 days overdue.",
  EMAIL_OVERDUE_HERO: "Your payment is overdue.",
  EMAIL_OVERDUE_SUBJECT: "Your payment to %s is overdue",
  EMAIL_PAYFETCH_CUSTOMER_PAID_SUBJECT: "Invoice %s paid by %s",
  EMAIL_PAYFETCH_REFUND_SUBJECT: "Refunded payment confirmation %s",
  EMAIL_PAYFETCH_REQUEST_SUBJECT: "%s requests your payment for invoice %s",
  EMAIL_PAYFETCH_TEMPLATE_MARK_BULK_COLLECTED_PAYMENT_AS_COMPLETE_SUBJECT:
    "Payment from %s deposited to your bank account - %s",
  EMAIL_PAYFETCH_TEMPLATE_MARK_PAYMENT_AS_COMPLETE_SUBJECT:
    "Your payment has successfully reached %s, %s",
  EMAIL_PAYFETCH_TEMPLATE_RECEIPT_SUBJECT:
    "Your payment is on its way to %s! %s",
  EMAIL_PLACEHOLDER: "Email",
  EMAIL_RECEIPT_AMOUNT: "Amount",
  EMAIL_RECEIPT_BANK_FEE: "Bank Fee",
  EMAIL_RECEIPT_CARD: "Card",
  EMAIL_RECEIPT_COMPANY: "Company",
  EMAIL_RECEIPT_COUNTRY: "Recipient Country",
  EMAIL_RECEIPT_DESCRIPTION: "Description",
  EMAIL_RECEIPT_DETAILS: "Details",
  EMAIL_RECEIPT_DISCOUNT: "Discount",
  EMAIL_RECEIPT_FEE: "Fee",
  EMAIL_RECEIPT_FEE_TOTAL: "Fee Total",
  EMAIL_RECEIPT_HERO: "Payment Successful",
  EMAIL_RECEIPT_INSTRUCTIONS:
    "Thank you for using ipaymy! Your recipient will receive the funds by",
  EMAIL_RECEIPT_ITEM: "Item",
  EMAIL_RECEIPT_NAME: "Name",
  EMAIL_RECEIPT_NUMBER: "Receipt Number",
  EMAIL_RECEIPT_PRICE: "Price",
  EMAIL_RECEIPT_TOTAL: "Total",
  EMAIL_REFERRER_BODY:
    "Awesome, {{.RefereeName}} has just made their first payment on ipaymy!",
  EMAIL_REFERRER_BODY_DETAILS: "Keep referring, keep earning!",
  EMAIL_REFERRER_BODY_INSTRUCTIONS:
    "Use the promo code {{.ReferrerCouponName}} for the following amount off the ipaymy transaction fee on your next payment before {{.ReferrerCouponExpiryDate}}",
  EMAIL_REFERRER_REDEEM_BUTTON: "Redeem Offer",
  EMAIL_REFERRER_TC_1:
    "Promo code only valid for users that are part of ipaymy Referral Program",
  EMAIL_REFERRER_TC_2:
    "Payment must be made with locally issued Visa or Mastercard card",
  EMAIL_REFERRER_TC_3: "Promo code valid for one-time payments",
  EMAIL_REFERRER_TC_4:
    "Charge date must be on or before {{.ReferrerCouponExpiryDate}}",
  EMAIL_REFUND_AMOUNT: "Refunded Amount",
  EMAIL_REFUND_BODY:
    "Hi {{.FirstName}}, your payment with the following details has been successfully refunded.",
  EMAIL_REFUND_BODY_WITH_CUSTOMER:
    "Hi {{.FirstName}}, your payment from {{.CustomerName}} with the following details has been successfully refunded.",
  EMAIL_REFUND_FEE: "Refunded Fee",
  EMAIL_REFUND_HERO: "Payment Refunded",
  EMAIL_REFUND_INSTRUCTIONS:
    "This email is to confirm that a refund has been issued by ipaymy. It can take 5 to 10 business days to appear on your statement.",
  EMAIL_REFUND_INSTRUCTIONS_01:
    "This email is to confirm that a refund has been issued by ipaymy.",
  EMAIL_REFUND_INSTRUCTIONS_02:
    "It can take 5 to 10 business days to appear on your statement.",
  EMAIL_REFUND_INSTRUCTIONS_WITH_CUSTOMER:
    "This email is to confirm that a refund has been issued to your customer. It can take 5 to 10 business days to appear on their statement.",
  EMAIL_REFUND_INSTRUCTIONS_WITH_CUSTOMER_01:
    "This email is to confirm that a refund has been issued to your customer.",
  EMAIL_REFUND_INSTRUCTIONS_WITH_CUSTOMER_02:
    "It can take 5 to 10 business days to appear on their statement.",
  EMAIL_REFUND_NEW_TOTAL: "New Total",
  EMAIL_REFUND_SUBJECT: "ipaymy %s Refunded",
  EMAIL_REMINDER_BODY:
    "Hello {{.CustomerName}}! Your payment request from {{.CompanyName}} for {{.InvoiceNumber}} is due by {{.DueDate}}.",
  EMAIL_REMINDER_DISREGARD:
    "If you have already paid your invoice, please disregard this message.",
  EMAIL_REMINDER_HERO: "Your payment is due soon.",
  EMAIL_REMINDER_INSTRUCTIONS_01:
    "Hello {{.CustomerName}}! Your payment request from",
  EMAIL_REMINDER_INSTRUCTIONS_02: "for {{.InvoiceNumber}} is due by",
  EMAIL_REMINDER_SUBJECT: "Your payment to %s is due today",
  EMAIL_REQUEST_BODY:
    "Hi {{.CustomerName}}, {{.CompanyName}} is requesting payment for {{.InvoiceNumber}}. The total amount is {{.Currency}}{{.Amount}} and is due by {{.DueDate}}.",
  EMAIL_REQUEST_DOWNLOAD_01: "You can view or download",
  EMAIL_REQUEST_DOWNLOAD_02: "your invoice here",
  EMAIL_REQUEST_EMAIL_CHAT_01:
    "Payments powered by ipaymy. For support, please email us at",
  EMAIL_REQUEST_EMAIL_CHAT_02: "or chat with us at",
  EMAIL_REQUEST_HERO: "You received a payment request.",
  EMAIL_REQUEST_INSTRUCTIONS_01: "Hi {{.CustomerName}}",
  EMAIL_REQUEST_INSTRUCTIONS_02:
    "is requesting payment for {{.InvoiceNumber}}. The total amount is",
  EMAIL_REQUEST_INSTRUCTIONS_03: "and is due by",
  EMAIL_REQUEST_INVOICE_NUMBER: "Invoice Number",
  EMAIL_REQUEST_NOTE: "Note from",
  EMAIL_REQUEST_PAY_BUTTON: "Pay Now",
  EMAIL_REQUEST_SUBJECT: "%s is requesting payment for %s",
  EMAIL_REQUEST_TOTAL: "Total",
  EMAIL_SCHEDULED_FAILED: "Oops... Payment Failed",
  EMAIL_SCHEDULED_FAILED_INSTRUCTIONS:
    "Hi {{.FirstName}}, your payment could not be processed because of the following reason: {{.FailureReason}}",
  EMAIL_SCHEDULED_FAILED_PAYMENT_BUTTON: "Make Another Payment",
  EMAIL_SCHEDULED_FAILED_PAYOUT: "Payout Date",
  EMAIL_SECOND_INSTALLMENT_PLAN_SUBJECT:
    "Your second installment for %s is due today",
  EMAIL_SECTION: "Email",
  EMAIL_SUPPLIER_NOTIFICATION_BODY_01:
    "Great news! {{.RecipientName}} has received an invoice payment of {{.PaymentCurrency}}{{.PaymentAmount}} from {{.UserFullName}} via ipaymy. The funds are on the way and will be deposited directly into your {{.PaymentBank}} number {{.PaymentAccountNumber}} on {{.PayoutDate}}.",
  EMAIL_SUPPLIER_NOTIFICATION_BODY_02:
    'To ensure you don’t miss the payment, look out for the descriptor "{{.BeneficiaryStatement}}" from "IPAYMY TECHNOLOGIES PTE LTD" on your bank statement.',
  EMAIL_SUPPLIER_NOTIFICATION_BODY_03:
    "ipaymy is an online platform that enables SMEs to pay rent, salaries, invoices and even tax using the credit cards they have in their wallet today. Our secure platform makes it easy to make and manage payments to suppliers who currently don’t accept credit card payments.",
  EMAIL_SUPPLIER_NOTIFICATION_BODY_04:
    "If you are interested in learning more about ipaymy for making or collecting payments, our team is ready to assist at hello@ipaymy.com.",
  EMAIL_SUPPORT: "Support",
  EMAIL_TCS: "T\u0026Cs",
  EMAIL_TEMPLATE_CANCEL_PAYMENT_REQUEST_SUBJECT: "Payment request cancelled",
  EMAIL_TEMPLATE_MARK_BULK_COLLECTED_PAYMENT_AS_COMPLETE_SUBJECT:
    "Your payment has been deposited through ipaymy",
  EMAIL_TEMPLATE_MARK_PAYMENT_AS_COMPLETE_SUBJECT: "ipaymy %d-%d Completed",
  EMAIL_TEMPLATE_MOTOROLA_PAYMENT_DEPOSITED_SUPPLIER_SUBJECT:
    "%s has been deposited a payment via ipaymy",
  EMAIL_TEMPLATE_MOTOROLA_PAYMENT_SUCCESS_SUPPLIER_SUBJECT:
    "%s has received a payment via ipaymy",
  EMAIL_TEMPLATE_PARTNER_MARK_PAYMENT_AS_COMPLETE_SUBJECT:
    "Your payment has been deposited through ipaymy",
  EMAIL_TEMPLATE_PARTNER_PAYMENT_COLLECTION_SUCCESS_CUSTOMER_SUBJECT:
    "%s Receipt %s",
  EMAIL_TEMPLATE_RECEIPT_SUBJECT: "ipaymy Receipt %s",
  EMAIL_TEMPLATE_REFERRER_SUBJECT: "%s, you have earned %s",
  EMAIL_TEMPLATE_SCHEDULE_FAILED_SUBJECT: "Your scheduled payment failed",
  EMAIL_TEMPLATE_SCHEDULE_PAYMENTS_SERIES_CANCELLED_CARD_REMOVED_SUBJECT:
    "Your card was removed from your scheduled payment series",
  EMAIL_TEMPLATE_SCHEDULE_PAYMENTS_SERIES_CANCELLED_SUBJECT:
    "Your scheduled payment series have been cancelled",
  EMAIL_TEMPLATE_SCHEDULE_PAYMENT_CANCELLED_CARD_REMOVED_SUBJECT:
    "Your card has been removed from your scheduled payment",
  EMAIL_TEMPLATE_SCHEDULE_PAYMENT_CANCELLED_SUBJECT:
    "Your scheduled payment has been cancelled",
  EMAIL_TEMPLATE_SUPPLIER_DEPOSITED_NOTIFICATION_SUBJECT:
    "Payment has been deposited from %s",
  EMAIL_TEMPLATE_SUPPLIER_NOTIFICATION_SUBJECT:
    "%s has received an invoice payment via ipaymy",
  EMAIL_TEMPLATE_WALLEX_BUSINESS_KYC_APPROVED_SUBJECT:
    "ipaymy has Verified Company Details",
  EMAIL_TEMPLATE_WALLEX_BUSINESS_KYC_REJECTED_SUBJECT:
    "ipaymy is Unable to Verify your Company Details",
  EMAIL_TEMPLATE_WALLEX_BUSINESS_KYC_UNDER_REVIEW_SUBJECT:
    "ipaymy is Verifying your Company Details",
  EMAIL_TEMPLATE_WALLEX_KYC_APPROVED_SUBJECT:
    "ipaymy has Verified your Identity",
  EMAIL_TEMPLATE_WALLEX_KYC_REJECTED_SUBJECT:
    "ipaymy is Unable to Verify your Identity",
  EMAIL_TEMPLATE_WALLEX_KYC_UNDER_REVIEW_SUBJECT:
    "ipaymy is Verifying your Identity",
  EMAIL_TERMS_OF_USE: "Terms of Use",
  EMAIL_TRANSACTION_ACCOUNT: "Recipient Account Number",
  EMAIL_TRANSACTION_ADDRESS:
    "Address: 144 Robinson Road, #06-02, Singapore 068908",
  EMAIL_TRANSACTION_AMOUNT: "Amount Transferred",
  EMAIL_TRANSACTION_BANK: "Recipient Bank",
  EMAIL_TRANSACTION_DATE: "Payment Date",
  EMAIL_TRANSACTION_HERO: "Transaction Details",
  EMAIL_TRANSACTION_IPAYMY: "ipaymy Technologies Pte. Ltd.",
  EMAIL_TRANSACTION_PAGE: "Page {{.Page}} of {{.Total}}",
  EMAIL_TRANSACTION_PURPOSE: "Purpose",
  EMAIL_TRANSACTION_THANKS: "Thank you for using ipaymy!",
  EMAIL_TRANSACTION_UEN: "UEN: 201535772K",
  EMAIL_TRANSACTION_WEBSITE: "Website",
  EMAIL_VERIFICATION_REQUIRED: "Please verify your email first.",
  EMAIL_VERIFIED: "Email verification successful! You may now sign in.",
  EMAIL_VIEW_INVOICE_INSTRUCTIONS: "You can view or download your invoice ",
  EMPLOYEES_HERO: "EMPLOYEES",
  EMPLOYEES_INSTRUCTIONS:
    "Here are your registered employees. Have a new one?{br}Click “Add New Employee” to add it.",
  EMPLOYEES_MENU_ITEM: "Employees",
  EMPLOYEE_ACCOUNT_NUMBER_HEADER: "Account Number",
  EMPLOYEE_ACCOUNT_PLACEHOLDER: "Employee's bank account number",
  EMPLOYEE_AMOUNT_HEADER: "Amount",
  EMPLOYEE_BANK_HEADER: "Bank",
  EMPLOYEE_COUNTRY_HEADER: "Country",
  EMPLOYEE_DELETE_HERO: "Do you want to delete this employee?",
  EMPLOYEE_DELETE_INSTRUCTIONS:
    "This employee will be removed from your employees",
  EMPLOYEE_FULL_NAME_LABEL: "Employee's Full Name",
  EMPLOYEE_FULL_NAME_PLACEHOLDER: "Employee's Full Name",
  EMPLOYEE_HEADER: "Employee",
  EMPLOYEE_HKID_HEADER: "HKID",
  EMPLOYEE_ID_HEADER: "ID",
  EMPLOYEE_LABEL: "Employee",
  EMPLOYEE_NOTE_HEADER: "Note to Employee",
  EMPLOYEE_NRIC_HEADER: "NRIC",
  EMPLOYEE_SCHEDULED_PAYMENT_HERO:
    "This employee is associated with a scheduled payment.",
  EMPLOYEE_SCHEDULED_PAYMENT_INSTRUCTIONS:
    "You need to cancel the associated payment before you edit the employee details.",
  ENTER_EMAIL_PLACEHOLDER: "Enter Email",
  ENTER_INVOICE_AMOUNT_HEADER: "Enter Invoice Amount and Upload Invoice",
  ENTER_INVOICE_DETAILS_HERO: "ENTER INVOICE DETAILS",
  ENTER_PASSWORD_ERROR:
    "Please choose a stronger password with at least 8 characters consisting of letters, numbers and symbols.",
  ENTER_PASSWORD_PLACEHOLDER: "Enter Password",
  ENTER_PIN:
    "Please enter the verification PIN sent to your phone number ending in \u003cb\u003e{render}.\u003c/b\u003e",
  ERROR_ACCOUNT_NUMBER_DOES_NOT_MATCH: "Please enter a valid account number.",
  ERROR_ADDING_CARD:
    "We had some trouble with your card. Please try again, or contact us at support@ipaymy.com.",
  ERROR_ADYEN_CARD_UNACCEPTED: "We currently only accept MasterCard and Visa.",
  ERROR_BANK_ACCOUNT_HOLDER_NAME_DOES_NOT_MATCH:
    "Please enter a valid bank account holder name.",
  ERROR_BANK_RAW_NAME_DOES_NOT_MATCH: "Please enter a valid bank name.",
  ERROR_BRAINTREE_CARD_UNACCEPTED:
    "We currently only accept Visa and Mastercard.",
  ERROR_BT_2000:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_2001:
    "Payment failed due to insufficient credit. You may have reached the maximum credit limit on this credit card. Please adjust the payment amount or use another credit card.",
  ERROR_BT_2002:
    "This transaction failed due to exceeding withdrawal limit. Please try another card.",
  ERROR_BT_2003:
    "This transaction failed due to exceeding withdrawal limit. Please try another card.",
  ERROR_BT_2004:
    "The card’s expiration is incorrect. Check the expiration date or use a different card.",
  ERROR_BT_2005:
    "The card number is incorrect. Check the card’s number or use a different card.",
  ERROR_BT_2006:
    "The card’s expiration is invalid. Check the expiration date or use a different card.",
  ERROR_BT_2007:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2008:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2009:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2010:
    "The card’s CVC/CVV is incorrect. Check the card’s security code or use a different card.",
  ERROR_BT_2011:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2012:
    "The transaction cannot be authorized. Please try a different card or contact your issuer for more information.",
  ERROR_BT_2013:
    "The transaction cannot be authorized. Please try a different card or contact your issuer for more information.",
  ERROR_BT_2014:
    "The transaction cannot be authorized. Please try a different card or contact your issuer for more information.",
  ERROR_BT_2015:
    "The transaction cannot be authorized. Please try a different card or contact your issuer for more information.",
  ERROR_BT_2016:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2017:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2018:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2019:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2020:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2021:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2022:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2023:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2024:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2025:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2026:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2027:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2028:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2029:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2030:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2031:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2032:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2033:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2034:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2035:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2036:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2037:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2038:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2039:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2040:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2041:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_2042:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2043:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_2044:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_2045:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2046:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_2047:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_2048:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2049:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2050:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_2051:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2052:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2053:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_2054:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2055:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2056:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2057:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_2058:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2059:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2060:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2061:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2062:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2063:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2064:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2065:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2066:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2067:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2068:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2069:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2070:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2071:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2072:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2073:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2074:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2075:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2076:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2077:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2078:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2079:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2080:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2081:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2082:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2083:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2084:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2085:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2086:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2087:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2088:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2089:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2090:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2091:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2092:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2093:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2094:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2095:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2096:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2097:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2098:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2099:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_2100:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2101:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2102:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2103:
    "Oops! Payment failed. There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  ERROR_BT_2104:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2105:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2106:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2107:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2108:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2109:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2110:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2111:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2112:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2113:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2114:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2115:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2116:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2117:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2118:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2119:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2120:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2121:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2122:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2123:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2124:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2125:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2126:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2127:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2128:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2129:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2130:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2131:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2132:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2133:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2134:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2135:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2136:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2137:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2138:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2139:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2140:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2141:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2142:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2143:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2144:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2145:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2146:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2147:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2148:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2149:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2150:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2151:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2152:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2153:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2154:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2155:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2156:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2157:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2158:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2159:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2160:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2161:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2162:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2163:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2164:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2165:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2166:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2167:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2168:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2169:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2170:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2171:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2172:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2173:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2174:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2175:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2176:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2177:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2178:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2179:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2180:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2181:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2182:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2183:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2184:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2185:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2186:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2187:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2188:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2189:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2190:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2191:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2192:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2193:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2194:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2195:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2196:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2197:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2198:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2199:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2200:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2201:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2202:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2203:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2204:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2205:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2206:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2207:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2208:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2209:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2210:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2211:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2212:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2213:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2214:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2215:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2216:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2217:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2218:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2219:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2220:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2221:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2222:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2223:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2224:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2225:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2226:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2227:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2228:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2229:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2230:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2231:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2232:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2233:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2234:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2235:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2236:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2237:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2238:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2239:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2240:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2241:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2242:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2243:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2244:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2245:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2246:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2247:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2248:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2249:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2250:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2251:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2252:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2253:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2254:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2255:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2256:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2257:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2258:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2259:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2260:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2261:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2262:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2263:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2264:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2265:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2266:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2267:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2268:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2269:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2270:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2271:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2272:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2273:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2274:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2275:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2276:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2277:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2278:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2279:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2280:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2281:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2282:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2283:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2284:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2285:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2286:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2287:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2288:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2289:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2290:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2291:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2292:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2293:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2294:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2295:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2296:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2297:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2298:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2299:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2300:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2301:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2302:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2303:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2304:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2305:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2306:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2307:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2308:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2309:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2310:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2311:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2312:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2313:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2314:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2315:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2316:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2317:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2318:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2319:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2320:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2321:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2322:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2323:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2324:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2325:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2326:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2327:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2328:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2329:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2330:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2331:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2332:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2333:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2334:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2335:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2336:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2337:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2338:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2339:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2340:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2341:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2342:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2343:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2344:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2345:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2346:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2347:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2348:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2349:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2350:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2351:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2352:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2353:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2354:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2355:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2356:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2357:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2358:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2359:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2360:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2361:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2362:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2363:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2364:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2365:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2366:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2367:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2368:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2369:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2370:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2371:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2372:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2373:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2374:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2375:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2376:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2377:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2378:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2379:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2380:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2381:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2382:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2383:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2384:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2385:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2386:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2387:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2388:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2389:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2390:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2391:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2392:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2393:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2394:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2395:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2396:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2397:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2398:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2399:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2400:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2401:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2402:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2403:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2404:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2405:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2406:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2407:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2408:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2409:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2410:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2411:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2412:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2413:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2414:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2415:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2416:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2417:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2418:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2419:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2420:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2421:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2422:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2423:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2424:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2425:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2426:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2427:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2428:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2429:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2430:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2431:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2432:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2433:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2434:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2435:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2436:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2437:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2438:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2439:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2440:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2441:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2442:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2443:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2444:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2445:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2446:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2447:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2448:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2449:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2450:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2451:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2452:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2453:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2454:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2455:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2456:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2457:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2458:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2459:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2460:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2461:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2462:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2463:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2464:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2465:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2466:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2467:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2468:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2469:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2470:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2471:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2472:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2473:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2474:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2475:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2476:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2477:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2478:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2479:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2480:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2481:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2482:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2483:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2484:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2485:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2486:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2487:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2488:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2489:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2490:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2491:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2492:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2493:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2494:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2495:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2496:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2497:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2498:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2499:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2500:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2501:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2502:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2503:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2504:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2505:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2506:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2507:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2508:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2509:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2510:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2511:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2512:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2513:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2514:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2515:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2516:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2517:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2518:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2519:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2520:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2521:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2522:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2523:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2524:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2525:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2526:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2527:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2528:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2529:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2530:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2531:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2532:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2533:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2534:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2535:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2536:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2537:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2538:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2539:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2540:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2541:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2542:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2543:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2544:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2545:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2546:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2547:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2548:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2549:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2550:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2551:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2552:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2553:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2554:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2555:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2556:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2557:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2558:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2559:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2560:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2561:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2562:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2563:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2564:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2565:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2566:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2567:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2568:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2569:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2570:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2571:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2572:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2573:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2574:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2575:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2576:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2577:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2578:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2579:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2580:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2581:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2582:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2583:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2584:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2585:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2586:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2587:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2588:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2589:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2590:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2591:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2592:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2593:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2594:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2595:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2596:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2597:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2598:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2599:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2600:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2601:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2602:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2603:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2604:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2605:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2606:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2607:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2608:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2609:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2610:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2611:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2612:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2613:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2614:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2615:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2616:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2617:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2618:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2619:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2620:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2621:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2622:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2623:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2624:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2625:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2626:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2627:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2628:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2629:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2630:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2631:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2632:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2633:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2634:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2635:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2636:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2637:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2638:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2639:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2640:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2641:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2642:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2643:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2644:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2645:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2646:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2647:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2648:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2649:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2650:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2651:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2652:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2653:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2654:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2655:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2656:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2657:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2658:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2659:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2660:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2661:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2662:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2663:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2664:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2665:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2666:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2667:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2668:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2669:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2670:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2671:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2672:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2673:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2674:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2675:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2676:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2677:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2678:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2679:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2680:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2681:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2682:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2683:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2684:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2685:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2686:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2687:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2688:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2689:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2690:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2691:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2692:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2693:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2694:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2695:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2696:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2697:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2698:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2699:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2700:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2701:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2702:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2703:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2704:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2705:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2706:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2707:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2708:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2709:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2710:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2711:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2712:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2713:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2714:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2715:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2716:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2717:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2718:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2719:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2720:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2721:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2722:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2723:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2724:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2725:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2726:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2727:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2728:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2729:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2730:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2731:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2732:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2733:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2734:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2735:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2736:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2737:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2738:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2739:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2740:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2741:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2742:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2743:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2744:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2745:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2746:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2747:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2748:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2749:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2750:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2751:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2752:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2753:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2754:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2755:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2756:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2757:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2758:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2759:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2760:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2761:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2762:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2763:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2764:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2765:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2766:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2767:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2768:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2769:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2770:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2771:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2772:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2773:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2774:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2775:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2776:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2777:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2778:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2779:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2780:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2781:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2782:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2783:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2784:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2785:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2786:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2787:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2788:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2789:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2790:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2791:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2792:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2793:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2794:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2795:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2796:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2797:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2798:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2799:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2800:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2801:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2802:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2803:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2804:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2805:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2806:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2807:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2808:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2809:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2810:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2811:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2812:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2813:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2814:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2815:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2816:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2817:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2818:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2819:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2820:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2821:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2822:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2823:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2824:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2825:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2826:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2827:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2828:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2829:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2830:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2831:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2832:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2833:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2834:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2835:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2836:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2837:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2838:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2839:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2840:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2841:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2842:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2843:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2844:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2845:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2846:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2847:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2848:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2849:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2850:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2851:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2852:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2853:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2854:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2855:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2856:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2857:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2858:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2859:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2860:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2861:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2862:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2863:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2864:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2865:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2866:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2867:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2868:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2869:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2870:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2871:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2872:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2873:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2874:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2875:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2876:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2877:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2878:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2879:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2880:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2881:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2882:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2883:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2884:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2885:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2886:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2887:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2888:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2889:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2890:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2891:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2892:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2893:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2894:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2895:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2896:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2897:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2898:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2899:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2900:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2901:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2902:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2903:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2904:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2905:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2906:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2907:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2908:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2909:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2910:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2911:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2912:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2913:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2914:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2915:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2916:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2917:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2918:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2919:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2920:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2921:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2922:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2923:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2924:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2925:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2926:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2927:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2928:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2929:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2930:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2931:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2932:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2933:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2934:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2935:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2936:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2937:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2938:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2939:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2940:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2941:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2942:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2943:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2944:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2945:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2946:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2947:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2948:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2949:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2950:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2951:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2952:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2953:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2954:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2955:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2956:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2957:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2958:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2959:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2960:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2961:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2962:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2963:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2964:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2965:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2966:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2967:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2968:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2969:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2970:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2971:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2972:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2973:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2974:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2975:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2976:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2977:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2978:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2979:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2980:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2981:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2982:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2983:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2984:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2985:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2986:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2987:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2988:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2989:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2990:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2991:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2992:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2993:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2994:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2995:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2996:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2997:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2998:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_DECLINED_2999:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BT_PROCESSOR_NETWORK_UNAVAILABLE_3000:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  ERROR_BULK_REQUEST_PENDING_APPROVAL_UPDATE_INSTANT_PAY_LIMIT:
    "Already have pending approval operation to update instant pay limit",
  ERROR_CARD_BRAND_UNACCEPTED: "We currently do not accept this card brand.",
  ERROR_CARD_UNACCEPTED: "We currently only accept {accepted_card_types}",
  ERROR_CKO_CARD_UNACCEPTED: "We currently only accept Visa and Mastercard.",
  ERROR_COLLECTED_ACCOUNT_EXIST:
    "This company already has a Payment Collection account.",
  ERROR_CONFIRM_AMOUNT_REQUIRED: "Please confirm amount",
  ERROR_CONNECTION_TIMEOUT:
    "The internet connection was lost. Check your internet connection and try again.",
  ERROR_COUNTRY_REQUIRED: "Please select your country",
  ERROR_COUPON_AU_VISA:
    "Oops! The promo code is invalid. Kindly contact us via live chat in the bottom right corner.",
  ERROR_COUPON_BOC_CARD_ONLY:
    "The promo code is not valid for your card, please use a different card instead.",
  ERROR_COUPON_CHARGED_ACCOUNT:
    "Oops! This promotion is not valid for this payment.",
  ERROR_COUPON_CHARGE_DATE_EXPIRED:
    "Oops! This promotion is not valid for this charge date.",
  ERROR_COUPON_CHARGE_DATE_SOONER:
    "Oops! This promotion is not valid for this charge date.",
  ERROR_COUPON_EXCEED_USAGE: "Your account has fully redeemed this promo code.",
  ERROR_COUPON_EXPIRED: "The coupon has expired or has been fully redeemed.",
  ERROR_COUPON_HK_VISA:
    "Oops! The promo code is invalid. Kindly contact us via live chat in the bottom right corner.",
  ERROR_COUPON_INVALID_CARD:
    "The promo code is not valid for your card, please use a different card instead.",
  ERROR_COUPON_INVALID_CARD_BRAND:
    "Oops! Your credit card is not valid for this promotion. Please use %s.",
  ERROR_COUPON_INVALID_PAYMENT_TYPE:
    "The promo code is only valid for tax payments.",
  ERROR_COUPON_INVALID_PAYMENT_TYPE_2:
    "Oops! This promotion is not valid for this payment.",
  ERROR_COUPON_INVALID_TAX_TYPE:
    "The promo code is not valid for tax payments.",
  ERROR_COUPON_INVOICE_PURPOSE_NOT_MATCH:
    "This promotion is not valid for invoice payments.",
  ERROR_COUPON_MY_VISA:
    "Oops! The promo code is invalid. Kindly contact us via live chat in the bottom right corner.",
  ERROR_COUPON_NOT_FOUND: "Invalid promo code.",
  ERROR_COUPON_NO_AVAILABLE_USE:
    "Oops! The promo code is invalid. Kindly contact us via live chat in the bottom right corner.",
  ERROR_COUPON_NO_AVAILABLE_USE_2:
    "The promo code has been applied more than its usage limit.",
  ERROR_COUPON_NO_AVAILABLE_USE_3:
    "The promo code has been applied more than its usage limit.",
  ERROR_COUPON_RENT_PURPOSE_NOT_MATCH:
    "This promotion is not valid for rent payments.",
  ERROR_COUPON_SALARY_PURPOSE_NOT_MATCH:
    "This promotion is not valid for salary payments.",
  ERROR_COUPON_SG_VISA:
    "Oops! The promo code is invalid. Kindly contact us via live chat in the bottom right corner.",
  ERROR_COUPON_UEN_NOT_IN_LIST:
    "Oops! This promotion is not valid for this payment.",
  ERROR_EMAIL_REQUIRED: "Please enter a valid email address",
  ERROR_EXISTING_EMAIL:
    "This email is already registered, please use a different email",
  ERROR_EXISTING_MOBILE_NUMBER:
    "This mobile number is already registered, please use a different number",
  ERROR_FIELD_REQUIRED: "This field is required.",
  ERROR_FIRST_NAME_REQUIRED: "Please enter your first name",
  ERROR_HK_CARD_UNACCEPTED: "We currently only accept Visa and Mastercard.",
  ERROR_INCORRECT_2FA_PASSWORD: "Please enter the correct password.",
  ERROR_INCORRECT_OLD_PASSWORD: "Please enter correct old password.",
  ERROR_INVALID_CARD: "Card details are invalid.",
  ERROR_INVALID_EMAIL_ADDRESS: "Please enter a valid email address.",
  ERROR_INVOICE_SUPPORTING_DOCUMENT_REQUIRED:
    "Please upload a copy of your invoice.",
  ERROR_LAST_NAME_REQUIRED: "Please enter your last name",
  ERROR_LOANS_PAYMENT_VISA: "Loan payments with VISA cards are not supported.",
  ERROR_MAX_LENGTH: "Please enter fewer than {max_length} characters.",
  ERROR_MIN_LENGTH: "Must be at least {min_length} characters.",
  ERROR_MIN_PASSWORD_LENGTH:
    "Password needs to be at least {min_length} characters",
  ERROR_MOBILE_NUMBER_REQUIRED: "Please enter your mobile number",
  ERROR_MULTIPLE_LANDLORDS_AMEX:
    "Amex is currently unavailable for paying multiple landlords. Please select one landlord or another card brand.",
  ERROR_MULTIPLE_SUPPLIERS_AMEX:
    "Amex is currently unavailable for paying multiple suppliers. Please select one supplier or another card brand.",
  ERROR_MULTIPLE_TAX_AMEX:
    "Amex is currently unavailable for paying multiple tax payments. Please select one tax payment or another card brand.",
  ERROR_MY_CARD_UNACCEPTED: "We currently only accept Visa and Mastercard.",
  ERROR_NO_SELECTED_CARD: "Please select or add a card first.",
  ERROR_NO_SELECTED_PAYEE: "Please select a payee.",
  ERROR_ONLY_PERSONAL_AMEX_CARD:
    "We currently only accept Amex personal cards, please use another card.",
  ERROR_OPERATION_PENDING_APPROVAL:
    "This payment has awaiting approval for other operation",
  ERROR_PASSWORD_CONFIRM_REQUIRED: "Please ensure passwords match",
  ERROR_PASSWORD_LENGTH:
    "Please enter a password with at least 8 characters consisting of at least one letter, one number and one symbol",
  ERROR_PASSWORD_REQUIRED: "Please enter a stronger password",
  ERROR_PAYMENT_PROCESSED: "Payment has already been processed.",
  ERROR_PROMO_CODE_FIRST_PAYMENT_ONLY:
    "Oops! The promo code is only valid for your first payment.",
  ERROR_PROMO_CODE_HIGHER_DEFAULT_RATE:
    "Good news, no promo code required. You already received the lowest rate!",
  ERROR_PROMO_CODE_NOT_FOR_INSURANCE_PAYMENT:
    "The promo code is not valid for insurance payments.",
  ERROR_PROMO_CODE_NOT_FOR_INVOICE_PAYMENT:
    "The promo code is not valid for invoice payments.",
  ERROR_PROMO_CODE_NOT_FOR_RENTAL_PAYMENT:
    "The promo code is not valid for rental payments.",
  ERROR_PROMO_CODE_NOT_FOR_SALARY_PAYMENT:
    "The promo code is not valid for salary payments.",
  ERROR_PROMO_CODE_NOT_FOR_THIS_PAYMENT:
    "The promo code is not valid for this payment.",
  ERROR_PROMO_CODE_ONE_TIME_PAYMENT_ONLY:
    "Oops! Looks like this is a recurring payment. This promo code is only valid for one-time payments.",
  ERROR_PROMO_CODE_RECURRING_PAYMENT_ONLY:
    "Oops! Looks like this is a one-time payment. This promo code is only valid for recurring payments.",
  ERROR_REFUND_PENDING_APPROVAL:
    "This payment has a pending approval refund operation",
  ERROR_SCHEDULE_PENDING_APPROVAL_BULK_UPLOAD_PAYMENT_FILE:
    "This schedule has a pending approval operation to bulk upload file",
  ERROR_SCHEDULE_PENDING_APPROVAL_CANCEL_SCHEDULE:
    "This schedule has a pending approval operation to cancel schedule",
  ERROR_SCHEDULE_PENDING_APPROVAL_UPDATE_BANK_DETAILS_SCHEDULE:
    "This schedule has a pending approval operation to update bank details",
  ERROR_SCHEDULE_PENDING_APPROVAL_UPDATE_DESCRIPTION_SCHEDULE:
    "This schedule has a pending approval operation to update description",
  ERROR_SCHEDULE_PENDING_APPROVAL_UPDATE_PAYOUT_SCHEDULE:
    "This schedule has a pending approval operation to update payout date",
  ERROR_SCHEDULE_TYPE_REQUIRED:
    "Please select one-time payment or recurring payment.",
  ERROR_SG_CARD_UNACCEPTED:
    "We currently only accept Visa, Mastercard, and China UnionPay.",
  ERROR_STATEMENT_MIN_LENGTH:
    "Statement descriptor must be at least {min_length} characters.",
  ERROR_STRIPE_CARD_UNACCEPTED:
    "We currently only accept MasterCard, Visa and American Express.",
  ERROR_TENANCY_AGREEMENT_REQUIRED:
    "Please upload a copy of your tenancy agreement.",
  ERROR_TERM_AGREEMENT_REQUIRED:
    "Please select the checkbox to agree to our terms and conditions",
  ERROR_UNSUPPORTED_EXPEDITE: "Expedite operation is not supported",
  ERROR_UNSUPPORTED_REFUND: "Refund operation is not supported",
  ERROR_UNSUPPORTED_UPDATE: "Update operation is not supported",
  ERROR_UPLOAD_FAILED: "We had trouble uploading your file. Please try again.",
  ERROR_VALID_MOBILE_NUMBER: "Please enter a valid mobile number",
  EXCEEDS_MAXIMUM_AMOUNT: "Please enter a valid amount up to 999,999.99",
  EXCEED_MAX_AMOUNT_350000_INTERNATIONAL_ERROR:
    "The amount entered exceeds the transaction limit of SGD350,000.",
  EXCEED_MAX_AMOUNT_ERROR:
    "The amount entered exceeds the transaction limit, please enter a smaller amount.",
  EXCEED_MAX_AMOUNT_INTERNATIONAL_ERROR:
    "The amount entered exceeds the transaction limit of SGD200,000.",
  EXPIRED_EMAIL_TOKEN:
    "Your email verification token has expired. Please try again.",
  EXPIRED_PASSWORD_RESET_TOKEN:
    "Your token has expired. Please reset your password again.",
  EXPORT_BUTTON: "Export",
  FEATURE_UNAVAILABLE_ERROR: "The feature is currently unavailable.",
  FILE_DRAG_LABEL: "Drag and drop your files here to upload or",
  FILE_INVALID_TYPE: "Invalid file type",
  FILE_MAXIMUM_SIZE: "Maximum file size",
  FILE_SELECT_LABEL: "Select files to upload",
  FILE_SUPPORTED_TYPES: "Supported file types",
  FILTER_BUTTON: "Filter",
  FILTER_CHARGE_DATE_HEADER: "Charge Date",
  FILTER_CLEAR_BUTTON: "Clear",
  FILTER_DONE_BUTTON: "Done",
  FILTER_FROM_LABEL: "From",
  FILTER_HEADER: "Filter",
  FILTER_STATUS_CANCELLED: "Cancelled",
  FILTER_STATUS_COMPLETED: "Completed",
  FILTER_STATUS_DECLINED: "Declined",
  FILTER_STATUS_HEADER: "Status",
  FILTER_STATUS_ON_HOLD: "On Hold",
  FILTER_STATUS_PROGRESS: "In Progress",
  FILTER_STATUS_REFUNDED: "Refunded",
  FILTER_TO_LABEL: "To",
  FIND_ABN: "Don't know the ABN? You can find it ",
  FIND_CRN:
    "Don’t know the Business Registration Number (BRN/CRN)? You can find it ",
  FIND_UEN: "Don't know the UEN? You can find it ",
  FIRST_EXPIRING_PAYMENT_REMINDER_SUBJECT:
    "Reminder: Your scheduled recurring payment to %s will end soon",
  FIRST_NAME_ERROR: "Please enter your first name",
  FIRST_NAME_PLACEHOLDER: "First Name",
  FIRST_UPCOMING_PAYMENT_REMINDER_SUBJECT:
    "Reminder: You have an upcoming scheduled payment to %s",
  FORGOT_PASSWORD_EMAIL_BUTTON: "Reset Password",
  FORGOT_PASSWORD_EMAIL_EXPIRY:
    "This verification email is valid for {{.ExpiredIn}}.",
  FORGOT_PASSWORD_EMAIL_HERO: "Forgot Your Password?",
  FORGOT_PASSWORD_EMAIL_INSTRUCTIONS:
    "Please click the button below to reset your password.",
  FORGOT_PASSWORD_EMAIL_SUBJECT: "Reset your password",
  FORGOT_PASSWORD_INSTRUCTIONS: "Forgot your password? {RESET_PASSWORD_LINK}",
  FREE_PAYMENTS_MESSAGE:
    "You are currently enjoying 0% transaction fees because you have claimed your Free Payments Offer.",
  GET_HELP_BUTTON: "Get Help",
  GET_STARTED: "Get Started",
  GREETING_NAVBAR: "Hello, {name}!",
  GST_REGISTRATION_NUMBER: "GST Registration Number",
  GST_REGISTRATION_NUMBER_PLACEHOLDER: "GST Registration Number",
  HANDSHAKE_CUSTOMER_TAG_ACTIVE: "Active",
  HANDSHAKE_CUSTOMER_TAG_ACTIVE_DEFINITION:
    "A customer who has completed at least one payment in the last 90 days.",
  HANDSHAKE_CUSTOMER_TAG_NEW: "New",
  HANDSHAKE_CUSTOMER_TAG_NEW_DEFINITION:
    "A customer who has received their first payment request in the last 30 days.",
  HANDSHAKE_CUSTOMER_TAG_RISKY: "Risky",
  HANDSHAKE_CUSTOMER_TAG_RISKY_DEFINITION:
    "A customer who has completed less than 50% of all the payments they have been requested to make in the last 90 days.",
  HANDSHAKE_CUSTOMER_TAG_VIP: "VIP",
  HANDSHAKE_CUSTOMER_TAG_VIP_DEFINITION:
    "A customer who has completed all payments at full price and on time in the last 90 days.",
  HERE_LINK: "here",
  HIDE_DETAILS_BUTTON: "Hide Details",
  HISTORY_HERO: "COLLECTED PAYMENTS",
  HISTORY_INVOICE_HEADER: "Invoice",
  HISTORY_MENU_ITEM: "History",
  HISTORY_NET_HEADER: "Net",
  HKID_LABEL: "HKID",
  HKID_PLACEHOLDER: "Employee's HKID",
  ID_LABEL: "ID",
  ID_PLACEHOLDER: "Employee's ID",
  IMAGE_MORE_FREE_PAYMENTS: "You have more free payments!",
  IMAGE_NEW_MONTH: "New Month",
  IMAGE_SWEET: "Sweet! You've maximized your free payments.",
  IMAGE_TRANSACTION_FEE: "Transaction Fee",
  IMAGE_VICTORY_LAP: "Take a victory lap, you are an invoicing pro!",
  IMAGE_WORKS_PAYS: "Works like a credit card. Pays like cash.",
  IMAGE_ZERO_PERCENT: "0% Transaction Fees",
  INCENTIVES_EARLY_DEADLINE: "Early payment deadline",
  INCENTIVES_EARLY_DESCRIPTION:
    "We'll send your customer this offer via email two business days after the invoice date on invoices with at least a net 15 due date.",
  INCENTIVES_EARLY_FEE: "Early payment discount",
  INCENTIVES_HALF_DESCRIPTION:
    "If your customer doesn't make a full payment by the due date, we'll send an offer via email one day after the due date to pay half of the total invoice amount immediately, and pay the remaining half on the same day of the following month.",
  INCENTIVES_IMMEDIATE_DEADLINE: "Immediate payment deadline",
  INCENTIVES_IMMEDIATE_DESCRIPTION:
    "We'll send your customer this offer via email three business days before the due date on invoices with at least a net 30 due date.",
  INCENTIVES_IMMEDIATE_FEE: "Immediate payment discount",
  INCENTIVES_LATE_DEADLINE: "Late payment deadline",
  INCENTIVES_LATE_DESCRIPTION:
    "If your customer doesn't make a full payment by the due date, we'll send a notification via email one day after the due date that we've applied this fee for late payment.",
  INCENTIVES_LATE_FEE: "Late payment fee",
  INCENTIVES_THREE_DESCRIPTION:
    "If your customer doesn't make a full payment by the due date, we'll send an offer via email one day after the due date to pay one third of the total invoice amount immediately, and pay the remaining thirds on the same day of the following two months.",
  INCENTIVES_THREE_INSTALLMENTS_DEADLINE: "Pay in three installments deadline",
  INCENTIVES_TWO_INSTALLMENTS_DEADLINE: "Half now, half later deadline",
  INSTALLMENT_NUMBER_LABEL: "Installment {number} of {total}",
  INSTANT_REQUEST_BUTTON: "Instant Request",
  INSTANT_REQUEST_MENU_ITEM: "Instant Request",
  INSTRUCTION_DESCRIPTION_OF_GOODS: "Description of Goods",
  INSTRUCTION_INVOICE_AMOUNT: "Invoice Amount",
  INSTRUCTION_SUPPLIER_COMPANY_NAME: "Supplier Company Name",
  INSURANCE_LEARN_MORE: "You can learn more about making an insurance payment",
  INTEND_MULTIPLE_PAYMENTS_LABEL:
    "I intend to make multiple payments to this supplier",
  INTEND_MULTIPLE_PAYMENTS_TOOLTIP:
    "By confirming you intend to make recurring payments to this supplier you may be eligible for occasionally lower fees.",
  INTERNATIONAL_LABEL: "International",
  INT_PAYMENT_MISSING_RECIPIENT_DATA:
    "We noticed that you are missing the following required data for this recipient of your international payment:",
  INT_PAYMENT_UNSUPPORTED_ERROR:
    "Please log into our new platform at web.ipaymy.com to make international payments.",
  INVALID_101_IBAN: "The IBAN should be 22 characters long",
  INVALID_104_IBAN: "The IBAN should be 27 characters long",
  INVALID_117_IBAN: "The IBAN should be 21 characters long",
  INVALID_123_IBAN: "The IBAN should be 20 characters long",
  INVALID_124_IBAN: "The IBAN should be 20 characters long",
  INVALID_131_IBAN: "The IBAN should be 31 characters long",
  INVALID_149_IBAN: "The IBAN should be 18 characters long",
  INVALID_171_IBAN: "The IBAN should be 25 characters long",
  INVALID_17_IBAN: "The IBAN should be 20 characters long",
  INVALID_195_IBAN: "The IBAN should be 24 characters long",
  INVALID_196_IBAN: "The IBAN should be 19 characters long",
  INVALID_202_IBAN: "The IBAN should be 24 characters long",
  INVALID_227_IBAN: "The IBAN should be 23 characters long",
  INVALID_228_IBAN: "The IBAN should be 22 characters long",
  INVALID_24_IBAN: "The IBAN should be 16 characters long",
  INVALID_57_IBAN: "The IBAN should be 28 characters long",
  INVALID_70_IBAN: "The IBAN should be 20 characters long",
  INVALID_75_IBAN: "The IBAN should be 18 characters long",
  INVALID_76_IBAN: "The IBAN should be 27 characters long",
  INVALID_81_IBAN: "The IBAN should be 22 characters long",
  INVALID_84_IBAN: "The IBAN should be 27 characters long",
  INVALID_ABN: "Please enter a valid ABN.",
  INVALID_ALPHANUMERIC: "Please enter only letters and numbers here.",
  INVALID_AMOUNT: "That does not look like a valid amount.",
  INVALID_AMOUNT_CONVERSION: "That does not look like a valid amount.",
  INVALID_ANZBSGSX_3_NUMBER_1: "ANZ account numbers require 10 or 11 digits.",
  INVALID_BANKSWIFT: "Invalid bank swift code",
  INVALID_BANK_CODE_FORMAT: "Enter your bank code in a valid format.",
  INVALID_BANK_DOCUMENTS_REQUIRED: "Bank documents required",
  INVALID_BANK_NOT_SUPPORTED: "ipaymy can not support payments to this bank",
  INVALID_BANK_NUMBER: "Bank account number is invalid",
  INVALID_BANK_NUMBER_NOT_SUPPORTED:
    "ipaymy can not support payments to this bank account number.",
  INVALID_BEASHKHH_123_NUMBER_1:
    "Please enter a valid Bank of East Asia account number.",
  INVALID_BKCHHKHH_120_NUMBER_1:
    "Please enter a valid Bank of China (Hong Kong) account number.",
  INVALID_BKCHSGSG_6_NUMBER_1:
    "The Bank of China account numbers require 15 digits.",
  INVALID_BNPASGSG_142_NUMBER_1:
    "Please enter a valid BNP Paribas account number.",
  INVALID_BOC_NUMBER: "Please enter a valid Bank of China account number.",
  INVALID_BOFASG2X_21_NUMBER_1:
    "Bank of America account numbers require 8 digits.",
  INVALID_BRN: "Please enter a valid Business Registration Number (BRN/CRN).",
  INVALID_BRN_AFFILIATED_ENTITIES:
    "Invoice payments can not be made to your business or any affiliated entities.",
  INVALID_BSB_CODE:
    "Invalid BSB code. It can only contain numeric characters and dashes.",
  INVALID_CCBQHKAX_125_NUMBER_1:
    "Please enter a valid China Construction Bank (Asia) Corporation Limited account number.",
  INVALID_CIBBSGSG_12_NUMBER_1:
    "CIMB Bank account numbers require 10 or 16 or 17 digits.",
  INVALID_CITIHKAX_128_NUMBER_1:
    "Please enter a valid Citibank (Hong Kong) Limited account number.",
  INVALID_CITIHKAX_128_NUMBER_2:
    "Please enter a valid Citibank (Hong Kong) Limited account number.",
  INVALID_CITIHKAX_128_NUMBER_3:
    "Please enter a valid Citibank (Hong Kong) Limited account number.",
  INVALID_CITIHKHX_129_NUMBER_1:
    "Please enter a valid CITIBANK, N.A account number.",
  INVALID_CITISGSG_4_NUMBER_1: "Citibank account numbers require 10 digits.",
  INVALID_CITISGSG_NUMBER:
    "That does not look like a valid citibank bank account number. It should be 10 digits",
  INVALID_CITISGSL_117_NUMBER_1: "Citibank account numbers require 10 digits.",
  INVALID_CIYUHKHH_126_NUMBER_1:
    "Please enter a valid Chiyu Banking Corporation Limited account number.",
  INVALID_COMMHKHK_121_NUMBER_1:
    "Please enter a valid Bank of Communications Co., Ltd. account number.",
  INVALID_COMMHKHK_122_NUMBER_1:
    "Please enter a valid Bank of Communications Co., Ltd. account number.",
  INVALID_COUNTRY_CODE_WHEN_ADDING_CARD:
    "We had some trouble with your card. Please contact us at support@ipaymy.com.",
  INVALID_CREDENTIALS: "Invalid email/password combination, please try again.",
  INVALID_DATE: "Invalid Date",
  INVALID_DBSSHKHH_132_NUMBER_1:
    "Please enter a valid DBS BANK LTD. account number.",
  INVALID_DBSSSGSG_19_NUMBER_1: "POSB Bank account numbers require 9 digits.",
  INVALID_DBSSSGSG_19_NUMBER_2:
    "Please enter a valid POSB Bank account number.",
  INVALID_DBSSSGSG_1_NUMBER_1:
    "DBS Bank account numbers require 9 or 10 digits.",
  INVALID_DBSSSGSG_1_NUMBER_2: "Please enter a valid DBS Bank account number.",
  INVALID_DBSSSGSG_NUMBER:
    "That does not look like a valid DBS bank account number. It should be 10 digits",
  INVALID_DHBKHKHH_131_NUMBER_1:
    "Please enter a valid DBS Bank (Hong Kong) Limited account number.",
  INVALID_DSBAHKHH_130_NUMBER_1:
    "Please enter a valid Dah Sing Bank Limited account number.",
  INVALID_DUE_DATE: "Enter a future invoice due date in a valid format.",
  INVALID_DUPLICATED_COLLECTION_INVOICED_DOCUMENT:
    "Only one corresponding invoice can be uploaded for each invoice number.",
  INVALID_EMAIL_ADDRESS: "Please enter a valid email address.",
  INVALID_EMAIL_TOKEN: "Please verify your email first.",
  INVALID_EMAIL_USED: "Invalid email address",
  INVALID_EMPLOYEE_ID: "Please enter a valid employee ID.",
  INVALID_EXCEED_FILE_SIZE: "File size exceeds 16MB.",
  INVALID_EXCEED_FILE_SIZE_5MB: "File size exceeds 5MB.",
  INVALID_FILE_NAME_LENGTH:
    "File name exceeds 60 character limit. Please rename and upload a new file.",
  INVALID_FILE_UPLOAD_AMOUNT: "You must upload at least {file_amount} files.",
  INVALID_GROSS_AMOUNT: "Invalid amount",
  INVALID_HASEHKHH_133_NUMBER_1:
    "Please enter a valid Hang Seng Bank, Limited account number.",
  INVALID_HKIC: "Please enter a valid HKID.",
  INVALID_HSBCHKHHHKH_134_NUMBER_1:
    "Please enter a valid The Hongkong and Shanghai Banking Corporation Limited account number.",
  INVALID_HSBCSGS2_5_NUMBER_1:
    "HSBC Bank Singapore account numbers require 12 digits.",
  INVALID_HSBCSGS2_5_NUMBER_2:
    "Please enter a valid HSBC Bank Singapore account number.",
  INVALID_HSBCSGSG_22_NUMBER_1: "HSBC Bank account numbers require 12 digits.",
  INVALID_HSBCSGSG_22_NUMBER_2:
    "Please enter a valid HSBC Bank account number.",
  INVALID_HSBCSGSG_NUMBER_1: "HSBC Bank account numbers require 12 digits.",
  INVALID_HSBCSGSG_NUMBER_2: "Please enter a valid HSBC Bank account number.",
  INVALID_IBAN: "IBAN is invalid",
  INVALID_INCORPORATION_DATE_ERROR: "Please enter a valid date.",
  INVALID_IOBASGSGS_NUMBER_1:
    "Indian Overseas Bank account numbers require 15 digits.",
  INVALID_IOBASGSG_15_NUMBER_1:
    "Indian Overseas Bank account numbers require 15 digits.",
  INVALID_KWHKHKHH_124_NUMBER_1:
    "Please enter a valid China Citi Bank International Limited account number.",
  INVALID_LCHBHKHH_127_NUMBER_1:
    "Please enter a valid Chong Hing Bank Limited account number.",
  INVALID_LENGTH_11: "Invalid length - it should be 11 characters long.",
  INVALID_LENGTH_HK_NOTE: "Note must be no more than 35 characters.",
  INVALID_LENGTH_INVOICE_NOTE_AU:
    "Note to supplier should not exceed 18 characters.",
  INVALID_LENGTH_MALAYSIA_NOTE: "Note must be no more than 20 characters.",
  INVALID_LENGTH_NOTE: "Note must be no more than %s characters.",
  INVALID_LENGTH_OTHER_COUNTRY_NOTE: "Note must be no more than 35 characters.",
  INVALID_LENGTH_RENT_NOTE_AU:
    "Note to landlord should not exceed 18 characters.",
  INVALID_LENGTH_SALARY_BUSINESS_NOTE_AU:
    "Salary reference should not exceed 18 characters.",
  INVALID_LENGTH_SALARY_NOTE_AU:
    "Note to employee should not exceed 18 characters.",
  INVALID_LENGTH_SINGAPORE_NOTE: "Note must be no more than 35 characters.",
  INVALID_LENGTH_TAX_NOTE_AU:
    "Payment Reference Number should not exceed 18 characters.",
  INVALID_LIVIHKHH_244_NUMBER_1:
    "Livi Bank Limited account numbers require 8 digits.",
  INVALID_MAXIMUM_VALUE: "The maximum is {value}.",
  INVALID_MBBESGSG_8_NUMBER_1: "Maybank account numbers require 11 digits.",
  INVALID_MBBESGSG_NUMBER_1: "Maybank account numbers require 11 digits.",
  INVALID_MHCBSGSG_17_NUMBER_1:
    "Mizhou Bank account numbers require 11 digits.",
  INVALID_MHCBSGSG_NUMBER_1: "Mizuho Bank account numbers require 11 digits.",
  INVALID_MINIMUM_SALARY_AMOUNT_MY: "Minimum salary amount is RM30.",
  INVALID_MOBILE_USED: "Account with this phone number already exists.",
  INVALID_MYKAD_NUMBER: "Please enter a valid MyKad.",
  INVALID_MY_INVOICE_PAYEE_AMOUNT: "Minimum invoice amount RM30.",
  INVALID_NOTE_TO:
    "Invalid character used. Note to your recipient can only contain alphabetic and numeric characters.",
  INVALID_NOTE_TO_SUPPLIER_INTERNATIONAL_PAYMENT:
    "Note to your recipient can only contain alphanumeric characters and must not exceed 16 characters.",
  INVALID_NRICFIN: "Please enter a valid NRIC.",
  INVALID_NYCBHKHH_136_NUMBER_1:
    "Please enter a valid Nanyang Commercial Bank Limited account number.",
  INVALID_NYCBHKHH_136_NUMBER_2:
    "Please enter a valid Nanyang Commercial Bank Limited account number.",
  INVALID_OCBCSGSG_2_NUMBER_1:
    "OCBC Bank account numbers require 10 or 12 digits. ",
  INVALID_OCBCSGSG_2_NUMBER_2: "Please enter a valid OCBC Bank account number.",
  INVALID_OCBCSGSG_NUMBER:
    'That does not look like a valid OCBC bank account number. It should be 7 digits. If you see 10 digit figures like "5501089550", please drop first 3 digits (550) which is the Branch Code',
  INVALID_OCBCSGSG_NUMBER_1:
    "OCBC Bank account numbers require 10 or 12 digits.",
  INVALID_OCBCSGSG_NUMBER_2: "Please enter a valid OCBC Bank account number.",
  INVALID_PASSWORD_STRENGTH:
    "Please choose a stronger password with at least 8 characters consisting of letters, numbers and symbols.",
  INVALID_PAYMENT_DUE_TO_SCREENING_REJECT:
    "Invalid payment due to screening rejection",
  INVALID_PAYOUT_DATE_ERROR:
    "Oops, looks like we ran into an issue. Please try rescheduling your payment.",
  INVALID_PHONE_NUMBER: "Please provide a valid mobile number.",
  INVALID_POSTAL_CODE_MY: "Please input a valid postal code",
  INVALID_PROMO_CODE:
    "Oops! The promo code is invalid. Kindly contact us via live chat in the bottom right corner.",
  INVALID_PROMO_CODE_CHARGE_DATE:
    "Oops! The promo code is not valid for this charge date.",
  INVALID_RATE_NUMBER: "Please enter a valid rate.",
  INVALID_RECIPIENT_NAME:
    "Invalid character used. Recipient name can only contain alphabetic and numeric characters.",
  INVALID_REQUEST_BODY: "Invalid body.",
  INVALID_REQUEST_BODY_STRUCTURE_ERROR: "Some information is incorrect",
  INVALID_RHBBSGSG_13_NUMBER_1: "RHB Bank account numbers require 11 digits.",
  INVALID_RHBBSGSG_NUMBER_1: "RHB Bank account numbers require 11 digits.",
  INVALID_SALARY_AMOUNT:
    "Please provide a valid salary amount for this employee",
  INVALID_SALARY_AMOUNT_HK:
    "Please provide a valid salary amount for this employee",
  INVALID_SBINSGSG_11_NUMBER_1:
    "State Bank of India account numbers require 14 digits.",
  INVALID_SBINSGSG_11_NUMBER_2:
    "Please enter a valid State Bank of India account number.",
  INVALID_SBINSGSG_NUMBER_1:
    "State Bank of India account numbers require 14 digits.",
  INVALID_SBINSGSG_NUMBER_2:
    "Please enter a valid State Bank of India account number.",
  INVALID_SCBKHKHH_138_NUMBER_1:
    "Please enter a valid Shanghai Commercial Bank Limited account number.",
  INVALID_SCBKHKHH_138_NUMBER_2:
    "Please enter a valid Shanghai Commercial Bank Limited account number.",
  INVALID_SCBLHKHH_139_NUMBER_1:
    "Please enter a valid Standard Chartered Bank (Hong Kong) Limited account number.",
  INVALID_SCBLHKHH_140_NUMBER_1:
    "Please enter a valid Wing Lung Bank Limited Limited account number.",
  INVALID_SCBLSGSG_10_NUMBER_1:
    "Standard Chartered Bank account numbers require 10 digits.",
  INVALID_SCBLSGSG_NUMBER_1:
    "Standard Chartered Bank account numbers require 10 digits.",
  INVALID_SG_INVOICE_PAYEE_AMOUNT: "Minimum invoice amount S$15.",
  INVALID_SSM: "Please enter a valid SSM number.",
  INVALID_SSM_NOT_SUPPORTED:
    "Please enter a valid company registration number.",
  INVALID_STATEMENT_DESCRIPTOR:
    "Invalid character. Statement descriptor only accepts alphanumeric charecters.",
  INVALID_STATEMENT_DESCRIPTOR_ALPHABET:
    "Payment description must contain at least 1 alphabetic character.",
  INVALID_STATEMENT_DESCRIPTOR_LENGTH:
    "The statement descriptor is limited to 22 characters only.",
  INVALID_SUPPORTING_DOCUMENT: "The file you uploaded is not supported.",
  INVALID_SUPPORTING_DOCUMENTS_RENT_COUNT:
    "You have reached the maximum number of supporting documents uploads",
  INVALID_SUPPORTING_DOCUMENTS_RENT_REQUIRED:
    "Please upload at least one supporting document.",
  INVALID_SUPPORTING_DOCUMENTS_SALARY_COUNT:
    "You have reached the maximum number of supporting documents uploads",
  INVALID_TRBUSGSG_243_NUMBER_1:
    "TRUST BANK SINGAPORE LIMITED account numbers require 10 digits.",
  INVALID_TRBUSGSG_250_NUMBER_1:
    "TRUST BANK SINGAPORE LIMITED account numbers require 10 digits.",
  INVALID_UBHKHKHH_135_NUMBER_1:
    "Please enter a valid Industrial and Commercial Bank of China (Asia) Limited account number.",
  INVALID_UEN: "Please enter a valid UEN.",
  INVALID_UEN_AFFILIATED_ENTITIES:
    "Invoice payments can not be made to your business or any affiliated entities.",
  INVALID_UEN_NOT_SUPPORTED:
    "ipaymy currently does not support payments to this supplier.",
  INVALID_UOVBSGSG_16_NUMBER_1:
    "Far Eastern Bank Bank account numbers require 10 digits.",
  INVALID_UOVBSGSG_7_NUMBER_1:
    "UOB Bank account numbers require 10 or 12 digits.",
  INVALID_UOVBSGSG_NUMBER_1:
    "UOB Bank account numbers require 10 or 12 digits.",
  INVALID_WIHBHKHH_137_NUMBER_1:
    "Please enter a valid OCBC Wing Hang Bank Limited account number.",
  INVOICES_BUTTON: "Invoices",
  INVOICE_AMOUNT_DUE_LABEL: "Amount Due",
  INVOICE_AMOUNT_HEADER: "Amount",
  INVOICE_BILL_TO_LABEL: "Bill To",
  INVOICE_CC_LABEL: "CC",
  INVOICE_DATE_CUSTOM_OPTION: "Custom",
  INVOICE_DATE_LABEL: "Invoice Date",
  INVOICE_DATE_NET_15_OPTION: "Net 15 Days",
  INVOICE_DATE_NET_30_OPTION: "Net 30 Days",
  INVOICE_DATE_NET_45_OPTION: "Net 45 Days",
  INVOICE_DATE_NET_60_OPTION: "Net 60 Days",
  INVOICE_DATE_PLACEHOLDER: "Due On Receipt",
  INVOICE_DISCOUNT_HEADER: "Discount",
  INVOICE_DUE_DATE_LABEL: "Invoice due date",
  INVOICE_DUE_LABEL: "Due Date",
  INVOICE_EXAMPLE_COMPANY_ADDRESS: "1 Robinson Rd Singapore, Singapore 068908",
  INVOICE_EXAMPLE_COMPANY_NAME: "Company XYZ",
  INVOICE_EXAMPLE_DATE: "Invoice Date: 12 Feb 2020",
  INVOICE_EXAMPLE_DUE_DATE: "27 Feb 2020",
  INVOICE_EXAMPLE_GST_REGISTRATION_NUMBER: "GST Reg No. ",
  INVOICE_EXAMPLE_GST_TAX: "GST (7%)",
  INVOICE_INSTRUCTIONS:
    "Invoice \u003cspan\u003e must include:\u003c/span\u003e",
  INVOICE_ITEM_ADD_BUTTON: "Add Line Item",
  INVOICE_ITEM_DESCRIPTION_HEADER: "Item Description",
  INVOICE_ITEM_NEW_OPTION: "Add New Item",
  INVOICE_ITEM_PLACEHOLDER: "Click to select or add an item",
  INVOICE_LABEL: "INVOICE",
  INVOICE_LOGO_PREVIEW: "Logo{br}Preview",
  INVOICE_MESSAGE_LABEL: "Message",
  INVOICE_MULTIPLE_CUSTOMER_TOOLTIP:
    "Request multiple payments from the same customer.",
  INVOICE_MULTIPLE_SUPPLIER_TOOLTIP:
    "Pay multiple invoices to the same supplier.",
  INVOICE_NEW_ITEM_DISCOUNT_LABEL: "Discount",
  INVOICE_NEW_ITEM_DISCOUNT_PLACEHOLDER:
    "Tap {render1} to change it to {render2}",
  INVOICE_NEW_ITEM_HERO: "NEW ITEM",
  INVOICE_NEW_ITEM_NAME_LABEL: "Name",
  INVOICE_NEW_ITEM_NAME_PLACEHOLDER: "Name",
  INVOICE_NEW_ITEM_PCT_DISCOUNT_PLACEHOLDER: "e.g. 1.5",
  INVOICE_NEW_ITEM_QUANTITY_PLACEHOLDER: "e.g. 10",
  INVOICE_NEW_ITEM_SELECT_TAX_PLACEHOLDER: "Select a Tax",
  INVOICE_NEW_ITEM_TAX_NAME_LABEL: "Tax Name",
  INVOICE_NEW_ITEM_TAX_NAME_PLACEHOLDER: "Tax Name",
  INVOICE_NEW_ITEM_TAX_RATE_LABEL: "Rate",
  INVOICE_NEW_ITEM_TAX_RATE_PLACEHOLDER: "e.g. 1.5",
  INVOICE_NEW_TAX_HERO: "NEW TAX",
  INVOICE_NOTES_LABEL: "Notes (Optional)",
  INVOICE_NOTE_OPTIONAL_COMPANY_TCS:
    "Optional area to include your company’s terms and conditions.",
  INVOICE_NUMBER_AUTO_NEXT_LABEL: "Next Number",
  INVOICE_NUMBER_AUTO_OPTION: "Use auto-generated invoice number.",
  INVOICE_NUMBER_AUTO_PREFIX_LABEL: "Prefix",
  INVOICE_NUMBER_HEADER: "INVOICE NUMBER",
  INVOICE_NUMBER_INSTRUCTIONS:
    "How do you want to generate your invoice number?",
  INVOICE_NUMBER_LABEL: "Invoice Number",
  INVOICE_NUMBER_MANUAL_OPTION: "Add invoice number manually every time.",
  INVOICE_NUMBER_PLACEHOLDER: "Invoice Number",
  INVOICE_ORDER_LABEL: "Invoice/Order Number",
  INVOICE_ORDER_PLACEHOLDER: "Invoice/Order Number",
  INVOICE_PREVIEW: "INVOICE PREVIEW",
  INVOICE_PURPOSE_LABEL: "Enter Invoice Amount and Upload Invoice",
  INVOICE_QUANTITY_HEADER: "Qty",
  INVOICE_REPLY_TO_LABEL: "Reply To",
  INVOICE_REQUIRED_ERROR: "An invoice is required.",
  INVOICE_SUBTOTAL_LABEL: "Subtotal",
  INVOICE_TAX_HEADER: "Tax",
  INVOICE_TAX_NEW_OPTION: "Add New Tax",
  INVOICE_TAX_PLACEHOLDER: "Select a tax",
  INVOICE_TCS_LABEL: "Terms and Conditions (Optional)",
  INVOICE_TOTAL_LABEL: "Total Amount Due",
  INVOICE_TO_LABEL: "To",
  INVOICE_UNIT_PRICE_HEADER: "Unit Price",
  IPAYMY_LEARN_MORE_LINK: "Learn more about ipaymy",
  IPAYMY_RESTRICTED_BUSINESS_CHECKBOX:
    'By registering with us, you are confirming that you will not use ipaymy or our Services to accept payments in connection with any \u003ca\u003e"Restricted Businesses"\u003c/a\u003e or for any illegal activities.',
  IPAYMY_TCS_CHECKBOX:
    "I agree to ipaymy’s Payment Collection \u003ca\u003eTerms and Conditions.\u003c/a\u003e",
  IPAYMY_TERM_ERROR:
    "In order to use this service you must agree to this term.",
  IRAS_TAX_TOOLTIP:
    "For your convenience, IRAS has been added as a supplier for your tax payments.",
  IRAS_TOOLTIP:
    "Click here to easily pay tax to \u003cb\u003eIRAS.\u003c/b\u003e",
  JP_ACCOUNT_NUMBER_MAX_LENGTH_ERROR: "Please enter fewer than 7 numbers.",
  LABEL_ADD_CARD_TO_WALLET: "ADD A CREDIT CARD ",
  LABEL_ADD_COMPANY: "Add New Company",
  LABEL_AGREE_TC: "I agree to ipaymy Terms and Conditions and Privacy Policy.",
  LABEL_AGREE_TC_1:
    "I agree to ipaymy {term_and_condition} and {privacy_policy}.",
  LABEL_AGREE_TC_2: "Terms and Conditions",
  LABEL_AGREE_TC_3: "Privacy Policy",
  LABEL_BENEFICIARY_STATEMENT: "Note to Landlord",
  LABEL_BTN_ADD_NEW_COMPANY: "Add New Company",
  LABEL_BTN_SIGN_OUT: "Sign Out",
  LABEL_CARD_CHARGED: "Card Charged.",
  LABEL_CARD_CVC_INSTRUCTION:
    "A 3-digit code usually found on the back of your card.",
  LABEL_CARD_HOLDER: "Cardholder name",
  LABEL_CARD_TO_BE_CHARGED: "Card to be Charged",
  LABEL_CHANGE_PASSWORD: "Change Password",
  LABEL_CHECKOUT_CARD_STATEMENT: "Description on Your Card Statement",
  LABEL_CHECKOUT_COUPON_CODE: "Promo code",
  LABEL_CHECKOUT_FEE: "Fee ({percentage}%)",
  LABEL_CHECKOUT_PAY_WITH_ANOTHER_CARD: "Pay With Another Card",
  LABEL_COMPANY_REGISTRATION_NUMBER: "Company registration number",
  LABEL_CREATE_INVOICE: "Create your invoice",
  LABEL_DASHBOARD_PAYMENT_EMPTY: "No payments yet. ",
  LABEL_EDIT_COMPANY: "Edit Company",
  LABEL_EDIT_PROPERTY: "Edit Property",
  LABEL_EMPLOYEE_SUMMARY: "Employee Summary",
  LABEL_END_OF_DAY: "end of business day",
  LABEL_GET_STARTED_MAKING_PAYMENT: "GET STARTED WITH MAKING A PAYMENT",
  LABEL_GET_STARTED_MAKING_PAYMENT_1: "GET STARTED",
  LABEL_GET_STARTED_MAKING_PAYMENT_2: "WITH MAKING A PAYMENT",
  LABEL_INVOICE_SCHEDULE_BENIFICIARY:
    "Your card will be charged on {render1}. Your supplier will receive the funds by {render2} on {render3}.",
  LABEL_INVOICE_SCHEDULE_BENIFICIARY_TODAY:
    "Your card will be charged today. Your supplier will receive the funds by {render1} on {render2}.",
  LABEL_IPM_BUSINESS_ACCOUNT: "ipaymy Business Account",
  LABEL_IPM_PERSONAL_ACCOUNT: "ipaymy Personal Account",
  LABEL_MAKE_PAYMENT_RECURRYING: "MAKE YOUR PAYMENTS RECURRING",
  LABEL_MENU_ADMIN: "Admin",
  LABEL_MENU_COMPANIES: "Companies",
  LABEL_MENU_DASHBOARD: "Dashboard",
  LABEL_MENU_EMPLOYEES: "Employees",
  LABEL_MENU_MY_WALLET: "My Wallet",
  LABEL_MENU_PAYMENTS: "Payments",
  LABEL_MENU_PROPERTIES: "Properties",
  LABEL_MENU_SCHEDULED: "Scheduled",
  LABEL_MENU_SUPPLIERS: "Suppliers",
  LABEL_MENU_SUPPORT: "Support",
  LABEL_MONEY_TRANSFER: "Money Transfer",
  LABEL_MY_ACCOUNT: "My Account",
  LABEL_MY_COMPANIES: "My Companies",
  LABEL_NOTE_TO_LANDLORD: "Note to Landlord",
  LABEL_OLD_CARD_TOKEN_ARCHIVED_NOTIFICATION:
    "We recently updated our platform, which requires you to re-add existing cards to your wallet. These changes won't impact any payments that were already scheduled.",
  LABEL_PAGINATION: "Page {{.idx}} of {{.length}}",
  LABEL_PASSWORD: "Confirm Password",
  LABEL_PAYMENT_DETAIL_DISCOUNT: "Discount",
  LABEL_PAYMENT_DETAIL_FEE: "Fee",
  LABEL_PAYMENT_DETAIL_FEE_TOTAL: "Fee Total",
  LABEL_PAYMENT_SCHEDULE_SUCCESS_1: "Yay! Payment successfully scheduled!",
  LABEL_PAYMENT_SCHEDULE_SUCCESS_2:
    "Your card will be charged on {charged_date} and your landlord will receive the payment on {payout_date}.",
  LABEL_PAYMENT_SCHEDULE_SUCCESS_2_RENT:
    "Your card will be charged on {charged_date} and your landlord will receive the payment on {payout_date}.",
  LABEL_PAYMENT_SCHEDULE_SUCCESS_3:
    "Your card will be charged on {charged_date} and your {recipient} will receive the payment on {payout_date}.",
  LABEL_PAY_YOUR_EMPLOYEE: "Pay your employee",
  LABEL_PAY_YOUR_LANDLORD: "Pay your landlord",
  LABEL_PAY_YOUR_SUPPLIER: "Pay your supplier",
  LABEL_PAY_YOUR_TAX: "Pay your tax",
  LABEL_RECOMMENT_ADD_CARD_DESC:
    "Make payments quick and easy by adding a card to your wallet.",
  LABEL_RECOMMENT_SCHEDULE_PAYMENT_DESC:
    "Save time and enjoy a better rate with recurring  payments.",
  LABEL_RECOMMENT_SUPPORT_DESC: "Contact us via live chat or email.",
  LABEL_RECOMMENT_VIEW_PAYMENT_DESC: "View and manage payment information. ",
  LABEL_RECOMMENT_VIEW_PAYMENT_TITLE: "VIEW PAYMENT STATUS",
  LABEL_REGISTER_SELECT_COUNTRY: "Select your location",
  LABEL_REMEMBER_ME: "Remember me",
  LABEL_RENT_BENEFICIARY_STATEMENT: "Note to Landlord",
  LABEL_RENT_SCHEDULE_BENIFICIARY:
    "Your card will be charged on {render1}. Your landlord will receive the funds by {render2} on {render3}.",
  LABEL_RENT_SCHEDULE_BENIFICIARY_TODAY:
    "Your card will be charged today. Your landlord will receive the funds by {render1} on {render2}.",
  LABEL_SALARY_SCHEDULE_BENIFICIARY:
    "Your card will be charged on {render1}. Your employee will receive the funds by {render2} on {render3}.",
  LABEL_SALARY_SCHEDULE_BENIFICIARY_TODAY:
    "Your card will be charged today. Your employee will receive the funds by {render1} on {render2}.",
  LABEL_SCHEDULE_BENIFICIARY:
    "Your card will be charged {charged_date}. Your landlord will receive the funds by end of business day on {payout_date}.",
  LABEL_SCHEDULE_BENIFICIARY_TODAY:
    "Your card will be charged today. Your landlord will receive the funds by end of business day on {payout_date}.",
  LABEL_SCHEDULE_YOUR_PAYMENT: "Schedule your payment",
  LABEL_SCHEDULE_YOUR_PAYMENTS: "Schedule your payment",
  LABEL_SELECT_PAYOUT_DATE: "Select Payout Date",
  LABEL_SELECT_PAYOUT_DATES: "Select Payout Date(s)",
  LABEL_SMS_REQUEST: "SMS Request",
  LABEL_TRANSACTION_SUCCESSFUL:
    "Your card has been successfully charged. Your payment will be made by {payout_date}.",
  LABEL_TRANSACTION_SUCCESSFUL_RECEIPT_NUMBER:
    "Receipt Number: {receipt_number}",
  LABEL_TRY_IPM_FOR_BUSINESS: "Try ipaymy for Business",
  LABEL_UPLOAD_CSV_FILE_TIP:
    'Tip: Save "Account Number" cells as TEXT format and save file type as CSV.',
  LABEL_UPLOAD_INVOICE: "Upload your invoice",
  LANDLORD_NAME_LABEL: "Landlord Name",
  LANDLORD_NAME_PLACEHOLDER: "Landlord Name",
  LANDLORD_NOTE_PLACEHOLDER:
    "Description to appear on your beneficiary's statement",
  LAST_NAME_ERROR: "Please enter your last name",
  LAST_NAME_PLACEHOLDER: "Last Name",
  LEGEND_INCOMING_PAYMENT: "\u003cb\u003eIncoming\u003c/b\u003e Payment",
  LEGEND_OUTGOING_PAYMENT: "\u003cb\u003eOutgoing\u003c/b\u003e Payment",
  LIMIT_PAYMENT_UNIONPAY_7399:
    "Please note that a maximum amount of US$5,000 or its equivalent applies to all salary or invoice payments if you choose to pay with a China UnionPay credit card.",
  LOADING_STATUS: "Loading...",
  MADE_MULTIPLE_PAYMENTS_LABEL:
    "Multiple payments have been made to this supplier",
  MADE_MULTIPLE_PAYMENTS_TOOLTIP:
    "Since you have made recurring payments to this supplier you maybe eligible for occasionally lower fees.",
  MALAYSIAN_LABEL: "Malaysian",
  MASTERCARD_LABEL: "Mastercard",
  MAYBE_LATER: "Maybe Later",
  MINIMUM_INSURANCE_AMOUNT_SG: "Minimum invoice amount S$15.",
  MINIMUM_INVOICE_AMOUNT_AU: "Minimum invoice amount A$15.",
  MINIMUM_INVOICE_AMOUNT_AU_PAYMENT_COLLECTION: "Minimum invoice amount A$30.",
  MINIMUM_INVOICE_AMOUNT_HK: "Minimum invoice amount HK$80.",
  MINIMUM_INVOICE_AMOUNT_HK_PAYMENT_COLLECTION: "Minimum invoice amount HK$50.",
  MINIMUM_INVOICE_AMOUNT_HK_USD: "Minimum invoice amount US$10.",
  MINIMUM_INVOICE_AMOUNT_MY: "Minimum invoice amount is RM30.",
  MINIMUM_INVOICE_AMOUNT_MY_PAYMENT_COLLECTION: "Minimum invoice amount RM100.",
  MINIMUM_INVOICE_AMOUNT_SG: "Minimum invoice amount S$15.",
  MINIMUM_INVOICE_AMOUNT_SG_PAYMENT_COLLECTION: "Minimum invoice amount S$30.",
  MINIMUM_INVOICE_AMOUNT_USD_PAYMENT_COLLECTION:
    "Minimum invoice amount US$1.00.",
  MINIMUM_INVOICE_AMOUNT_WALLEX:
    "The minimum amount for this payment is S$50 equivalent.",
  MINIMUM_RENT_AMOUNT_AU: "Minimum rental amount A$200.",
  MINIMUM_RENT_AMOUNT_HK: "Minimum rental amount HK$1,700.",
  MINIMUM_RENT_AMOUNT_HK_USD: "Minimum rental amount US$200.",
  MINIMUM_RENT_AMOUNT_MY: "Minimum rental amount RM500.",
  MINIMUM_RENT_AMOUNT_SING: "Minimum rental amount S$300.",
  MINIMUM_RENT_AMOUNT_WALLEX:
    "The minimum amount for this payment is S$300 equivalent.",
  MINIMUM_SALARY_AMOUNT_AU: "Minimum salary amount is A$15.",
  MINIMUM_SALARY_AMOUNT_HK: "Minimum salary amount is HK$80.",
  MINIMUM_SALARY_AMOUNT_HK_USD: "Minimum salary amount is US$10.",
  MINIMUM_SALARY_AMOUNT_MY: "Minimum salary amount is RM30.",
  MINIMUM_SALARY_AMOUNT_SG: "Minimum salary amount is S$15.",
  MINIMUM_SALARY_BUSINESS_AMOUNT_AU: "Minimum salary amount is A$15.",
  MINIMUM_SALARY_BUSINESS_AMOUNT_HK: "Minimum salary amount is HK$80.",
  MINIMUM_SALARY_BUSINESS_AMOUNT_HK_USD: "Minimum salary amount is US$10.",
  MINIMUM_SALARY_BUSINESS_AMOUNT_MY: "Minimum salary amount is RM30.",
  MINIMUM_SALARY_BUSINESS_AMOUNT_SG: "Minimum salary amount is S$15.",
  MINIMUM_SELF_TRANSFER_AMOUNT_WALLEX:
    "The minimum amount for this payment is S$50 equivalent.",
  MISSING_INCORPORATION_DATE_ERROR:
    "An incorporation date is required for international payments.",
  MISSING_REGION_OR_CITY_ERROR:
    "Please select a region and city for this payment.",
  MOBILE_NUMBER_ERROR: "Please enter your mobile number",
  MOBILE_NUMBER_PLACEHOLDER: "Mobile Number",
  MONEY_TRANSFER_BUTTON: "Money Transfer",
  MORE_BUTTON: "More",
  MULTIPLE_EMPLOYEES_ONE_CURRENCY:
    "You can only pay multiple employees in \u003cb\u003eone\u003c/b\u003e currency.",
  MULTIPLE_PROPERTIES_ONE_CURRENCY:
    "You can only pay multiple properties in \u003cb\u003eone\u003c/b\u003e currency.",
  MULTIPLE_RECIPIENTS: "Multiple Recipients",
  MYINFO_ERROR_HERO: "We are unable to retrieve your information from Myinfo.",
  MYINFO_ERROR_INSTRUCTIONS:
    "You need to verify your identity to make a payment.{br}You can try again later by visiting Myinfo portal at \u003ca1\u003emyinfo.gov.sg\u003c/a1\u003eor contact \u003ca2\u003esupport@myinfo.gov.sg\u003c/a2\u003e{br}if you require additional assistance.",
  MYINFO_HERO: "Verify your identity using Myinfo",
  MYINFO_INSTRUCTIONS:
    "By accessing Myinfo via Singpass, your personal data will be automatically retrieved and relevant fields will be pre-filled, making verifying your identity faster and more convenient.",
  MYINFO_LOGIN_BUTTON: "Log in via Singpass",
  MYINFO_VERIFICATION_ADDRESS: "Registered Address",
  MYINFO_VERIFICATION_DOB: "Date of Birth",
  MYINFO_VERIFICATION_HERO:
    "Please note that information retrieved from Myinfo cannot be edited.",
  MYINFO_VERIFICATION_MOBILE: "Mobile Number",
  MYINFO_VERIFICATION_NAME_LABEL: "Name",
  MYINFO_VERIFICATION_NATIONALITY: "Nationality",
  MYINFO_VERIFICATION_NRIC_LABEL: "NRIC/FIN",
  MYINFO_VERIFICATION_PASSPORT_EXPIRY: "Passport Expiry Date",
  MYINFO_VERIFICATION_PASSPORT_NUMBER: "Passport Number",
  MYINFO_VERIFICATION_PASS_EXPIRY: "Pass Expiry Date",
  MYINFO_VERIFICATION_PASS_TYPE: "Pass Type",
  MYINFO_VERIFICATION_RESIDENTIAL_STATUS: "Residential Status",
  MYINFO_VERIFICATION_SEX: "Sex",
  MYINFO_VERIRIFCATION_REQUIRED: "Myinfo verification required",
  MY_FEATURE_UNSUPPORTED_ERROR:
    "Does not support this feature for Malaysian market",
  MY_LABEL_END_OF_DAY: "end of business day",
  NET_AMOUNT_LABEL: "Net Amount",
  NEW_BADGE: "NEW",
  NEW_GREETING_NAVBAR: "Hello, {render}!",
  NEW_LABEL_INVOICE_SCHEDULE_BENIFICIARY:
    "Your card will be charged on {render1}. Your supplier will receive the funds by {render2} on:{render3}",
  NEW_LABEL_INVOICE_SCHEDULE_BENIFICIARY_TODAY:
    "Your card will be charged today. Your supplier will receive the funds by {render1} on:{render2}",
  NEW_LABEL_RENT_SCHEDULE_BENIFICIARY:
    "Your card will be charged on {render1}. Your landlord will receive the funds by {render2} on:{render3}",
  NEW_LABEL_RENT_SCHEDULE_BENIFICIARY_TODAY:
    "Your card will be charged today. Your landlord will receive the funds by {render1} on:{render2}",
  NEW_LABEL_SALARY_BUSINESS_SCHEDULE_BENIFICIARY:
    "Your card will be charged on {render1}. Your funds will be in your business bank account by {render2} on:{render3}",
  NEW_LABEL_SALARY_BUSINESS_SCHEDULE_BENIFICIARY_TODAY:
    "Your card will be charged today. Your funds will be in your business bank account by {render1} on:{render2}",
  NEW_LABEL_SALARY_SCHEDULE_BENIFICIARY:
    "Your card will be charged on {render1}. Your employee will receive the funds by {render2} on:{render3}",
  NEW_LABEL_SALARY_SCHEDULE_BENIFICIARY_TODAY:
    "Your card will be charged today. Your employee will receive the funds by {render1} on:{render2}",
  NEW_LABEL_TRANSACTION_SUCCESSFUL_RECEIPT_NUMBER: "Receipt Number: {render}",
  NEW_PASSWORD_PLACEHOLDER: "New Password",
  NEW_TOTAL_HEADER: "New Total",
  NEW_VERIFICATION_LINK:
    "The email verification link you used has expired, click the button below to get a new link.",
  NEXT_BUTTON: "Next",
  NOTE_CREATE_SUPPLIER_ABN_APPROVED:
    "Your ABN{regno} application has been approved. Any on-hold payments to this supplier will now be processed.",
  NOTE_CREATE_SUPPLIER_ABN_DECLINED:
    "Your ABN{regno} application has been declined. Please reach out to our live chat for more information.",
  NOTE_CREATE_SUPPLIER_ABN_REQUEST:
    "Your ABN application {regno} is being reviewed at the moment, this will usually not take more than a few business hours. Please note that any payments to this supplier will be placed on hold while we verify your application request.",
  NOTE_CREATE_SUPPLIER_CRN_APPROVED:
    "Your CRN{regno} application has been approved. Any on-hold payments to this supplier will now be processed.",
  NOTE_CREATE_SUPPLIER_CRN_DECLINED:
    "Your CRN{regno} application has been declined. Please reach out to our live chat for more information.",
  NOTE_CREATE_SUPPLIER_CRN_REQUEST:
    "Your CRN application {regno} is being reviewed at the moment, this will usually not take more than a few business hours. Please note that any payments to this supplier will be placed on hold while we verify your application request.",
  NOTE_CREATE_SUPPLIER_UEN_APPROVED:
    "Your UEN{regno} application has been approved. Any on-hold payments to this supplier will now be processed.",
  NOTE_CREATE_SUPPLIER_UEN_DECLINED:
    "Your UEN{regno} application has been declined. Please reach out to our live chat for more information.",
  NOTE_CREATE_SUPPLIER_UEN_REQUEST:
    "Your UEN application {regno} is being reviewed at the moment, this will usually not take more than a few business hours. Please note that any payments to this supplier will be placed on hold while we verify your application request.",
  NOTE_LABEL: "Note to employee",
  NOTE_PLACEHOLDER: "Description to appear on your employee's bank statement",
  NOTICE_OF_ASSESSMENT_LABEL:
    "Notice of Assessment \u003cspan\u003eor\u003c/span\u003e Statement of Account",
  NOTIFY_SUPPLIER_CHECKBOX:
    "Would you like to notify your supplier that a payment has been initiated?",
  NOT_AFFILIATED_CHECKBOX:
    "I confirm I am not affiliated with this business and all payments made to this supplier are for legitimate goods and services.",
  NOT_INPROGRESS_PAYMENT_ERROR: "This payment status is not in-progress",
  NO_CHECKBOX: "No",
  NO_PIN_RECEIVED: "Didn't receive a PIN?",
  NRIC_LABEL: "NRIC",
  NRIC_PLACEHOLDER: "Employee's NRIC",
  NUMBER_OF_MOBILE_VERIFICATION_ATTEMPTS_EXCEEDED:
    "Number of mobile verification attemps excceded. Please {contact_link} for assistance.",
  NUMBER_OF_MOBILE_VERIFICATION_ATTEMPTS_EXCEEDED_ERROR:
    "Number of mobile verification attemps exceeded. Please {contact_link} for assistance.",
  ONLY_HONGKONG_ISSUER_UNIONPAY:
    "Only Hong Kong–issued UnionPay cards are supported.",
  ONLY_MALAYSIA_ISSUER: "Please use a valid Malaysian credit card.",
  ONLY_MALAYSIA_ISSUER_MASTERCARD:
    "We currently only accept Malaysian issued Mastercard.",
  ONLY_MY_FEATURE_SUPPORTED_ERROR:
    "Only support this feature for Malaysian market",
  ONLY_VISA_MASTERCARD: "We currently only accept Visa and Mastercard.",
  ONLY_VISA_MASTERCARD_AMEX:
    "We currently only accept Visa, Mastercard and Amex.",
  ONLY_VISA_MASTERCARD_UNIONPAY:
    "We currently only accept Visa, Mastercard and China UnionPay.",
  ONLY_VISA_MASTERCARD_UNIONPAY_AMEX:
    "We currently only accept Visa, Mastercard, China UnionPay, and Amex.",
  OPTIONAL_NOTE_TO_SUPPLIER: "Note to Supplier (Optional)",
  ORDER_NUMBER_LABEL: "Order Number",
  OVERDUE_PAYMENT: "Your payment is past the invoice due date.",
  PASSWORD_CONFIRM_DOES_NOT_MATCH: "Passwords do not match",
  PASSWORD_MINIMUM_ERROR:
    "Please choose a stronger password with at least 8 characters consisting of letters, numbers and symbols.",
  PASSWORD_PLACEHOLDER: "Password",
  PASSWORD_RESET_INSTRUCTIONS:
    "We'll send you instructions to reset your password.",
  PAYEE_ALREADY_EXISTS: "You've already added this recipient.",
  PAYEE_BANK_ACCOUNT_HOLDER: "Bank Account Holder Name",
  PAYEE_DETAILS_BANK_ACCOUNT: "Account",
  PAYEE_DETAILS_BANK_NAME: "Bank",
  PAYEE_EMPLOYEE: "Employee",
  PAYEE_NOT_FOUND_ERROR:
    "We could not find your payment recipient. Please contact us through support@ipaymy.com for details.",
  PAYEE_PROPERTY: "Property Address",
  PAYEE_SUPPLIER: "Supplier",
  PAYER_EXIST: "This customer already exists.",
  PAYING: "Paying",
  PAYMENTS_ACCOUNT_HEADER: "Account No.",
  PAYMENTS_BANK_HEADER: "Bank",
  PAYMENTS_CARD_LABEL: "Card Charged",
  PAYMENTS_COMPANY_LABEL: "Company",
  PAYMENTS_DESCRIPTION:
    "View details and status of your payments, or make a new payment.",
  PAYMENTS_DESCRIPTION_LABEL: "Description",
  PAYMENTS_EXCHANGE_RATE_LABEL: "Exchange Rate",
  PAYMENTS_HERO: "MY PAYMENTS",
  PAYMENTS_MENU_ITEM: "Payments",
  PAYMENTS_NOTE_TRANSFER: "Payment Reference",
  PAYMENTS_PROMOTIONS_ITEM: "Promotions",
  PAYMENTS_PURPOSE_INVOICE: "Invoice Payment",
  PAYMENTS_PURPOSE_RENTAL: "Rental Payment",
  PAYMENTS_PURPOSE_SALARY: "Salary Payment",
  PAYMENTS_PURPOSE_TRANSFER: "Money Transfer",
  PAYMENTS_RECEIPT_HEADER: "Receipt No.",
  PAYMENTS_RECEIPT_LABEL: "Receipt",
  PAYMENTS_TOTAL_LABEL: "Total Amount",
  PAYMENTS_VIEW_BUTTON: "View",
  PAYMENT_ARRIVE_LABEL: "Your payment will arrive by (SGT)",
  PAYMENT_BLOCKED_ERROR:
    "Payments made on this card are not supported on ipaymy. You may contact us for more information.",
  PAYMENT_CANCELLED_DESCRIPTION:
    "Oops! Looks like this payment request has been cancelled by \u003cspan\u003ecompany name\u003c/span\u003e{br}No further action required here!",
  PAYMENT_CANCELLED_HERO: "PAYMENT REQUEST CANCELLED",
  PAYMENT_CARD_UNSUPPORTED_3DS_ERROR:
    "Payments made on this card are not supported on ipaymy. You may contact us for more information.",
  PAYMENT_COLLECTION_CARD_HEADER: "Enter Card Details",
  PAYMENT_COLLECTION_FEE_TOOLTIP:
    "This is a processing fee the merchant charges for accepting credit card payments.",
  PAYMENT_COLLECTION_HERO: "Payment Summary For Your Payment to",
  PAYMENT_COLLECTION_PAY_INVOICE_BUTTON: "Pay Invoice Now",
  PAYMENT_COLLECTION_PCI:
    "ipaymy is a secure platform. All of our payments are made using industry-leading encryption over PCI compliant networks to ensure your privacy is protected.",
  PAYMENT_CONFIRMATION_CONTACT: "For inquiries, please contact us at",
  PAYMENT_CONFIRMATION_GO_TO_IPAYMY:
    "\u003ca\u003eGo to ipaymy\u003c/a\u003e\u003cp\u003eGet started with ipaymy's one-stop cash flow management platform.\u003c/p\u003e",
  PAYMENT_CONFIRMATION_LEARN: "Learn more about",
  PAYMENT_CONFIRMATION_RECEIPT: "Receipt Number",
  PAYMENT_CONFIRMATION_REDIRECT_MESSAGE:
    " If you are not redirected to {render} in 10 seconds, \u003ca\u003eclick here\u003c/a\u003e.",
  PAYMENT_CONFIRMATION_SUCCESS: "PAYMENT SUCCESSFUL",
  PAYMENT_CONFIRMATION_THANKS:
    "Thank you for paying through ipaymy, a receipt with your payment details has been sent to your email.",
  PAYMENT_CONFIRMATION_TRY:
    "\u003ca\u003eTry ipaymy now\u003c/a\u003e\u003cp\u003eGet started today and use your credit card to pay{br} rent, salaries, invoices, and more.\u003c/p\u003e",
  PAYMENT_CONFIRMATION_TRY_BUTTON: "Try ipaymy now",
  PAYMENT_DESCRIPTION_INVALID_AMEX:
    "Please refine your payment description for use with Amex, or keep your original payment description and select another card brand.",
  PAYMENT_DESCRIPTION_LABEL: "Payment Description",
  PAYMENT_DETAILS_HERO: "Payment Details",
  PAYMENT_DETAILS_TOOLTIP: "Click to view more details.",
  PAYMENT_FAILED_EMAIL_REASON:
    "There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  PAYMENT_FAILED_HERO: "Oops! Payment Failed.",
  PAYMENT_INTEREST_BE_PAID:
    "\u003cb\u003eBe Paid\u003c/b\u003e by my customers through credit card acceptance",
  PAYMENT_INTEREST_BOTH: "Both",
  PAYMENT_INTEREST_ERROR: "Please select a response.",
  PAYMENT_INTEREST_INSTRUCTIONS:
    "In order to provide you a more personalised experience, we’d like to know what are you interested in using ipaymy for?",
  PAYMENT_INTEREST_PAY:
    "\u003cb\u003ePay\u003c/b\u003e my expenses with my credit card",
  PAYMENT_LINK_FAIL_HERO: "PAYMENT LINK FAILED",
  PAYMENT_LINK_FAIL_MESSAGE: "There is an error with this payment link.",
  PAYMENT_MAKE_ALREADY_DESCRIPTION: "You have already made this payment.",
  PAYMENT_MAKE_ALREADY_HERO: "PAYMENT ALREADY MADE",
  PAYMENT_MAKE_ALREADY_LOGIN_BUTTON: "Login",
  PAYMENT_MAKE_ALREADY_THANKS: "Thank you for paying through ipaymy.",
  PAYMENT_OVERDUE_HERO: "PAYMENT OVERDUE",
  PAYMENT_OVERDUE_MESSAGE:
    "This payment is overdue and the payment link is no longer available.",
  PAYMENT_PAID_DATE: "Paid Date",
  PAYMENT_PAID_HERO: "MARK PAYMENT AS PAID",
  PAYMENT_PAID_ORDER_NUMBER: "Order Number: ",
  PAYMENT_PROCESSED_ERROR: "Payment has already been processed.",
  PAYMENT_REFERENCE_LABEL: "Payment Reference",
  PAYMENT_REQUEST_FAILED:
    "\u003cspan1\u003eNotification:\u003c/span1\u003e Payment request (invoice number {render1}) failed. Please check and update your customer's {render2} \u003cspan2\u003ehere\u003c/span2\u003e.",
  PAYMENT_SUCCESSFUL_HERO: "Yay! Transaction successful!",
  PAYMENT_SUCCESSFUL_INSTRUCTIONS:
    "Your card has been successfully charged. Your payment will be made by",
  PAYMENT_SUMMARY_LABEL: "Payment Summary",
  PAYMENT_TECHNICAL_ISSUE_ERROR:
    "There was a technical issue with your payment. You can contact us for more details anytime.",
  PAYMENT_TO_LABEL: "Payment to {value}",
  PAYSLIP_EMPLOYEE_ID: "Employee's ID",
  PAYSLIP_EMPLOYEE_ID_HKID: "Employee’s ID Number (i.e. HKID Number)",
  PAYSLIP_EMPLOYEE_ID_MYKAD: "Employee’s ID Number (i.e. MyKad Number)",
  PAYSLIP_EMPLOYEE_ID_NRIC: "Employee’s ID Number (i.e. NRIC Number)",
  PAYSLIP_EMPLOYEE_NAME: "Employee Name",
  PAYSLIP_LABEL:
    "\u003cspan\u003ePayslip or Employment Contract\u003c/span\u003e must include",
  PAY_BROWSER_WARNING:
    "Please avoid closing this browser window or refreshing this page until the payment completes.",
  PAY_BY_LABEL: "Pay by",
  PAY_CALENDAR_SUBTITLE: "Total Amount Paid This Month",
  PAY_CALENDAR_TITLE: "Payments Made",
  PAY_FEATURE_DISABLED_ERROR:
    "Payments are temporarily disabled while we make some product improvements. Thank you for your patience. We will notify you as soon as payments are available.",
  PAY_IN_LABEL: "\u003cb\u003ePAY\u003c/b\u003eIN",
  PAY_IN_NOW_LABEL:
    "\u003cb\u003ePAY\u003c/b\u003e AND MAKE A PAYMENT NOW TO A RECIPIENT IN",
  PAY_LABEL: "PAY",
  PAY_MENU_ITEM: "Pay",
  PAY_NEED_HELP_LABEL: "NEED HELP?",
  PAY_NOW_BUTTON: "Pay Now",
  PAY_RECOMMENDED_ACTIONS_SECTION:
    "\u003cb\u003eRECOMMENDED\u003c/b\u003e ACTIONS",
  PAY_TAX_TOOLTIP: "Pay Tax Here!",
  PAY_WAITING_TOO_LONG: "Waiting too long? Click here to try again.",
  PERSONAL_UNAVAILABLE: "Currently{br}Unavailable",
  POPUP_ACCEPT_PAYMENTS_BODY:
    "Accept invoice payments from your{br}customers using ipaymy's \u003cstrong\u003eBe Paid\u003c/strong\u003e{br}invoicing product and enjoy a 0% rate on{br}{render} in payments.",
  POPUP_AWESOME_PAYMENTS_BODY:
    "Awesome, free payments are coming your way!{br}You will receive an email with{br}more details shortly.",
  POPUP_BE_PAID_BUTTON: "Be Paid today",
  POPUP_CLAIM_BUTTON: "Claim Offer",
  POPUP_CONGRATULATIONS_BODY:
    "Congratulations, you qualify for \u003cstrong\u003e...\u003c/strong\u003e{br}in free payments! Would you like to claim this{br}limited time offer now?",
  POPUP_DASHBOARD_BODY:
    "Would you like to optimize your dashboard for managing contactless payments from your customers?",
  POPUP_DASHBOARD_HERO: "Optimize your dashboard",
  POPUP_EASY_PAYMENTS_BODY:
    "\u003cstrong\u003eEasy, Fast, and Free\u003c/strong\u003e card payments{br}direct to your bank account.",
  POPUP_FREE_PAYMENTS_HERO:
    "We'd like to send you{br}\u003cspan1\u003e...\u003c/span1\u003e for \u003cspan2\u003eFREE!\u003c/span2\u003e",
  POPUP_GOT_IT_BUTTON: "Got it",
  POPUP_NOT_NOW_BUTTON: "Not Now",
  POPUP_NO_THANKS_BUTTON: "No, Thanks",
  POPUP_START_ACCEPTING_BODY:
    "Start accepting invoice payments from{br}your customers using ipaymy's \u003cstrong\u003eBe Paid\u003c/strong\u003e{br} invoicing product and enjoy a 0% rate on{br}{render} in payments.",
  POPUP_YES_BUTTON: "Yes",
  POSTAL_CODE_LABEL: "Postal Code",
  POSTAL_CODE_PLACEHOLDER: "Postal Code",
  PO_NUMBER_LABEL: "P.O. Number",
  PO_NUMBER_PLACEHOLDER: "P.O. Number",
  PROGRAM_ENTERED_EARLY_ERROR: "Program already entered early",
  PROGRAM_NOT_FOUND: "Program not found",
  PROMO_CODE_PAYMENT_ROUTING_FAILED:
    "Something went wrong for this payment. Kindly contact us via live chat in the bottom right corner.",
  PROPERTIES_HERO: "MY PROPERTIES",
  PROPERTIES_MENU_ITEM: "Properties",
  PROPERTY_ACCOUNT_NUMBER_HEADER: "Account Number",
  PROPERTY_ADDRESS_HEADER: "Property Address",
  PROPERTY_AMOUNT_HEADER: "Amount",
  PROPERTY_BANK_HEADER: "Bank",
  PROPERTY_COUNTRY_HEADER: "Country",
  PROPERTY_DELETE_HERO: "Do you want to delete this property?",
  PROPERTY_DELETE_INSTRUCTIONS:
    "This property will be removed from your properties",
  PROPERTY_LANDLORD_HEADER: "Landlord",
  PROPERTY_NOTE_HEADER: "Note to Landlord",
  PROPERTY_SCHEDULED_PAYMENT_HERO:
    "This property is associated with a scheduled payment.",
  PROPERTY_SCHEDULED_PAYMENT_INSTRUCTIONS:
    "You need to cancel the associated payment before you edit the property details.",
  PURPOSE_BANK_LABEL: "bank account",
  PURPOSE_COLLECTION: "Collection",
  PURPOSE_EMPLOYEE_LABEL: "employee",
  PURPOSE_INTERNATIONAL: "International",
  PURPOSE_INVOICE: "Invoices",
  PURPOSE_MONEY_TRANSFER: "Money Transfer",
  PURPOSE_PARTNERSHIP: "Partnership",
  PURPOSE_PROPERTY_LABEL: "property",
  PURPOSE_RENT: "Rent",
  PURPOSE_SALARY: "Salary",
  PURPOSE_SALARY_BUSINESS: "Salary Business",
  PURPOSE_SUPPLIER_LABEL: "supplier",
  REFERRALS_MENU_ITEM: "Referrals",
  REFERRAL_BUSINESS_LABEL: "Number of Business Referrals",
  REFERRAL_BUSINESS_NOTE:
    "For every successful Business account referral, both parties will receive a promo code valued at {render}.",
  REFERRAL_BUSINESS_TOOLTIP:
    "This refers to total number of Business account referees that have successfully made a qualified payment.",
  REFERRAL_CODE_ERROR: "Please enter your referral code",
  REFERRAL_CODE_PLACEHOLDER: "Referral Code",
  REFERRAL_COPIED_LABEL: "Copied",
  REFERRAL_COPY_LABEL: "Copy",
  REFERRAL_COPY_LINK: "Copy the link below and share it with your referee.",
  REFERRAL_ENJOY_STEP: "Enjoy the Rewards",
  REFERRAL_HERO:
    "Earn up to \u003cstrong\u003e...\u003c/strong\u003e on every referral.",
  REFERRAL_INSTRUCTIONS:
    "For every qualified referee who makes a payment with ipaymy, we’ll give both of you a promotional code valued up to \u003cstrong\u003e...\u003c/strong\u003e.*",
  REFERRAL_JOIN_STEP: "Join Now",
  REFERRAL_PERSONAL_LABEL: "Number of Personal Referrals",
  REFERRAL_PERSONAL_NOTE:
    "For every successful Personal account referral, both parties will receive a promo code valued at {render}.",
  REFERRAL_PERSONAL_TOOLTIP:
    "This refers to total number of Personal account referees that have successfully made a qualified payment.",
  REFERRAL_SHARE_STEP: "Share Your Link",
  REFERRAL_SIGNUPS_LABEL: "Number of Sign-ups",
  REFERRAL_SIGNUPS_TOOLTIP:
    "This refers to total number of new signs up from your unique referral link.",
  REFERRAL_TCS_1:
    "Your referee must be a new user that has not registered for an ipaymy account before",
  REFERRAL_TCS_2:
    "For a referral to be successful, your referee needs to have completed a qualified payment on ipaymy. Please click \u003ca\u003ehere\u003c/a\u003e to find out more about the types of payments we accept.",
  REFERRAL_TCS_3:
    "Referral Promo Codes are valid for 30 days from the date of issuance",
  REFERRAL_TCS_4:
    "ipaymy reserves the right to not award rewards for users with multiple accounts",
  REFERRAL_TCS_LABEL: "Terms and conditions apply",
  REFERRAL_TCS_VIEW:
    "View full Terms and Conditions \u003ca\u003ehere\u003c/a\u003e.",
  REFER_FRIEND_BODY:
    "For every individual or business you refer who{br}makes a payment with ipaymy, we'll give both{br}of you a promotional code valued up to \u003cb\u003e{amount}\u003c/b\u003e!",
  REFER_FRIEND_HERO:
    "\u003cb\u003eRefer a Friend or Business\u003c/b\u003e and{br}\u003cb\u003eGet up to {amount}!\u003c/b\u003e",
  REFUNDED_AMOUNT_HEADER: "Refunded Amount",
  REFUNDED_FEE_HEADER: "Refunded Fee",
  REGION_LABEL: "Region",
  REGION_PLACEHOLDER: "Region",
  REGISTER_COMPANY_TOOLTIP: "Please register a company first.",
  REGISTER_FIRST: "Please register your company first",
  REGISTRATION_GRAPHIC_ACCOUNT_TYPE_BUSINESS: "Business Account",
  REGISTRATION_GRAPHIC_ACCOUNT_TYPE_PERSONAL: "Personal Account",
  REGISTRATION_GRAPHIC_BUSINESS_LINE_1:
    "Pay business expenses like office rent, payroll, invoices, and more",
  REGISTRATION_GRAPHIC_BUSINESS_LINE_2:
    "Send invoices and collect card payments from your customers",
  REGISTRATION_GRAPHIC_BUSINESS_LINE_3: "Advanced dashboard to manage AR/AP",
  REGISTRATION_GRAPHIC_BUSINESS_LINE_4: "Dedicated Customer Success Manager",
  REGISTRATION_GRAPHIC_BUSINESS_LINE_5: "Enjoy customised business pricing",
  REGISTRATION_GRAPHIC_BUSINESS_SIGNUP: "Sign up for a business account",
  REGISTRATION_GRAPHIC_FOOTNOTE: "*Country, bank and card scheme dependent.",
  REGISTRATION_GRAPHIC_HERO: "Sign up for the right account for you",
  REGISTRATION_GRAPHIC_PERSONAL_LINE_1:
    "Pay personal expenses like rent, tuition, condo fees, and more",
  REGISTRATION_GRAPHIC_PERSONAL_LINE_2:
    "Simplified dashboard to manage monthly expenses",
  REGISTRATION_GRAPHIC_PERSONAL_LINE_3:
    "Enjoy special promotions from credit card providers",
  REGISTRATION_GRAPHIC_PERSONAL_SIGNUP: "Sign up for a personal account",
  REGISTRATION_NO_COMPANY_NUMBER:
    "I don't have my registration number at the moment.",
  REGISTRATION_NUMBER_COLUMN: "Registration Number",
  REGISTRATION_NUMBER_LABEL: "Registration Number",
  REGISTRATION_NUMBER_PLACEHOLDER: "Registration Number",
  REMOVE_BUTTON: "Remove",
  RENTAL_AMOUNT_LABEL: "Rental Amount",
  RENT_BUTTON: "Rent",
  REQUEST_ANOTHER_PAYMENT_BUTTON: "Request Another Payment",
  REQUEST_CONFIRM_EMAIL_LABEL: "Confirm New Email",
  REQUEST_CONFIRM_EMAIL_PLACEHOLDER: "Confirm New Email",
  REQUEST_CONFIRM_MOBILE_LABEL: "Confirm Mobile Number",
  REQUEST_CONFIRM_MOBILE_PLACEHOLDER: "Confirm New Mobile Number",
  REQUEST_NEW_EMAIL_LABEL: "New Email",
  REQUEST_NEW_EMAIL_PLACEHOLDER: "New Email",
  REQUEST_NEW_MOBILE_LABEL: "New Mobile Number",
  REQUEST_NEW_MOBILE_PLACEHOLDER: "New Mobile Number",
  REQUEST_OLD_EMAIL_LABEL: "Old Email",
  REQUEST_OLD_MOBILE_LABEL: "Old Mobile Number",
  REQUEST_PAYMENT_BUTTON: "Request a Payment",
  REQUEST_PAYMENT_HERO: "\u003cb\u003eREQUEST\u003c/b\u003e A PAYMENT",
  REQUEST_RESEND_BUTTON: "Resend Payment Request",
  REQUEST_RESENT: "Your payment request has been resent to your customer.",
  REQUEST_RESENT_EMAIL:
    "Your payment request has been resent to the updated email address.",
  REQUEST_RESENT_MOBILE:
    "Your payment request has been resent to the updated mobile.",
  REQUEST_SENT_COPIED_CONFIRMATION: "Copied",
  REQUEST_SENT_COPY_BUTTON: "Copy",
  REQUEST_SENT_HERO: "Yay! Request successfully sent!",
  REQUEST_SENT_INSTRUCTIONS:
    "Your request for payment has been sent to your {render}. You will receive an email notification once you have been paid.",
  REQUEST_SENT_LINK: "Copy the link below and share it with your {render}",
  REQUEST_TO_LIST_NEW_COMPANY: "Request to List New Company",
  REQUEST_UPDATE_EMAIL_HERO: "UPDATE CUSTOMER'S EMAIL",
  REQUEST_UPDATE_MOBILE_HERO: "UPDATE CUSTOMER'S MOBILE NUMBER",
  REQUIRED_DOCUMENT_CAPITAL: "Capital Injection",
  REQUIRED_DOCUMENT_FUNDS: "Funds Required for Operations",
  REQUIRED_DOCUMENT_HEADER: "Required Document",
  REQUIRED_DOCUMENT_MESSAGE:
    "Please upload a statement regarding the purpose of funds transfer to your business entity abroad. This should be provided on company letter head.{br}Examples of acceptable purposes are:",
  REQUIRED_FIELD: "This field is required.",
  REQUIRED_FIELD_EMAIL: "An email is required",
  REQUIRED_FIELD_MOBILE_NUMBER: "A mobile number is required",
  REQUIRED_FIELD_PASSWORD: "A password is required",
  REQUIRE_CDD_KYC: "Please complete KYC first.",
  REQUIRE_MY_INFO_VERIFICATION: "Please verify your myinfo first.",
  RESEND_EMAIL_BUTTON: "Resend email",
  RESEND_PIN: "resend code",
  RESEND_VERIFICATION_EMAIL: "Resend verification email",
  RESENT_PIN: "We have sent you a new PIN. This may take a few minutes.",
  RESET_EMAIL_ADDRESS:
    "Enter the email address you used to sign up, we'll send you instructions to reset your password.",
  RESET_INSTRUCTIONS:
    "Instructions to reset your password have been sent to you. Please check your email.",
  RESET_PASSWORD_BUTTON: "Reset Password",
  RESET_PASSWORD_LINK: "Reset it here.",
  RESTRICTED_BUSINESS_INSTRUCTIONS:
    "Please confirm that the business you have selected does not fall within the scope of “Restricted Businesses”",
  RESTRICTED_FINANCIAL_EXAMPLE_1: "Investment \u0026 credit services",
  RESTRICTED_FINANCIAL_EXAMPLE_2: "Money and legal services",
  RESTRICTED_FINANCIAL_EXAMPLE_3: "Virtual currency or stored value",
  RESTRICTED_FINANCIAL_HEADER: "Financial and professional services such as",
  RESTRICTED_HIGH_RISK_EXAMPLE_1: "Bankruptcy lawyers",
  RESTRICTED_HIGH_RISK_EXAMPLE_2:
    "Computer technical support and IT help desks",
  RESTRICTED_HIGH_RISK_EXAMPLE_3: "Psychic Service",
  RESTRICTED_HIGH_RISK_EXAMPLE_4: "Travel reservation services and clubs",
  RESTRICTED_HIGH_RISK_EXAMPLE_5: "Airlines, Airfares and Cruises",
  RESTRICTED_HIGH_RISK_EXAMPLE_6: "Timeshares",
  RESTRICTED_HIGH_RISK_EXAMPLE_7:
    "Prepaid phone cards, phone services, and cell phones",
  RESTRICTED_HIGH_RISK_EXAMPLE_8:
    "Telemarketing, telecommunications equipment and telephone sales",
  RESTRICTED_HIGH_RISK_EXAMPLE_9: "Foreclosure and identity theft protection",
  RESTRICTED_HIGH_RISK_HEADER: '"High Risk" businesses such as',
  RESTRICTED_IP_EXAMPLE_1: "Adult content and services",
  RESTRICTED_IP_EXAMPLE_2: "Counterfeit or unauthorized goods",
  RESTRICTED_IP_EXAMPLE_3: "Essay Mills",
  RESTRICTED_IP_EXAMPLE_4: "Gambling",
  RESTRICTED_IP_EXAMPLE_5:
    "Intellectual property or proprietary rights infringement",
  RESTRICTED_IP_EXAMPLE_6: "Regulated or illegal products or services",
  RESTRICTED_IP_HEADER:
    "IP infringement, regulated or illegal products and services such as",
  RESTRICTED_OTHER_EXAMPLE_1: "Aggregation",
  RESTRICTED_OTHER_EXAMPLE_2:
    "Drug paraphernalia, substances designed to mimic illegal drugs and other pharmaceuticals",
  RESTRICTED_OTHER_EXAMPLE_3: "Embassy, consulate, other foreign governments",
  RESTRICTED_OTHER_EXAMPLE_4: "Multi-level marketing",
  RESTRICTED_OTHER_EXAMPLE_5:
    "Products designed to decrypt, descramble, or jam signals",
  RESTRICTED_OTHER_EXAMPLE_6:
    "Social media activity (i.e. sales of followers, likes etc)",
  RESTRICTED_OTHER_EXAMPLE_7: "Video game or virtual world credits",
  RESTRICTED_OTHER_EXAMPLE_8:
    "Any business or organization that a. engages in, encourages, promotes or celebrates unlawful violence or physical harm to persons or property, or b. engages in, encourages, promotes or celebrates unlawful violence toward any group based on race, religion, disability, gender, sexual orientation, national origin, or any other immutable characteristic",
  RESTRICTED_OTHER_HEADER: "Other products or services including",
  RESTRICTED_QUESTIONS:
    "If you have any questions about if your business can be supported through ipaymy's payment collection product please \u003ca\u003eget in touch with us.\u003c/a\u003e",
  RESTRICTED_UNFAIR_EXAMPLE_1: "Get rich quick schemes",
  RESTRICTED_UNFAIR_EXAMPLE_2:
    "Platforms facilitating publication and removal of content",
  RESTRICTED_UNFAIR_EXAMPLE_3: "No-value-added services",
  RESTRICTED_UNFAIR_HEADER: "Unfair, predatory, or deceptive practices such as",
  RETRY_BUTTON: "Retry",
  REVIEW_DETAILS_HERO: "Review Details and Send Request",
  SALARIES_BUTTON: "Salaries",
  SALARY_LABEL: "Salary",
  SAVE_AND_EXIT_BUTTON: "Save and Exit",
  SAVE_BUTTON: "Save Changes",
  SAVING_AND_EXITING_BUTTON: "Saving and exiting...",
  SCHEDULED_ACTIVE_PAYMENTS_BUTTON: "Active Payments",
  SCHEDULED_AMOUNT_HEADER: "Amount",
  SCHEDULED_ARCHIVED_PAYMENTS_BUTTON: "Archived Payments",
  SCHEDULED_AUTHORIZED_BODY:
    "As part of the authorisation process, you may see {br}a {render} pending charge on your bank statement. {br}Note that it is only temporary and will be {br}automatically reversed.",
  SCHEDULED_AUTHORIZED_HERO: "Yay! Payment has been authorised.",
  SCHEDULED_AUTHORIZED_INSTRUCTIONS:
    "You will receive \u003cb\u003ea confirmation email\u003c/b\u003e and \u003cb\u003ereceipt\u003c/b\u003e for the full amount within the next \u003cb\u003e30 minutes\u003c/b\u003e.",
  SCHEDULED_BANK_LABEL: "Bank",
  SCHEDULED_CANCEL_HERO:
    "Are you sure you want to cancel this scheduled payment?",
  SCHEDULED_CANCEL_INSTRUCTIONS:
    "You may not be able to enjoy this discounted rate again if you cancel.",
  SCHEDULED_CARD_HEADER: "Card",
  SCHEDULED_CATEGORY_HEADER: "Category",
  SCHEDULED_CHARGE_DATE_HEADER: "Charge Date",
  SCHEDULED_COPY_TOOLTIP:
    "Start date and end date are the first and last days your beneficiary will receive the funds. Your card will be charged 1 business day before these dates.",
  SCHEDULED_DESCRIPTION: "View and manage your scheduled payments",
  SCHEDULED_EDIT_ALL_HERO:
    "Edit Payment Details for \u003cb\u003eAll Upcoming Payments\u003c/b\u003e",
  SCHEDULED_EDIT_COUPON_LABEL: "Coupon Code",
  SCHEDULED_EDIT_ERROR_MESSAGE:
    "Your payment details have not been successfully updated. Please try again.",
  SCHEDULED_EDIT_ONE_HERO:
    "Edit Payment Details for \u003cb\u003eThis One Payment\u003c/b\u003e",
  SCHEDULED_EDIT_SELECT_CARD: "Select Card",
  SCHEDULED_END_HEADER: "End Date",
  SCHEDULED_FEE_HEADER: "Fee",
  SCHEDULED_FREQUENCY_HEADER: "Frequency",
  SCHEDULED_HERO: "SCHEDULED PAYMENTS",
  SCHEDULED_MENU_ITEM: "Scheduled",
  SCHEDULED_MULTIPLE_RECIPIENTS: "Multiple Recipients",
  SCHEDULED_NEW_PAYMENT_BUTTON: "Make A New Payment",
  SCHEDULED_NEXT_PAYMENT_BUTTON: "View Next Payment",
  SCHEDULED_NOTE_SUPPLIER_HEADER: "Note to Supplier",
  SCHEDULED_NO_BUTTON: "No",
  SCHEDULED_PAYEE_INVOICE_LABEL: "Supplier",
  SCHEDULED_PAYEE_RENTAL_LABEL: "Property Address",
  SCHEDULED_PAYEE_SALARY_LABEL: "Employee",
  SCHEDULED_PAYMENTS_BUTTON: "Scheduled Payments",
  SCHEDULED_PAYMENT_DETAILS_HERO: "Payment Details",
  SCHEDULED_PAYOUT_DATE_HEADER: "Payout Date",
  SCHEDULED_RECIPIENT_HEADER: "Recipient",
  SCHEDULED_START_HEADER: "Start Date",
  SCHEDULED_STATUS_HEADER: "Status",
  SCHEDULED_TOTAL_HEADER: "Total",
  SCHEDULED_UPDATED_MESSAGE:
    "Your payment details have been successfully updated.",
  SCHEDULED_YES_BUTTON: "Yes",
  SCHEDULE_END_DATE_LABEL: "End Date",
  SCHEDULE_FREQUENCY_LABEL: "Frequency",
  SCHEDULE_FREQUENCY_MONTHLY_ITEM: "Monthly",
  SCHEDULE_FREQUENCY_PLACEHOLDER: "Select Schedule Frequency",
  SCHEDULE_FREQUENCY_WEEKLY_ITEM: "Weekly",
  SCHEDULE_PAYMENT_BUTTON: "Schedule a Payment",
  SCHEDULE_PAYMENT_HERO: "\u003cb\u003eSCHEDULE\u003c/b\u003e A PAYMENT",
  SCHEDULE_START_DATE_LABEL: "Start Date",
  SCHEDULE_TYPE_LABEL: "Schedule Type",
  SCHEDULE_TYPE_ONE_TIME_ITEM: "One-Time Payment",
  SCHEDULE_TYPE_RECURRING_ITEM: "Recurring Payment",
  SEARCH_BANK_NO_RESULTS:
    "No matching banks found. Try another search, or contact us for support.",
  SEARCH_BANK_PLACEHOLDER: "Bank Name, Branch, or BSB",
  SEARCH_COMPANY_NAME_LABEL: "Company Name Search",
  SEARCH_COMPANY_NAME_PLACEHOLDER: "Company Name",
  SEARCH_COMPANY_NO_RESULTS:
    "No matching companies found. Try another search, or contact us for support.",
  SELECT_ACCOUNT_CREATED: "(Account created.)",
  SELECT_COMPANY_INSTRUCTIONS:
    "Select which company you would like to collect payments for",
  SELECT_COMPANY_PLACEHOLDER: "Select Company",
  SELECT_CUSTOMER_HERO: "SELECT CUSTOMER",
  SELECT_EMPLOYEE_HERO: "SELECT YOUR EMPLOYEES",
  SELECT_PROPERTY_HERO: "SELECT YOUR PROPERTY",
  SEND_BUTTON: "Send",
  SEND_BUTTON_TOOLTIP: "Please enter all the request details.",
  SEND_INVOICE_HERO: "SEND INVOICE",
  SEND_PASSWORD_REQUEST_BUTTON: "Send Request Password Instructions",
  SESSION_PAYMENT_TIMEOUT_ERROR:
    "Session timeout, please refresh and try again.",
  SETTINGS_ACCOUNT_AU_DESCRIPTION:
    "This must be a bank account in Australia that accepts AUD.",
  SETTINGS_ACCOUNT_HK_DESCRIPTION:
    "This must be a bank account in Hong Kong that accepts HKD.",
  SETTINGS_ACCOUNT_MY_DESCRIPTION:
    "This must be a bank account in Malaysia that accepts MYR.",
  SETTINGS_ACCOUNT_NUMBER: "Account Number",
  SETTINGS_ACCOUNT_SG_DESCRIPTION:
    "This must be a bank account in Singapore that accepts SGD.",
  SETTINGS_BANK_LABEL: "Bank",
  SETTINGS_BANK_STATEMENT_LABEL: "Bank Statement",
  SETTINGS_EMAIL_DESCRIPTION:
    "Please provide the email you would like all information regarding payments made to your account to be sent to",
  SETTINGS_FEE_CHANGE_HERO:
    "Change in fee structure will only apply to new requests.",
  SETTINGS_FEE_CHANGE_INSTRUCTIONS:
    "The fees for existing pending payment requests will not be updated.",
  SETTINGS_FEE_CHANGE_OKAY_BUTTON: "Okay",
  SETTINGS_HERO: "Account Settings",
  SETTINGS_MENU_ITEM: "Settings",
  SETTINGS_SUCCESS: "Your account settings have been successfully updated.",
  SETTING_BANK_CHANGE_MESSAGE:
    "In order to update your bank account details, please contact us at \u003ca\u003esupport@ipaymy.com\u003c/a\u003e",
  SETTING_BANK_DESCRIPTION:
    "The bank account you would like the funds to be deposited in",
  SIGNIN_BUTTON: "Sign in",
  SIGNIN_ERROR: "Invalid email/password combination, please try again.",
  SIGNIN_HERO: "Sign In",
  SIGNIN_LINK: "sign in",
  SIGNIN_SIGNUP_OPTION: "or {SIGNIN_LINK}",
  SIGNUP_BUSINESS: "Business",
  SIGNUP_BUTTON: "Sign up",
  SIGNUP_CLOSE: "Close",
  SIGNUP_HERO: "Sign up",
  SIGNUP_PERSONAL: "Personal",
  SIGNUP_SIGNIN_OPTION: "or \u003cstyling1\u003esign up\u003c/styling1\u003e",
  SIGNUP_SUCCESSFUL: "Registration Successful",
  SIGNUP_THANKS:
    "Thank you for signing up! An email has been sent to you with further verification details. Check your inbox to activate your account now!",
  SMS_MENU_ITEM: "SMS Request",
  SMS_REQUEST_BUTTON: "SMS Request",
  SMS_REQUEST_HEADER: "Enter Your Customer's Details",
  SMS_REQUEST_HERO: "ENTER DETAILS AND SEND ",
  SMS_REQUEST_HERO_PAYMENT_INVOICE: "INVOICE",
  SMS_REQUEST_HERO_PAYMENT_REQUEST: "PAYMENT REQUEST",
  SMS_SENDER_INSTRUCTIONS:
    "This information may appear in the SMS request your customer receives",
  SMS_SENDER_INSTRUCTIONS_EXTRA:
    "Specify the sender ID you want your customer to see in the SMS request, we recommend using a name your customer will recognize, such as the name of your business.",
  SMS_SENDER_LABEL: "SMS Sender ID",
  SMS_SENDER_PLACEHOLDER: "SMS Sender ID",
  SMS_SENDER_SECTION: "SMS Sender ID",
  SPLIT_FEE_HEADER: "How Do You Want to Split the Fee",
  SPLIT_FEE_INSTRUCTIONS:
    "Drag the slider to determine how much your company is going to pay",
  SPLIT_FEE_SECTION: "Split the Fee Between You and Your Customer",
  STATEMENT_DESCRIPTION_PLACEHOLDER: "Statement Descriptor",
  STATEMENT_DESCRIPTOR_LABEL: "Statement Descriptor",
  STATE_LABEL: "State/Province",
  STATE_PLACEHOLDER: "State/Province",
  STATUS_DRAFT_LABEL: "Draft",
  STATUS_SCHEDULED_LABEL: "Scheduled",
  STEP_1_OF_2: "Step 1 of 2",
  STEP_1_OF_3: "Step 1 of 3",
  STEP_1_OF_4: "Step 1 of 4",
  STEP_2_OF_2: "Step 2 of 2",
  STEP_2_OF_3: "Step 2 of 3",
  STEP_2_OF_4: "Step 2 of 4",
  STEP_3_OF_3: "Step 3 of 3",
  STEP_3_OF_4: "Step 3 of 4",
  STEP_4_OF_4: "Step 4 of 4",
  STRIPE_ERROR_AMOUNT_TOO_LARGE:
    "The specified amount is greater than the maximum amount allowed. Use a lower amount and try again",
  STRIPE_ERROR_CARD_DETAIL_INVALID:
    "Card details invalid, please provide a valid card number.",
  STRIPE_ERROR_CARD_NOT_SUPPORTED:
    "The card is not valid for this type of purchase.  Please try a different card or contact your issuer for more information.",
  STRIPE_ERROR_CARD_NOT_SUPPORT_001:
    "001. Your card does not support this payment type. Please contact customer support for more details.",
  STRIPE_ERROR_CARD_NOT_SUPPORT_002:
    "002. Your card does not support this payment type. Please contact customer support for more details.",
  STRIPE_ERROR_CARD_UNAUTHORIZED_APPROVE_WITH_ID:
    "The transaction cannot be authorized. Please try a different card or contact your issuer for more information.",
  STRIPE_ERROR_CARD_UNAUTHORIZED_INVALID_ACCT:
    "The transaction cannot be authorized. Please try a different card or contact your issuer for more information.",
  STRIPE_ERROR_CARD_UNAUTHORIZED_NEW_ACCT_INFO_AVAIL:
    "The transaction cannot be authorized. Please try a different card or contact your issuer for more information.",
  STRIPE_ERROR_CARD_UNAUTHORIZED_PROCESSED_ERROR:
    "The transaction cannot be authorized. Please try a different card or contact your issuer for more information.",
  STRIPE_ERROR_CARD_UNAUTHORIZED_REENTER_TXN:
    "The transaction cannot be authorized. Please try a different card or contact your issuer for more information.",
  STRIPE_ERROR_CARD_UNAUTHORIZED_REVOCATION:
    "The transaction cannot be authorized. Please try a different card or contact your issuer for more information.",
  STRIPE_ERROR_CARD_UNAUTHORIZED_REVOCATIONS:
    "The transaction cannot be authorized. Please try a different card or contact your issuer for more information.",
  STRIPE_ERROR_CARD_UNAUTHORIZED_SERVICE_NOT_ALLOWED:
    "The transaction cannot be authorized. Please try a different card or contact your issuer for more information.",
  STRIPE_ERROR_CARD_UNAUTHORIZED_STOP_PAYMENT_ORDER:
    "The transaction cannot be authorized. Please try a different card or contact your issuer for more information.",
  STRIPE_ERROR_CARD_UNAUTHORIZED_TRY_AGAIN_LATER:
    "The transaction cannot be authorized. Please try a different card or contact your issuer for more information.",
  STRIPE_ERROR_CARD_UNAUTHORIZED_TXN_NOT_ALLOWED:
    "The transaction cannot be authorized. Please try a different card or contact your issuer for more information.",
  STRIPE_ERROR_CHARGE_ALREADY_REFUNDED:
    "The charge you’re attempting to refund has already been refunded",
  STRIPE_ERROR_CHARGE_DISPUTED:
    "The charge you’re attempting to refund has been charged back",
  STRIPE_ERROR_DECLINED:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  STRIPE_ERROR_DECLINED_CALL_ISSUER:
    "The transaction was declined. Please contact your issuer for more information.",
  STRIPE_ERROR_DECLINED_CARD_VELOCITY_EXCEEDED:
    "The transaction was declined. Please contact your issuer for more information.",
  STRIPE_ERROR_DECLINED_DO_NOT_TRY_AGAIN:
    "The transaction was declined. Please contact your issuer for more information.",
  STRIPE_ERROR_DECLINED_LOST_CARD:
    "The transaction was declined. Please contact your issuer for more information.",
  STRIPE_ERROR_DECLINED_PICKUP_CARD:
    "The transaction was declined. Please contact your issuer for more information.",
  STRIPE_ERROR_DECLINED_RESTRICTED_CARD:
    "The transaction was declined. Please contact your issuer for more information.",
  STRIPE_ERROR_DECLINED_SECURITY_VIOLATION:
    "The transaction was declined. Please contact your issuer for more information.",
  STRIPE_ERROR_DECLINED_STOLEN_CARD:
    "The transaction was declined. Please contact your issuer for more information.",
  STRIPE_ERROR_DO_NOT_HONOR:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  STRIPE_ERROR_DO_NOT_HONOR_GENERIC_DECLINED:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  STRIPE_ERROR_DO_NOT_HONOR_NO_ACTION_TAKEN:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  STRIPE_ERROR_DUPLICATE_TRANSACTION:
    "A transaction with identical amount and credit card information was submitted recently. Transaction declined to ensure no duplicate payments occurred.",
  STRIPE_ERROR_EXCEEDING_WITHDRAW_LIMIT:
    "This transaction failed due to exceeding withdrawal limit. Please try another card.",
  STRIPE_ERROR_EXPIRED_CARD:
    "The card’s expiration is incorrect. Check the expiration date or use a different card.",
  STRIPE_ERROR_FRAUDULENT:
    "The transaction was declined. Please contact your issuer for more information.",
  STRIPE_ERROR_INCORRECT_CVC:
    "The card’s CVC/CVV is incorrect. Check the card’s security code or use a different card.",
  STRIPE_ERROR_INCORRECT_NUMBER:
    "The card number is incorrect. Check the card’s number or use a different card.",
  STRIPE_ERROR_INSUFFICIENT_FUND:
    "Payment failed due to insufficient credit. You may have reached the maximum credit limit on this credit card. Please adjust the payment amount or use another credit card.",
  STRIPE_ERROR_INVALID_CVC:
    "The card’s CVC/CVV is incorrect. Check the card’s security code or use a different card.",
  STRIPE_ERROR_INVALID_EXPIRY_MONTH:
    "The card’s expiration is incorrect. Check the expiration date or use a different card.",
  STRIPE_ERROR_INVALID_EXPIRY_YEAR:
    "The card’s expiration is incorrect. Check the expiration date or use a different card.",
  STRIPE_ERROR_ISSUER_NOT_AVAILABLE:
    "The transaction cannot be authorized. Please try again or use different card.  If unsucessful please contact your issuer.",
  STRIPE_ERROR_NOT_PERMITTED:
    "The card is not valid for this type of purchase.  Please try a different card or contact your issuer for more information.",
  STRIPE_ERROR_UNSUPPORTED_CURRENCY:
    "The card does not support the specified currency.  Please try another card or contact your issuer for more information.",
  SUBMIT_BUTTON: "Submit",
  SUBTOTAL_LABEL: "Subtotal",
  SUCCESS_ADD_ACCOUNT: "Log into your other accounts or register a new one.",
  SUCCESS_APPLIED_COUPON_REMOVED: "Coupon successfully removed.",
  SUCCESS_CARD_CREATED: "Card successfully added to your wallet.",
  SUCCESS_CARD_DELETED: "Card successfully deleted.",
  SUCCESS_CARD_EDITED: "Card successfully edited in your wallet.",
  SUCCESS_COMPANY_DELETED: "Company successfully deleted.",
  SUCCESS_COUPON_APPLIED: "Your coupon was applied.",
  SUCCESS_LOG_OUT: "Successfully logged out.",
  SUCCESS_PASSWORD_EDITED: "Password successfully updated.",
  SUCCESS_PAYEE_DELETED: "Payee has been deleted successfully",
  SUCCESS_PAYEE_EDITED: "Payee has been edited successfully",
  SUCCESS_PAYMENT_CANCELED: "Payment canceled successfully",
  SUCCESS_PAYMENT_MARKED_AS_COMPLETE: "Successfully Mark as Completed",
  SUCCESS_RATE_EDITED: "Rate updated",
  SUCCESS_SWITCH_ACCOUNT: "Log into your other accounts or register a new one.",
  SUGGESTED_BANK_ACCOUNT_LABEL: "Suggested Bank and Account Number",
  SUPPLIERS_HERO: "SUPPLIERS",
  SUPPLIERS_MENU_ITEM: "Suppliers",
  SUPPLIER_ABN_HEADER: "ABN",
  SUPPLIER_ABN_LABEL: "Supplier's Australian Business Number (ABN)",
  SUPPLIER_ABN_PLACEHOLDER: "Supplier's Australian Business Number (ABN)",
  SUPPLIER_ACCOUNT_NUMBER_HEADER: "Account Number",
  SUPPLIER_ACCOUNT_NUMBER_PLACEHOLDER: "Account Number",
  SUPPLIER_ALREADY_EXISTS: "Supplier already exists",
  SUPPLIER_BANK_ACCOUNT_LABEL: "Account Number",
  SUPPLIER_BANK_ACCOUNT_PLACEHOLDER: "Supplier's Bank Account Number",
  SUPPLIER_BANK_HEADER: "Bank",
  SUPPLIER_BANK_PLACEHOLDER: "Bank",
  SUPPLIER_BUSINESS_REGISTRATION_NUMBER_LABEL:
    "Supplier's Business Registration Number",
  SUPPLIER_BUSINESS_REGISTRATION_NUMBER_PLACEHOLDER:
    "Supplier's Business Registration Number",
  SUPPLIER_COLUMN: "Supplier",
  SUPPLIER_COMPANY_NAME_LABEL: "Supplier's company name",
  SUPPLIER_COMPANY_NAME_PLACEHOLDER: "Supplier's company name",
  SUPPLIER_COUNTRY_HEADER: "Country",
  SUPPLIER_CRN_HEADER: "BRN/CRN",
  SUPPLIER_CRN_LABEL: "Supplier's Business Registration Number (BRN/CRN)",
  SUPPLIER_CRN_PLACEHOLDER: "Supplier's Business Registration Number (BRN/CRN)",
  SUPPLIER_DELETE_HERO: "Do you want to delete this supplier?",
  SUPPLIER_DELETE_INSTRUCTIONS:
    "This supplier will be removed from your supplier",
  SUPPLIER_EMAIL_LABEL: "Supplier's Email Address",
  SUPPLIER_EMAIL_PLACEHOLDER: "Supplier's Email Address",
  SUPPLIER_HEADER: "Supplier",
  SUPPLIER_NAME_LABEL: "Supplier's name",
  SUPPLIER_NAME_PLACEHOLDER: "Supplier's name",
  SUPPLIER_NOTE_LABEL: "Note to supplier",
  SUPPLIER_NOTE_PLACEHOLDER: "Note to Supplier",
  SUPPLIER_PLACEHOLDER: "i.e. 20150712D Income Tax",
  SUPPLIER_REGISTRATION_NUMBER_HEADER: "Registration Number",
  SUPPLIER_SCHEDULED_PAYMENT_HERO:
    "You need to cancel the associated payment before you edit the supplier details.",
  SUPPLIER_SCHEDULED_PAYMENT_INSTRUCTIONS:
    "This supplier is associated with a scheduled payment.",
  SUPPLIER_UEN_HEADER: "UEN",
  SUPPLIER_UEN_LABEL: "Supplier's Unique Entity Number (UEN)",
  SUPPLIER_UEN_PLACEHOLDER: "Supplier's Unique Entity Number (UEN)",
  SUPPORT_MENU_ITEM: "Support",
  SWIFT_CODE_LABEL: "SWIFT Code",
  SWIFT_CODE_PLACEHOLDER: "SWIFT Code",
  SYSTEM_UPGRADES:
    "Our system is currently undergoing an upgrade, payments will be available soon. Thank you for your understanding",
  SYSTEM_UPGRADES_AU:
    "Our system is currently undergoing an upgrade and is temporarily unavailable. We apologise for the inconvenience.",
  TABLE_ACTION: "Action",
  TABLE_AMOUNT: "Amount",
  TABLE_CARD: "Card",
  TABLE_CHARGE_DATE: "Charge Date",
  TABLE_CUSTOMER: "Customer",
  TABLE_DATE_REQUEST: "Date Requested",
  TABLE_DUE_DATE: "Due Date",
  TABLE_EMAIL: "Email",
  TABLE_ESTIMATED_FEE: "Estimated Fee",
  TABLE_ESTIMATED_NET_AMOUNT: "Estimated Net Amount",
  TABLE_FREQUENCY: "Frequency",
  TABLE_INVOICE_NO: "Invoice No.",
  TABLE_INVOICE_NUMBER: "Invoice Number",
  TABLE_NOTE: "Note to Recipient",
  TABLE_ORDER_NUMBER: "Order Number",
  TABLE_PAYMENT_CANCELLED: "Payment cancelled",
  TABLE_PAYMENT_DECLINED: "Payment declined",
  TABLE_PAYOUT_DATE: "Payout Date",
  TABLE_RECEIPT_NUMBER: "Receipt Number",
  TABLE_TYPE: "Type",
  TAX_BUTTON: "Tax",
  TAX_REFERENCE_LABEL: "Tax Reference Number",
  TAX_TYPE_LABEL: "and Tax Type",
  TEMPLATE_CARD_EXPIRED_REMINDER:
    "Important information about your upcoming scheduled payment",
  TEMPLATE_CARD_EXPIRING_REMINDER: "Your card is expiring soon",
  TEMPLATE_SCHEDULED_PAYMENT_1_MONTH_REMINDER_SUBJECT:
    "Your scheduled %s payment is ending soon",
  TEMPLATE_SCHEDULED_PAYMENT_2_WEEKS_REMINDER_SUBJECT:
    "Reminder - extend your %s payment today",
  TENANCY_AGREEMENT:
    "\u003cspan\u003eTenancy Agreement\u003c/span\u003e must include",
  TENANCY_BANK_ACCOUNT: "Bank Account",
  TENANCY_CONFIRM:
    "I confirm I am paying rent directly to my landlord as per my tenancy agreement.",
  TENANCY_LANDLORD_NAME: "Landlord Name",
  TENANCY_RENTAL_AMOUNT: "Rental Amount",
  TERMS_LABEL: "Terms",
  TEST_PARAMS: "Test without param",
  TOO_MANY_EMAIL_VERIFICATION_REQUESTS: "Too many email verification requests",
  TOO_MANY_LOGIN_ATTEMPTS:
    "You have reached the maximum number of login attempts. Please change your password and try again.",
  TOO_MANY_LOGIN_ATTEMPTS_2:
    "You have reached the maximum amount of login attempts. Please contact {contact_link} for assistance.",
  TOO_MANY_MOBILE_PHONE_VERIFICATION_ERROR:
    "Too many unsuccessful login attempts, please",
  TOP_ACCOUNT_ADD: "Add Account",
  TOP_ACCOUNT_CHANGE_PASSWORD: "Change Password",
  TOP_ACCOUNT_MENU_BUSINESS: "ipaymy Business Account",
  TOP_ACCOUNT_MENU_MY_ACCOUNT: "My Account",
  TOP_ACCOUNT_MENU_PERSONAL: "ipaymy Personal Account",
  TOP_ACCOUNT_SIGN_OUT: "Sign Out",
  TOP_COMPANIES_MENU_ADD_BUTTON: "Add New Company",
  TOP_COMPANIES_MENU_HEADER: "My Companies",
  TOP_COMPANIES_MENU_REGISTRATION_LABEL: "Reg No.",
  TOP_REFER_BUTTON:
    "\u003ctspan1\u003eRefer\u003c/tspan1\u003e\u003ctspan2\u003e and\u003c/tspan2\u003e\u003ctspan3\u003eGet\u003c/tspan3\u003e",
  TOP_TRY_IPAYMY_BUSINESS: "Try ipaymy for Business",
  TOP_TRY_IPAYMY_PERSONAL: "Try ipaymy for Personal",
  TRY_AGAIN_BUTTON: "Try Again",
  TRY_IPAYMY_PERSONAL_CTA: "Try ipaymy",
  UEN_COLUMN: "UEN",
  UEN_PLACEHOLDER: "Unique entity number (UEN)",
  UNAUTHORIZED_CARD:
    "The card could not be authorized. Please try again or use a different card.",
  UNAVAILABLE_EMAIL_USED:
    "Please enter the email address you used to register your ipaymy account.",
  UNIONPAY_COMMON_FEE_LABEL: "China UnionPay",
  UNIONPAY_HKD_FEE_LABEL: "China UnionPay (HKD)",
  UNIONPAY_LABEL: "China UnionPay",
  UNIONPAY_USD_FEE_LABEL: "China UnionPay (USD)",
  UNIT_NUMBER_LABEL: "Unit Number",
  UNIT_NUMBER_PLACEHOLDER: "Unit Number",
  UNSUPPORTED_CARD:
    "This card is not supported on ipaymy. You may contact us for more information.",
  UNSUPPORTED_PAYEE_INSURER_FOR_UEN_FLOW_ERROR:
    "Payments to insurers are not supported via the Pay to UEN option.",
  UPDATE_BUTTON: "Update",
  UPDATE_COMPANY_ERROR: "Failed to update company",
  UPDATE_PASSWORD_BUTTON: "Update Password",
  UPLOAD_CSV_HERO: "Upload CSV File",
  UPLOAD_CSV_INSTRUCTIONS:
    "Please ensure the recipient’s Bank and Account Number provided for the payment is accurate. These are the primary details that will be used to process the payment. If uploading via the provided CSV template please confirm all account numbers have been correctly captured - in particular any accounts leading with a zero (0).",
  UPLOAD_DOCUMENT_APPLIES_ALL_SELECTION: "All",
  UPLOAD_DOCUMENT_APPLIES_LABEL: "Applies to",
  UPLOAD_DOCUMENT_COLLECTED_ACCOUNT: "Add a KYC Document",
  UPLOAD_FILE_LABEL: "Upload file...",
  UPLOAD_ID_HERO_AU: "Upload Photos of Your ID",
  UPLOAD_ID_HERO_MY: "Upload Photos of Your NRIC",
  UPLOAD_ID_INSTRUCTIONS_AU:
    "For compliance and anti-money laundering purposes, and for the protection of your account, we are required to verify your personal identity documents before proceeding with your first payment. Valid IDs are a current passport, driver license, or other government-issued ID.",
  UPLOAD_ID_INSTRUCTIONS_MY:
    "For compliance and anti-money laundering purposes, and for the protection of your account, we are required to verify your personal identity documents before proceeding with your first payment.",
  UPLOAD_ID_LIST_1_AU: "Please upload the following:",
  UPLOAD_ID_LIST_1_MY: "Please upload the following:",
  UPLOAD_ID_LIST_2_AU:
    "1. A clear and in focus photo of the front and back of your valid ID",
  UPLOAD_ID_LIST_2_MY:
    "1. A clear and in focus photo of the front and back of your valid NRIC",
  UPLOAD_ID_LIST_3_AU:
    "2. A clear and in focus photo of you holding your ID. The details on the ID and your face must be clearly visible.",
  UPLOAD_ID_LIST_3_MY:
    "2. A clear and in focus photo of you holding your NRIC. The details on the NRIC and your face must be clearly visible.",
  UPLOAD_ID_LIST_4_AU:
    "For account approval, your ID details will need to match the details of the card added.",
  UPLOAD_ID_LIST_4_MY:
    "For account approval, your NRIC details will need to match the details of the card added.",
  UPLOAD_ID_PHOTO_BACK_AU: "Back ID Photo",
  UPLOAD_ID_PHOTO_BACK_MY: "Back NRIC Photo",
  UPLOAD_ID_PHOTO_FRONT_AU: "Front ID Photo",
  UPLOAD_ID_PHOTO_FRONT_MY: "Front NRIC Photo",
  UPLOAD_ID_PHOTO_HOLDING_AU: "Photo of you holding your ID",
  UPLOAD_ID_PHOTO_HOLDING_MY: "Photo of you holding your NRIC",
  UPLOAD_INVOICE_BUTTON: "Upload Invoice",
  UPLOAD_INVOICE_LABEL: "Upload invoice to send to customer (Optional)",
  UPLOAD_INVOICE_MENU_ITEM: "Upload Invoice",
  UPLOAD_ORDER_INVOICE_BUTTON: "Upload Order Invoice",
  UPLOAD_ORDER_MENU_ITEM: "Upload Order Invoice",
  USD_SALARY_ACCEPT_BUTTON: "Accept",
  USD_SALARY_CHANGE_BUTTON: "Change to HKD",
  USD_SALARY_INSTRUCTIONS:
    "For settlements made in USD, you may be subject to inward remittance fees by your bank.{br}This amount varies per bank.",
  USER_NOT_ENOUGH_ACCESS_TO_SAML:
    "Your account can't access to SSO login, please try normal login!",
  VERIFICATION_LINK_EXPIRED: "The verification link has expired",
  VERIFY_EMAIL_BUTTON: "Verify Email Address",
  VERIFY_EMAIL_BUTTON_INSTRUCTIONS:
    "If the above button does not work, please click on the link below or copy and paste the link to a browser",
  VERIFY_EMAIL_EXPIRY:
    "This verification email is valid for {{.ExpirationHours}} hours only.",
  VERIFY_EMAIL_HERO: "Verify Email Address",
  VERIFY_EMAIL_INSTRUCTIONS:
    "Hello, {{.FirstName}}! Thanks for signing up! Please click on the button below to verify your email address.",
  VERIFY_EMAIL_QUESTIONS:
    "Should you have any queries about this transaction please contact us at",
  VERIFY_EMAIL_SUBJECT: "Welcome! Complete your ipaymy registration",
  VIEW_DETAILS_BUTTON: "View Details",
  VIEW_DETAILS_TOOLTIP: "View Details",
  VIOLATE_COUPON_SCHEDULED_END_DATE:
    "Please schedule your payment with a scheduled end date no later than %s.",
  VIOLATE_COUPON_START_DATE:
    "Please schedule your payment with a charge date no later than %s.",
  VISA_LABEL: "Visa and",
  VISA_MASTERCARD_FEE_LABEL: "Visa and Mastercard",
  WALLET_DESCRIPTION: "View, manage your existing cards or add a new one.",
  WALLET_HERO: "MY WALLET",
  WALLET_MENU_ITEM: "My Wallet",
  WALLET_NEW_CARD_BUTTON: "Add New Card",
  WALLEX_QUOTE_INVALID_FIELD: "This field contains invalid data.",
  WP_3DS_DECLINED_ERROR:
    "Payments made on this card are not supported on ipaymy. Please try again or use a different card.",
  WP_CSE_ERROR_101: "A card number is mandatory",
  WP_CSE_ERROR_102:
    "Card number should contain between 12 and 20 numeric characters",
  WP_CSE_ERROR_103: "The card number entered is invalid",
  WP_CSE_ERROR_201: "The security code is invalid",
  WP_CSE_ERROR_301: "The expiry month is not included",
  WP_CSE_ERROR_302: "Expiry month must contain exactly 2 numbers",
  WP_CSE_ERROR_303: "Expiry month should be between 01 and 12",
  WP_CSE_ERROR_304: "The expiry year is not included",
  WP_CSE_ERROR_305: "Expiry year must contain exactly 4 number",
  WP_CSE_ERROR_306:
    "Expiry month and expiry year together must be a date in the future",
  WP_CSE_ERROR_401: "Card holder name is mandatory",
  WP_CSE_ERROR_402: "Card holder name cannot exceed thirty (30) characters",
  WP_DO_NOT_HONOR:
    "Please check your card details or use another card. For more information, contact your card issuer.",
  WP_ERROR_3DS_FAILED:
    "The transaction cannot be authorized. Please try a different card or contact your issuer for more information.",
  WP_ERROR_3DS_NOT_SUPPORT:
    "Payments made on this card are not supported on ipaymy. You may contact us for more information.",
  WP_ERROR_DO_NOT_HONOR:
    "There is a problem with successfully processing your card. Please contact your issuer for more information.",
  WP_INTERNAL_TECHNICAL_ERROR:
    "There appears to be a technical issue with your payment request. Please contact us through support@ipaymy.com.",
  WP_REFUSED_ERROR_0:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_1:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_10:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_1044:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_1045:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_1046:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_1047:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_1048:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_1049:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_1050:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_1051:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_1198:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_12: "Please contact your card issuer for more details.",
  WP_REFUSED_ERROR_1201:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_1263:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_1295:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_13:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_14:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_15:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_19:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_2:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_20:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_25:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_28:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_3:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_30:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_34:
    "There is a problem with successfully processing your card. Please contact your issuer for more information.",
  WP_REFUSED_ERROR_39:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_397:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_398:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_4:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_41:
    "There appears to be a technical issue with your payment request. Please try a different card or contact your issuer for more information.",
  WP_REFUSED_ERROR_43:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_442:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_443:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_444:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_445:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_446:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_447:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_448:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_449:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_450:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_451:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_452:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_453:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_454:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_455:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_456:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_457:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_458:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_459:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_460:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_5:
    "The transaction was declined by your issuer. Please try a different card or contact your issuer for more information.",
  WP_REFUSED_ERROR_51:
    "Transaction failed due to insufficient funds. Please try an alternative card.",
  WP_REFUSED_ERROR_52:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_53:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_54: "The card’s expiration is incorrect.",
  WP_REFUSED_ERROR_55:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_57:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_577:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_578:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_579:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_58:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_580:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_581:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_582:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_583:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_584:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_586:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_587:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_588:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_589:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_59:
    "There is a problem with successfully processing your card. Please contact your issuer for more information.",
  WP_REFUSED_ERROR_590:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_591:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_592:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_593:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_594:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_595:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_596:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_597:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_598:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_599:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_6:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_600:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_601:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_602:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_603:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_604:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_605:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_606:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_607:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_608:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_609:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_61:
    "This transaction failed due to exceeding withdrawal limit. Please try another card.",
  WP_REFUSED_ERROR_610:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_611:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_62:
    "The transaction was declined. Please contact your issuer for more information.",
  WP_REFUSED_ERROR_622:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_623:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_624:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_625:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_626:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_627:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_628:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_629:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_63:
    "The transaction cannot be authorized. Please try again or use a different card. If unsuccessful, please contact your issuer.",
  WP_REFUSED_ERROR_630:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_631:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_632:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_633:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_634:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_635:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_636:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_637:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_638:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_639:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_64:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_640:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_641:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_642:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_643:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_644:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_645:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_646:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_647:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_65:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_658:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_659:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_660:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_661:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_662:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_663:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_664:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_665:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_666:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_667:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_668:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_669:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_670:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_671:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_672:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_673:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_674:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_675:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_676:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_677:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_678:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_679:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_68:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_680:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_681:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_682:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_683:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_694:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_695:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_696:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_697:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_698:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_699:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_7:
    "There appears to be a technical issue with your payment request. Please try a different card or contact your issuer for more information.",
  WP_REFUSED_ERROR_70:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_700:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_701:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_702:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_703:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_704:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_705:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_71:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_75:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_76:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_77:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_78:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_79:
    "There is a problem with successfully processing your card. Please contact your issuer for more information.",
  WP_REFUSED_ERROR_8:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_80:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_82:
    "The card’s CVC/CVV is incorrect. Please contact your issuer for more information.",
  WP_REFUSED_ERROR_828:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_83:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_831:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_832:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_833:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_835:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_836:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_84:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_85:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_86:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_88:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_89:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_902:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_905:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_906:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_91:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_92:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_93:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_937:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_94:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_96:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_972:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_973:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_975:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_98:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_REFUSED_ERROR_99:
    "There appears to be a technical issue with your payment request. Please try again or contact us at support@ipaymy.com.",
  WP_TOKENISATION_ERROR:
    "Your card has been declined by the issuing bank, please make sure your card information is valid.",
  WRONG_MOBILE_PASS_CODE_ERROR:
    "You have entered an invalid code, please try again or {RESEND_PIN}.",
  XERO_ACCESS_INSTRUCTIONS:
    "Need access to your Xero-connected ipaymy account? \u003cstyling1\u003eSign in here.\u003c/styling1\u003e",
  YES_CHECKBOX: "Yes",
  YOUR_BRANDING_COLOR: "Your Branding Color",
  YOUR_COMPANY_LOGO: "Your Company Logo",
  YOU_PAY_LABEL: "You Pay"
};
export default t;
